// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================================
   Seuytel / MainEvents — shared legal + cookie-consent styles
   Brand palette taken from the logo:
     purple  #6C3DD3   blue #5B8FE8   gradient 135deg blue -> purple
   All classes are prefixed \`se-\` to avoid clashing with the seat-map app.
   ========================================================================== */

:root {
  --se-purple: #6c3dd3;
  --se-blue: #5b8fe8;
  --se-grad: linear-gradient(135deg, #5b8fe8 0%, #6c3dd3 100%);
  --se-grad-soft: linear-gradient(135deg, #eef3fd 0%, #f3eefb 100%);
  --se-ink: #1f2430;
  --se-muted: #5b6472;
  --se-surface: #f6f7fb;
  --se-border: #e6e8f0;
  --se-white: #ffffff;
  --se-radius: 16px;
  --se-radius-sm: 10px;
  --se-shadow: 0 10px 30px rgba(31, 36, 48, 0.12);
  --se-shadow-sm: 0 4px 14px rgba(31, 36, 48, 0.08);
  --se-font: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica,
    Arial, sans-serif;
}

/* ---------------------------------------------------------------- page shell */
.se-page {
  font-family: var(--se-font);
  color: var(--se-ink);
  background: var(--se-white);
  min-height: 100vh;
  line-height: 1.7;
  -webkit-font-smoothing: antialiased;
}

.se-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 24px;
  border-bottom: 1px solid var(--se-border);
  position: sticky;
  top: 0;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(8px);
  z-index: 10;
}

.se-topbar img {
  height: 30px;
  width: auto;
  display: block;
}

.se-topbar-links {
  display: flex;
  gap: 18px;
  flex-wrap: nowrap;
}

.se-topbar-links a {
  color: var(--se-muted);
  text-decoration: none;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
}

.se-topbar-links a:hover,
.se-topbar-links a.se-active {
  color: var(--se-purple);
}

/* --------------------------------------------------------------------- hero */
.se-hero {
  background: var(--se-grad-soft);
  border-bottom: 1px solid var(--se-border);
}

.se-hero-inner {
  max-width: 880px;
  margin: 0 auto;
  padding: 48px 24px;
  display: flex;
  align-items: center;
  gap: 32px;
}

.se-hero-text {
  flex: 1 1 auto;
}

.se-eyebrow {
  display: inline-block;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: var(--se-purple);
  background: var(--se-white);
  border: 1px solid var(--se-border);
  border-radius: 999px;
  padding: 5px 12px;
  margin-bottom: 14px;
}

.se-hero h1 {
  margin: 0 0 10px;
  font-size: 34px;
  line-height: 1.15;
  letter-spacing: -0.5px;
}

.se-hero p {
  margin: 0;
  color: var(--se-muted);
  font-size: 16px;
  max-width: 46ch;
}

.se-hero-art {
  flex: 0 0 auto;
  width: 180px;
  height: 180px;
}

.se-hero-art svg {
  width: 100%;
  height: 100%;
}

/* ------------------------------------------------------------------ content */
.se-content {
  max-width: 880px;
  margin: 0 auto;
  padding: 40px 24px 72px;
}

.se-content h2 {
  font-size: 22px;
  margin: 36px 0 12px;
  letter-spacing: -0.3px;
}

.se-content h2:first-child {
  margin-top: 0;
}

.se-content h3 {
  font-size: 17px;
  margin: 22px 0 8px;
}

.se-content p,
.se-content li {
  color: #313846;
  font-size: 15.5px;
}

.se-content a {
  color: var(--se-purple);
  font-weight: 600;
}

.se-section-head {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 40px 0 14px;
}

.se-section-head .se-mini-art {
  flex: 0 0 auto;
  width: 44px;
  height: 44px;
}

.se-section-head h2 {
  margin: 0;
}

.se-card {
  background: var(--se-surface);
  border: 1px solid var(--se-border);
  border-radius: var(--se-radius);
  padding: 20px 22px;
  margin: 16px 0;
}

.se-callout {
  border-left: 4px solid var(--se-blue);
  background: var(--se-grad-soft);
  border-radius: var(--se-radius-sm);
  padding: 14px 18px;
  margin: 18px 0;
  font-size: 14.5px;
}

.se-placeholder {
  color: var(--se-purple);
  font-weight: 700;
}

/* ---------------------------------------------------------------- data table */
.se-table-wrap {
  overflow-x: auto;
  border: 1px solid var(--se-border);
  border-radius: var(--se-radius);
  margin: 18px 0;
}

.se-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  min-width: 560px;
}

.se-table th,
.se-table td {
  text-align: left;
  padding: 12px 16px;
  border-bottom: 1px solid var(--se-border);
  vertical-align: top;
}

.se-table thead th {
  background: var(--se-grad);
  color: #fff;
  font-weight: 700;
  border-bottom: none;
}

.se-table tbody tr:last-child td {
  border-bottom: none;
}

.se-table tbody tr:nth-child(even) td {
  background: rgba(91, 143, 232, 0.05);
}

/* --------------------------------------------------------------------- foot */
.se-foot {
  border-top: 1px solid var(--se-border);
  padding: 28px 24px;
  text-align: center;
  color: var(--se-muted);
  font-size: 13.5px;
}

.se-foot a {
  color: var(--se-muted);
  text-decoration: none;
  font-weight: 600;
  margin: 0 8px;
}

.se-foot a:hover {
  color: var(--se-purple);
}

.se-link-btn {
  background: none;
  border: none;
  color: var(--se-muted);
  font: inherit;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
  margin: 0 8px;
}

.se-link-btn:hover {
  color: var(--se-purple);
}

/* ===================================================== forms (report/delete) */
.se-form-card {
  display: flex;
  flex-direction: column;
  gap: 18px;
  max-width: 560px;
  padding: 24px;
  border: 1px solid var(--se-border);
  border-radius: var(--se-radius);
  background: var(--se-white);
  box-shadow: var(--se-shadow-sm);
}

.se-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.se-label {
  font-size: 14px;
  font-weight: 700;
  color: var(--se-ink);
}

.se-input {
  width: 100%;
  box-sizing: border-box;
  padding: 11px 13px;
  border: 1px solid var(--se-border);
  border-radius: var(--se-radius-sm);
  background: var(--se-white);
  font: inherit;
  font-size: 15px;
  color: var(--se-ink);
  outline: none;
}

.se-input:focus {
  border-color: var(--se-purple);
  box-shadow: 0 0 0 3px rgba(108, 61, 211, 0.12);
}

.se-textarea {
  resize: vertical;
  min-height: 110px;
}

.se-help {
  font-size: 12px;
  color: var(--se-muted);
}

.se-radio-row {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.se-radio {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 9px 14px;
  border: 1px solid var(--se-border);
  border-radius: 999px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.se-radio.se-active {
  border-color: var(--se-purple);
  color: var(--se-purple);
  background: var(--se-grad-soft);
}

.se-check {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 14px;
  color: var(--se-ink);
  cursor: pointer;
}

.se-check input {
  margin-top: 3px;
}

.se-btn-primary,
.se-btn-danger {
  align-self: flex-start;
  border: none;
  border-radius: 999px;
  padding: 12px 22px;
  font: inherit;
  font-size: 15px;
  font-weight: 700;
  color: #fff;
  cursor: pointer;
}

.se-btn-primary {
  background: var(--se-grad);
}

.se-btn-danger {
  background: linear-gradient(135deg, #f0616b 0%, #d23d5b 100%);
}

.se-btn-primary:disabled,
.se-btn-danger:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

/* alerts / callouts */
.se-alert {
  border-radius: var(--se-radius-sm);
  padding: 14px 16px;
  font-size: 14px;
  border: 1px solid var(--se-border);
  margin-bottom: 18px;
}

.se-alert-info {
  background: var(--se-grad-soft);
  border-color: #d9def0;
  color: var(--se-ink);
}

.se-alert-success {
  background: #eafaf1;
  border-color: #b8ecd0;
  color: #1c6b46;
}

.se-alert-warn {
  background: #fff7e6;
  border-color: #ffe1a8;
  color: #8a5b00;
}

.se-alert-error {
  background: #fdecee;
  border-color: #f6c2c8;
  color: #a4283a;
  margin-bottom: 0;
}

/* Two-up explanatory cards (Help Center: private/public events, melden/löschen) */
.se-hc-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 16px;
  margin: 16px 0 8px;
}

.se-hc-cards .se-card {
  margin: 0;
}

.se-hc-cards .se-card h3 {
  margin: 0 0 8px;
}

.se-hc-cards .se-card p:last-child {
  margin-bottom: 0;
}

/* ===================================================== layout container */
/* Centered, width-capped column so the header/footer don't stretch edge-to-edge
   on large screens and stay aligned with the page content. */
.se-container {
  width: 100%;
  max-width: 1180px;
  margin: 0 auto;
  padding: 0 24px;
  box-sizing: border-box;
}

/* ===================================================== site header / drawer */
/* The bar spans full width; its contents live in the centered container. */
.se-topbar {
  padding: 12px 0;
  transform: translateY(0);
  transition: transform 0.24s ease, box-shadow 0.24s ease, background 0.24s ease;
  box-shadow: 0 10px 28px rgba(31, 36, 48, 0.06);
}

.se-topbar-hidden {
  transform: translateY(-110%);
}

/* Two tiers: (1) language indicator, (2) brand · search · nav · login. */
.se-topbar-inner {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.se-topbar-row {
  display: flex;
  align-items: center;
  gap: 16px;
}

/* Top tier: language indicator, on its own line, pinned far right. */
.se-topbar-row-top {
  justify-content: flex-end;
}

/* Bottom tier: brand sits far left; everything else clusters on the right. */
.se-topbar-right {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: auto;
  min-width: 0;
}

/* ---- language / country selector ---- */
.se-locale {
  position: relative;
}

.se-locale-btn {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  background: var(--se-surface);
  border: 1px solid var(--se-border);
  border-radius: 999px;
  padding: 6px 12px;
  font-size: 13px;
  font-weight: 700;
  color: var(--se-ink);
  cursor: pointer;
}

.se-locale-btn:hover {
  border-color: var(--se-purple);
}

.se-locale-flag {
  font-size: 18px;
  line-height: 1;
}

.se-locale-country {
  color: var(--se-muted);
  font-weight: 600;
}

.se-locale-caret {
  color: var(--se-muted);
  font-size: 11px;
}

.se-locale-menu {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  min-width: 200px;
  margin: 0;
  padding: 6px;
  list-style: none;
  background: var(--se-white);
  border: 1px solid var(--se-border);
  border-radius: var(--se-radius-sm);
  box-shadow: var(--se-shadow);
  z-index: 40;
}

.se-locale-opt {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 9px 10px;
  border: none;
  border-radius: 8px;
  background: none;
  font-size: 14px;
  color: var(--se-ink);
  cursor: pointer;
  text-align: left;
}

.se-locale-opt:hover,
.se-locale-opt.se-active {
  background: var(--se-grad-soft);
  color: var(--se-purple);
}

.se-locale-opt-lang {
  font-weight: 800;
  min-width: 26px;
}

.se-locale-opt-country {
  color: var(--se-muted);
}

.se-locale-opt.se-active .se-locale-opt-country {
  color: var(--se-purple);
}

/* ---- website + event-location search ---- */
.se-search {
  position: relative;
  flex: 0 1 280px;
  min-width: 0;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 0.78fr) 42px;
  align-items: center;
  gap: 0;
  padding: 0 4px;
  border: 1px solid var(--se-border);
  border-radius: 999px;
  background: var(--se-surface);
  transition: border-color 0.16s ease, background 0.16s ease, box-shadow 0.16s ease;
}

.se-search:focus-within {
  border-color: var(--se-purple);
  background: var(--se-white);
  box-shadow: 0 0 0 3px rgba(108, 61, 211, 0.12);
}

.se-search-field {
  position: relative;
  min-width: 0;
}

.se-search-field-location {
  border-left: 1px solid var(--se-border);
}

.se-search-glyph {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--se-muted);
  display: inline-flex;
  pointer-events: none;
}

.se-search-input {
  min-width: 0;
  width: 100%;
  box-sizing: border-box;
  padding: 9px 12px 9px 36px;
  border: 0;
  border-radius: 0;
  background: transparent;
  font-size: 14px;
  color: var(--se-ink);
  outline: none;
}

.se-location-input {
  padding-left: 36px;
}

.se-location-glyph {
  position: absolute;
  left: 13px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--se-muted);
  display: inline-flex;
  pointer-events: none;
}

.se-search .se-search-filter-btn {
  position: relative;
  justify-self: center;
  width: 36px;
  height: 36px;
  margin-left: 0;
  border: 0;
  border-radius: 14px;
  background: transparent;
  color: #5b8fe8;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.se-search .se-search-filter-btn:hover,
.se-search .se-search-filter-btn.se-active {
  background: #5b8fe8;
  color: #fff;
}

.se-search-filter-badge {
  position: absolute;
  top: -4px;
  right: -4px;
  min-width: 17px;
  height: 17px;
  padding: 0 4px;
  border-radius: 999px;
  background: #ef4444;
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 900;
  line-height: 1;
  box-shadow: 0 0 0 2px #fff;
}

.se-search-input:focus {
  background: transparent;
  box-shadow: none;
}

.se-search-list {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  right: 0;
  margin: 0;
  padding: 6px;
  list-style: none;
  background: var(--se-white);
  border: 1px solid var(--se-border);
  border-radius: var(--se-radius-sm);
  box-shadow: var(--se-shadow);
  z-index: 40;
  max-height: 60vh;
  overflow: auto;
}

.se-search-opt {
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 100%;
  padding: 9px 10px;
  border: none;
  border-radius: 8px;
  background: none;
  cursor: pointer;
  text-align: left;
}

.se-search-opt:hover,
.se-search-opt.se-active {
  background: var(--se-grad-soft);
}

.se-search-opt-title {
  font-size: 14px;
  font-weight: 700;
  color: var(--se-ink);
}

.se-search-opt:hover .se-search-opt-title,
.se-search-opt.se-active .se-search-opt-title {
  color: var(--se-purple);
}

.se-search-opt-hint {
  font-size: 12px;
  color: var(--se-muted);
}

.se-search-empty {
  padding: 10px 11px;
  color: var(--se-muted);
  font-size: 13px;
}

/* ---- person / login icon ---- */
.se-person {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  border: 1px solid var(--se-border);
  color: var(--se-muted);
  background: var(--se-surface);
  text-decoration: none;
}

.se-person:hover {
  color: var(--se-purple);
  border-color: var(--se-purple);
}

.se-person-in {
  color: #fff;
  background: var(--se-grad);
  border-color: transparent;
}

.se-person-in:hover {
  color: #fff;
}

.se-drawer-search {
  padding: 10px 12px 4px;
}

.se-brand {
  display: inline-flex;
  align-items: center;
  flex: 0 0 auto;
  text-decoration: none;
}

.se-topbar .se-brand-logo {
  height: 30px;
  width: auto;
  display: block;
}

/* Inline tabs sit directly to the right of the search field and never shrink
   or wrap (so "Hilfe-Center" stays on one line). */
.se-nav-desktop {
  margin-left: 0;
  flex: 0 0 auto;
  align-items: center;
  gap: 12px;
}

.se-category-menu {
  position: relative;
  display: inline-flex;
}

.se-category-trigger {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 0;
  background: transparent;
  color: var(--se-muted);
  font: inherit;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  padding: 7px 0;
  white-space: nowrap;
}

.se-category-trigger:hover,
.se-category-trigger.se-active {
  color: var(--se-purple);
}

.se-category-panel {
  position: absolute;
  top: calc(100% + 14px);
  left: 50%;
  transform: translateX(-50%);
  width: min(720px, calc(100vw - 48px));
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
  padding: 18px;
  background: rgba(255, 255, 255, 0.98);
  border: 1px solid var(--se-border);
  border-radius: 14px;
  box-shadow: var(--se-shadow);
  z-index: 60;
}

.se-category-group h3 {
  margin: 0 0 10px;
  color: var(--se-ink);
  font-size: 13px;
  font-weight: 850;
}

.se-category-grid {
  display: grid;
  gap: 6px;
}

.se-category-grid a {
  display: block;
  margin: 0;
  padding: 8px 10px;
  border-radius: 8px;
  color: var(--se-muted);
  font-size: 13px;
  font-weight: 700;
}

.se-category-grid a:hover {
  color: var(--se-purple);
  background: var(--se-grad-soft);
}

.se-header-cta {
  padding: 9px 14px;
  box-shadow: 0 6px 18px rgba(91, 143, 232, 0.22);
}

.se-header-cta .se-me-cta-icon {
  width: 20px;
  height: 20px;
}

/* Language badge shown inline next to the burger — small screens only. */
.se-locale-mobile {
  display: none;
  flex: 0 0 auto;
}

/* Toggle button — hidden on wide screens, shown on small ones. */
.se-burger {
  display: none;
  flex: 0 0 auto;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  width: 44px;
  height: 44px;
  padding: 11px;
  background: none;
  border: 1px solid var(--se-border);
  border-radius: 12px;
  cursor: pointer;
}

.se-burger span {
  display: block;
  height: 2px;
  width: 100%;
  background: var(--se-ink);
  border-radius: 2px;
  transition: transform 0.25s ease, opacity 0.2s ease;
}

/* Morph the hamburger into an X while the drawer is open. */
.se-burger.se-open span:nth-child(1) {
  transform: translateY(7px) rotate(45deg);
}
.se-burger.se-open span:nth-child(2) {
  opacity: 0;
}
.se-burger.se-open span:nth-child(3) {
  transform: translateY(-7px) rotate(-45deg);
}

/* Scrim fills the viewport and CLIPS the drawer (overflow:hidden + an
   absolutely-positioned child), so the off-screen drawer never creates a
   horizontal scrollbar. High z-index keeps it above all page content. */
.se-drawer-scrim {
  position: fixed;
  inset: 0;
  overflow: hidden;
  background: rgba(15, 18, 26, 0.55);
  backdrop-filter: blur(2px);
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.25s ease, visibility 0.25s ease;
  z-index: 1000;
}

.se-drawer-scrim.se-open {
  opacity: 1;
  visibility: visible;
}

.se-drawer {
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: min(82vw, 320px);
  background: var(--se-white);
  box-shadow: -10px 0 30px rgba(31, 36, 48, 0.22);
  transform: translateX(100%);
  transition: transform 0.28s cubic-bezier(0.22, 0.61, 0.36, 1);
  display: flex;
  flex-direction: column;
}

.se-drawer.se-open {
  transform: translateX(0);
}

.se-drawer-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-bottom: 1px solid var(--se-border);
}

.se-drawer-head .se-brand-logo {
  height: 20px;
  width: auto;
}

.se-drawer-close {
  background: none;
  border: none;
  font-size: 20px;
  line-height: 1;
  color: var(--se-muted);
  cursor: pointer;
  padding: 6px 8px;
}

.se-drawer-links {
  display: flex;
  flex-direction: column;
  padding: 8px 6px;
  overflow-y: auto;
}

.se-drawer-links a {
  display: block;
  padding: 14px 16px;
  border-radius: 12px;
  color: var(--se-ink);
  text-decoration: none;
  font-size: 16px;
  font-weight: 600;
}

.se-drawer-links a:hover,
.se-drawer-links a.se-active {
  background: var(--se-grad-soft);
  color: var(--se-purple);
}

.se-drawer-section-title {
  padding: 16px 16px 6px;
  color: var(--se-muted);
  font-size: 12px;
  font-weight: 850;
  letter-spacing: 0.6px;
  text-transform: uppercase;
}

.se-drawer-cta {
  align-self: stretch;
  justify-content: center;
  margin: 10px 14px 6px;
}

.se-drawer-cat-group {
  display: grid;
  gap: 4px;
  padding: 8px 8px 10px;
}

.se-drawer-cat-group strong {
  padding: 4px 8px;
  color: var(--se-ink);
  font-size: 13px;
}

.se-drawer-cat-group a {
  padding: 9px 12px;
  font-size: 14px;
  color: var(--se-muted);
}

/* footer: centered container with brand, main tabs row, legal strip, copyright */
.se-foot-brand {
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
}

.se-foot-logo {
  display: inline-flex;
  text-decoration: none;
}

.se-foot .se-brand-logo {
  height: 24px;
  width: auto;
  display: block;
}

.se-foot-main {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 16px;
}

.se-foot-main a {
  font-weight: 700;
  color: var(--se-ink);
}

.se-foot-columns {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
  margin: 22px auto;
  text-align: left;
}

.se-foot-column {
  display: grid;
  gap: 8px;
  padding: 16px;
  border: 1px solid var(--se-border);
  border-radius: 12px;
  background: transparent;
}

.se-foot-column h3 {
  margin: 0 0 4px;
  color: var(--se-ink);
  font-size: 14px;
}

.se-foot-column a {
  margin: 0;
  color: var(--se-muted);
  font-size: 13.5px;
}

/* "zu MainEvents" smart entry-point button (footer + anywhere it's reused). */
.se-me-cta {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  padding: 10px 18px;
  border: none;
  border-radius: 999px;
  background: var(--se-grad);
  color: #fff;
  font-weight: 800;
  font-size: 14px;
  cursor: pointer;
  text-decoration: none;
  box-shadow: var(--se-shadow);
}

.se-me-cta:hover {
  filter: brightness(1.05);
}

.se-me-cta-icon {
  height: 22px;
  width: 22px;
  display: block;
}

.se-foot-legal {
  margin-bottom: 10px;
  font-size: 13px;
}

.se-foot-copy {
  color: var(--se-muted);
}

/* Wide screens: show inline tabs, fully hide the drawer/toggle so they can't
   create overflow or intercept clicks. */
@media (min-width: 761px) {
  .se-burger,
  .se-drawer-scrim {
    display: none;
  }
}

@media (max-width: 1080px) {
  .se-search {
    flex-basis: 220px;
  }
  .se-header-cta span {
    display: none;
  }
}

@media (max-width: 760px) {
  .se-nav-desktop {
    display: none;
  }
  .se-burger {
    display: flex;
  }
  /* Single-tier mobile bar: drop the separate language row and move the badge
     inline next to the burger → brand (left) · language + burger (right). */
  .se-topbar-row-top {
    display: none;
  }
  .se-locale-mobile {
    display: block;
  }
  /* The search and account icon live inside the slide-in drawer instead. */
  .se-topbar-right .se-search,
  .se-topbar-right .se-person,
  .se-header-cta {
    display: none;
  }
  .se-container {
    padding-left: 16px;
    padding-right: 16px;
  }
  .se-foot-columns {
    grid-template-columns: 1fr;
    text-align: center;
  }
}

@media (max-width: 480px) {
  /* Save horizontal space in the top row: keep flag + language code only. */
  .se-locale-country {
    display: none;
  }
}

/* ===================================================== refined app website chrome */
.se-topbar {
  padding: 7px 0;
  background: rgba(255, 255, 255, 0.94);
}

.se-topbar-inner {
  gap: 0;
}

.se-topbar-bar {
  min-height: 54px;
}

.se-topbar-row-top,
.se-locale-mobile {
  display: none;
}

.se-topbar .se-brand-logo {
  height: 28px;
}

.se-topbar-links a,
.se-category-trigger {
  font-size: 13.5px;
}

.se-locale-btn {
  gap: 5px;
  min-width: 74px;
  justify-content: center;
  padding: 7px 9px;
  background: #fff;
}

.se-locale-code {
  color: var(--se-ink);
  font-size: 12px;
  font-weight: 850;
  text-transform: uppercase;
}

.se-person {
  width: 48px;
  height: 46px;
  flex-direction: column;
  gap: 1px;
  border-radius: 14px;
}

.se-person svg {
  width: 18px;
  height: 18px;
}

.se-person span {
  max-width: 44px;
  overflow: hidden;
  text-overflow: ellipsis;
  color: inherit;
  font-size: 10px;
  font-weight: 800;
  line-height: 1;
  white-space: nowrap;
}

.se-ticket-quick,
.se-search-toggle {
  display: none;
}

.se-ticket-quick {
  align-items: center;
  justify-content: center;
  height: 40px;
  padding: 0 12px;
  border-radius: 12px;
  background: var(--se-grad-soft);
  color: var(--se-purple);
  font-size: 13px;
  font-weight: 850;
  text-decoration: none;
  white-space: nowrap;
}

.se-search-toggle {
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border: 1px solid var(--se-border);
  border-radius: 12px;
  background: var(--se-surface);
  color: var(--se-muted);
  cursor: pointer;
}

.se-search-toggle:hover,
.se-search-toggle.se-active {
  color: var(--se-purple);
  border-color: var(--se-purple);
  background: #fff;
}

.se-search-dock {
  display: none;
  padding: 0 0 8px;
}

.se-search-dock.se-open {
  display: block;
}

.se-search-dock .se-search {
  width: min(100%, 560px);
  margin-left: auto;
}

.se-search-dock .se-search-list {
  max-height: min(50vh, 320px);
}

.se-foot {
  background: linear-gradient(135deg, #f2f6ff 0%, #f7f3ff 100%);
  border-top: 1px solid #dfe5f4;
  color: #465064;
}

.se-foot-column {
  background: transparent;
  border-color: rgba(108, 61, 211, 0.12);
}

.se-foot-main a,
.se-foot-column h3 {
  color: var(--se-ink);
}

.se-foot a:hover {
  color: var(--se-purple);
}

@media (min-width: 1121px) {
  .se-burger,
  .se-drawer-scrim {
    display: none;
  }
}

@media (max-width: 1120px) {
  .se-burger {
    display: flex;
  }
  .se-drawer-scrim {
    display: block;
  }
  .se-category-menu,
  .se-nav-venues,
  .se-nav-help {
    display: none;
  }
}

@media (max-width: 980px) {
  .se-nav-discover,
  .se-nav-organize,
  .se-nav-tickets {
    display: none;
  }
  .se-ticket-quick {
    display: inline-flex;
    width: auto;
    min-width: auto;
    height: 40px;
    padding: 0 8px;
    color: var(--se-muted);
    font-size: 13px;
    font-weight: 850;
  }
  .se-ticket-quick svg {
    display: none;
  }
  .se-ticket-quick span {
    display: inline;
  }
}

@media (max-width: 900px) {
  .se-topbar-right > .se-search {
    display: none;
  }
  .se-search-toggle {
    display: inline-flex;
  }
}

@media (max-width: 760px) {
  .se-topbar {
    padding: 6px 0;
  }
  .se-topbar-bar {
    min-height: 52px;
  }
  .se-nav-desktop {
    display: none;
  }
  .se-ticket-quick {
    display: inline-flex;
  }
  .se-topbar-right .se-person {
    display: inline-flex;
  }
  .se-locale {
    display: block;
  }
  .se-locale-btn {
    min-width: 62px;
    padding-inline: 7px;
  }
  .se-locale-flag {
    font-size: 16px;
  }
  .se-locale-caret {
    display: none;
  }
  .se-search-dock .se-search {
    width: 100%;
  }
  .se-foot {
    padding-inline: 0;
  }
}

@media (max-width: 520px) {
  .se-topbar-right {
    gap: 7px;
  }
  .se-topbar .se-brand-logo {
    height: 24px;
  }
  .se-ticket-quick {
    padding-inline: 9px;
    font-size: 12px;
  }
  .se-person {
    width: 42px;
    height: 42px;
  }
  .se-person span {
    display: none;
  }
}

@media (max-width: 390px) {
  .se-locale {
    display: none;
  }
}

/* Header action refinement: text-first navigation, icon actions without button chrome. */
.se-topbar button,
.se-topbar .se-person,
.se-topbar .se-ticket-quick {
  border: 0;
  background: transparent;
  box-shadow: none;
}

.se-topbar button:hover,
.se-topbar button.se-active,
.se-topbar .se-person:hover,
.se-topbar .se-ticket-quick:hover {
  border: 0;
  background: transparent;
  box-shadow: none;
}

.se-topbar-right {
  flex: 1 1 auto;
}

.se-topbar-right > .se-search {
  flex: 1 1 250px;
  max-width: 320px;
}

.se-nav-desktop {
  justify-content: center;
}

.se-locale-btn {
  min-width: 58px;
  padding: 6px 4px;
}

.se-locale-menu {
  right: 0;
}

.se-person {
  width: 48px;
  height: 44px;
  padding: 0;
  gap: 2px;
  color: var(--se-muted);
  background: transparent;
}

.se-person-in {
  color: var(--se-purple);
  background: transparent;
}

.se-person-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 20px;
}

.se-person-label {
  display: block;
  max-width: 54px;
  color: inherit;
  font-size: 10px;
  font-weight: 850;
  line-height: 1;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.se-ticket-quick {
  width: 44px;
  height: 44px;
  padding: 0;
  color: var(--se-muted);
}

.se-ticket-quick span {
  display: none;
}

.se-ticket-quick:hover {
  color: var(--se-purple);
}

.se-search-toggle {
  border: 0;
  background: transparent;
}

.se-search-toggle:hover,
.se-search-toggle.se-active {
  border: 0;
  background: transparent;
}

.se-burger {
  border: 0;
  background: transparent;
}

@media (max-width: 1180px) {
  .se-topbar-links {
    gap: 10px;
  }
  .se-topbar-right {
    gap: 10px;
  }
  .se-topbar-right > .se-search {
    max-width: 260px;
  }
}

@media (max-width: 900px) {
  .se-topbar-right > .se-search {
    order: 1;
  }
  .se-ticket-quick {
    order: 2;
  }
  .se-search-toggle {
    order: 1;
  }
  .se-topbar-right > .se-locale {
    order: 3;
  }
  .se-person {
    order: 4;
  }
  .se-burger {
    order: 5;
  }
}

@media (max-width: 760px) {
  .se-topbar-right {
    flex: 0 0 auto;
    gap: 9px;
    margin-left: auto;
  }
  .se-search-toggle,
  .se-ticket-quick,
  .se-person {
    width: 40px;
    height: 42px;
  }
  .se-topbar-right > .se-locale {
    display: block;
  }
  .se-ticket-quick {
    padding: 0;
  }
  .se-ticket-quick svg {
    display: block;
  }
  .se-ticket-quick span {
    display: none;
  }
  .se-burger {
    display: flex;
    width: 38px;
    height: 42px;
    padding: 10px 8px;
    order: 99;
  }
  .se-person .se-person-label {
    display: block;
  }
}

@media (max-width: 520px) {
  .se-person .se-person-label {
    display: block;
    max-width: 42px;
    font-size: 9px;
  }
}

/* Final responsive header rules: wide header, stable tickets position, fixed right actions. */
.se-topbar .se-container {
  max-width: 1800px;
}

.se-nav-tickets {
  display: none;
}

.se-ticket-quick {
  display: inline-flex;
  flex: 0 0 auto;
  order: 2;
  width: auto;
  height: 40px;
  padding: 0 4px;
  color: var(--se-muted);
}

.se-ticket-quick svg {
  display: none;
}

.se-ticket-quick span {
  display: inline;
  font-size: 13.5px;
  font-weight: 850;
}

.se-nav-desktop {
  order: 3;
}

.se-topbar-right > .se-locale {
  flex: 0 0 auto;
  order: 7;
}

.se-person {
  flex: 0 0 auto;
  order: 8;
}

.se-burger {
  flex: 0 0 auto;
  order: 9;
}

.se-search-toggle {
  flex: 0 0 auto;
  order: 1;
}

.se-topbar-right > .se-search {
  order: 1;
}

@media (max-width: 1180px) {
  .se-ticket-quick {
    width: 40px;
    padding: 0;
  }
  .se-ticket-quick svg {
    display: block;
  }
  .se-ticket-quick span {
    display: none;
  }
}

@media (min-width: 761px) and (max-width: 980px) {
  .se-topbar-right > .se-search {
    display: block;
    flex: 1 1 230px;
    max-width: 340px;
    min-width: 180px;
  }
  .se-search-toggle {
    display: none;
  }
  .se-ticket-quick {
    display: inline-flex;
  }
  .se-topbar-right > .se-locale,
  .se-person,
  .se-burger {
    margin-left: 0;
  }
}

@media (max-width: 760px) {
  .se-topbar-right > .se-search {
    display: none;
  }
  .se-search-toggle {
    display: inline-flex;
  }
  .se-ticket-quick {
    display: inline-flex;
  }
  .se-topbar-right > .se-locale,
  .se-person,
  .se-burger {
    flex: 0 0 auto;
  }
}

/* Keep the utility cluster pinned to the far right at every responsive width. */
.se-topbar-bar {
  width: 100%;
}

.se-brand {
  flex: 0 0 auto;
}

.se-topbar-right {
  flex: 1 1 auto;
  justify-content: flex-start;
  min-width: 0;
}

.se-topbar-right > .se-locale {
  margin-left: auto;
}

@media (min-width: 1121px) {
  .se-topbar-right {
    display: grid;
    grid-template-columns: minmax(220px, 320px) auto minmax(0, 1fr) auto auto;
    align-items: center;
    column-gap: 14px;
  }
  .se-topbar-right > .se-search {
    justify-self: end;
    width: 100%;
  }
  .se-ticket-quick {
    justify-self: start;
  }
  .se-nav-desktop {
    justify-self: center;
  }
  .se-topbar-right > .se-locale {
    margin-left: 0;
  }
}

@media (min-width: 761px) and (max-width: 1120px) {
  .se-topbar-right > .se-search,
  .se-search-toggle {
    margin-left: auto;
  }
  .se-topbar-right > .se-locale {
    margin-left: 0;
  }
}

@media (max-width: 760px) {
  .se-topbar-right {
    flex: 1 1 auto;
    justify-content: flex-end;
    min-width: 0;
  }
  .se-search-toggle {
    margin-left: auto;
  }
  .se-topbar-right > .se-locale {
    margin-left: 0;
  }
}

/* Grouped header layout: center the main navigation block between logo and actions. */
.se-header-main-block,
.se-header-actions {
  display: flex;
  align-items: center;
  min-width: 0;
}

.se-header-main-block {
  gap: 14px;
}

.se-header-actions {
  gap: 12px;
  flex: 0 0 auto;
}

@media (min-width: 1121px) {
  .se-topbar-bar {
    display: grid;
    grid-template-columns: auto minmax(0, 1fr);
    column-gap: 28px;
  }

  .se-topbar-right {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: center;
    gap: 18px;
    width: 100%;
  }

  .se-header-main-block {
    justify-self: center;
  }

  .se-header-actions {
    justify-self: end;
  }

  .se-header-main-block .se-search {
    flex: 0 1 500px;
    width: min(500px, 36vw);
    max-width: 500px;
  }

  .se-search-toggle {
    display: none;
  }

  .se-ticket-quick {
    width: auto;
    padding: 0 4px;
  }

  .se-ticket-quick svg {
    display: none;
  }

  .se-ticket-quick span {
    display: inline;
  }
}

@media (max-width: 1120px) {
  .se-topbar-right {
    display: flex;
    justify-content: flex-end;
  }

  .se-header-main-block {
    margin-left: auto;
  }

  .se-header-actions {
    margin-left: 4px;
  }
}

@media (min-width: 761px) and (max-width: 980px) {
  .se-header-main-block .se-search {
    display: grid;
    flex: 0 1 360px;
    min-width: 190px;
    max-width: 360px;
    grid-template-columns: minmax(125px, 1fr) minmax(105px, 0.72fr) 38px;
  }

  .se-search-toggle {
    display: none;
  }

  .se-ticket-quick {
    width: 40px;
    padding: 0;
  }

  .se-ticket-quick svg {
    display: block;
  }

  .se-ticket-quick span {
    display: none;
  }
}

@media (max-width: 760px) {
  .se-header-main-block {
    gap: 8px;
    margin-left: auto;
  }

  .se-header-actions {
    gap: 8px;
  }

  .se-header-main-block .se-search {
    display: none;
  }

  .se-search-toggle,
  .se-ticket-quick {
    display: inline-flex;
    width: 38px;
    height: 42px;
  }

  .se-ticket-quick svg {
    display: block;
  }

  .se-ticket-quick span {
    display: none;
  }

  .se-header-actions .se-locale {
    display: block;
  }
}

@media (max-width: 420px) {
  .se-container {
    padding-left: 10px;
    padding-right: 10px;
  }

  .se-topbar .se-brand-logo {
    height: 22px;
  }

  .se-topbar-bar {
    min-height: 48px;
  }

  .se-topbar-right {
    gap: 2px;
  }

  .se-header-main-block {
    gap: 2px;
  }

  .se-header-actions {
    gap: 2px;
    margin-left: 1px;
  }

  .se-search-toggle,
  .se-ticket-quick,
  .se-person,
  .se-burger {
    width: 35px;
    height: 42px;
    padding: 0;
  }

  .se-search-toggle svg,
  .se-ticket-quick svg {
    width: 23px;
    height: 23px;
  }

  .se-person {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 0;
    color: var(--se-muted);
  }

  .se-person-icon {
    display: inline-flex;
    height: 25px;
  }

  .se-person svg {
    display: block;
    width: 24px;
    height: 24px;
  }

  .se-person .se-person-label {
    display: none;
  }

  .se-locale-btn {
    min-width: 43px;
    padding: 0 2px;
    gap: 2px;
  }

  .se-topbar-right > .se-locale,
  .se-header-actions .se-locale,
  .se-locale {
    display: block;
  }

  .se-locale-flag {
    font-size: 18px;
  }

  .se-locale-code {
    font-size: 11px;
  }

  .se-burger {
    width: 34px;
    padding: 9px 5px;
  }
}

/* Mobile search opens as its own docked panel directly below the header border. */
.se-topbar {
  overflow: visible;
  z-index: 120;
}

.se-topbar button,
.se-topbar a {
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
}

.se-category-panel,
.se-locale-menu,
.se-search-list {
  z-index: 140;
}

.se-search-dock {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  display: none;
  padding: 12px 16px 14px;
  background: rgba(255, 255, 255, 0.98);
  border-top: 1px solid var(--se-border);
  border-bottom: 1px solid var(--se-border);
  box-shadow: 0 18px 30px rgba(31, 36, 48, 0.12);
}

.se-search-dock.se-open {
  display: block;
}

.se-search-dock .se-search {
  width: min(100%, 760px);
  margin: 0 auto;
}

.se-search-dock .se-search-input {
  height: 44px;
  background: transparent;
}

.se-search-dock .se-search-list {
  top: calc(100% + 8px);
  max-height: min(52vh, 340px);
}

@media (min-width: 901px) {
  .se-search-dock {
    display: none !important;
  }
}

@media (max-width: 900px) {
  .se-search-dock .se-search {
    grid-template-columns: 1fr 42px;
    gap: 9px;
    border-radius: 18px;
    padding: 3px 8px;
  }

  .se-search-dock .se-search-field-location {
    grid-column: 1 / -1;
    grid-row: 2;
    border-left: 0;
    border-top: 1px solid var(--se-border);
  }

  .se-search-dock .se-search-filter-btn {
    grid-column: 2;
    grid-row: 1;
    align-self: center;
  }
}

@media (max-width: 520px) {
  .se-drawer-search .se-search {
    grid-template-columns: 1fr 42px;
    border-radius: 18px;
    padding: 3px 8px;
  }

  .se-drawer-search .se-search-field-location {
    grid-column: 1 / -1;
    grid-row: 2;
    border-left: 0;
    border-top: 1px solid var(--se-border);
  }

  .se-drawer-search .se-search-filter-btn {
    grid-column: 2;
    grid-row: 1;
    align-self: center;
  }
}

/* Event search filter sheet / popup. */
.se-filter-overlay {
  position: fixed;
  inset: 0;
  z-index: 220;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

.se-filter-backdrop {
  position: absolute;
  inset: 0;
  border: 0;
  background: rgba(15, 18, 26, 0.42);
  cursor: pointer;
}

.se-filter-panel {
  position: relative;
  width: min(860px, 100%);
  max-height: min(84vh, 760px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 22px;
  background: #f6f7fb;
  box-shadow: 0 28px 70px rgba(31, 36, 48, 0.24);
}

.se-filter-handle {
  display: none;
}

.se-filter-head {
  display: grid;
  grid-template-columns: 42px 1fr 42px;
  align-items: center;
  padding: 16px 20px 14px;
  border-bottom: 1px solid #e4e7f1;
}

.se-filter-head h2 {
  margin: 0;
  color: #1f2430;
  font-size: 18px;
  font-weight: 850;
  text-align: center;
}

.se-filter-close {
  width: 34px;
  height: 34px;
  border: 0;
  border-radius: 12px;
  background: transparent;
  color: #1f2430;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.se-filter-body {
  overflow: auto;
  padding: 18px 20px 20px;
}

.se-filter-section {
  padding: 16px 4px;
  border-bottom: 1px solid #e4e7f1;
}

.se-filter-section:first-child {
  padding-top: 0;
}

.se-filter-section:last-child {
  border-bottom: 0;
}

.se-filter-section h3 {
  margin: 0 0 12px;
  color: #1f2430;
  font-size: 15px;
  font-weight: 850;
}

.se-filter-cat-grid {
  display: grid;
  grid-template-columns: repeat(6, minmax(92px, 1fr));
  gap: 10px;
}

.se-filter-cat {
  min-height: 98px;
  padding: 10px;
  border: 1.5px solid #e8dcfa;
  border-radius: 14px;
  background: #fff;
  color: #1f2430;
  text-align: left;
  cursor: pointer;
}

.se-filter-cat.se-active {
  border-color: var(--cat-color);
  border-width: 2px;
}

.se-filter-cat-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
}

.se-filter-cat-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: color-mix(in srgb, var(--cat-color) 14%, white);
  color: var(--cat-color);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 900;
}

.se-filter-cat-radio {
  width: 16px;
  height: 16px;
  border: 1.5px solid #e4e7f1;
  border-radius: 999px;
  margin-top: 2px;
}

.se-filter-cat.se-active .se-filter-cat-radio {
  border-color: var(--cat-color);
  background: radial-gradient(circle, #fff 0 35%, var(--cat-color) 38% 100%);
}

.se-filter-cat-name {
  display: block;
  color: #1f2430;
  font-size: 11.5px;
  font-weight: 650;
  line-height: 1.25;
  text-align: center;
}

.se-filter-segment,
.se-filter-chip-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.se-filter-segment button,
.se-filter-chip-row button {
  min-height: 36px;
  padding: 8px 12px;
  border: 1px solid #e4e7f1;
  border-radius: 999px;
  background: #fff;
  color: #1f2430;
  font-size: 13px;
  font-weight: 750;
  cursor: pointer;
}

.se-filter-segment button.se-active,
.se-filter-chip-row button.se-active {
  border-color: #5b8fe8;
  background: #5b8fe8;
  color: #fff;
}

.se-filter-note {
  margin: 10px 0 0;
  color: #5b8fe8;
  font-size: 12px;
  font-style: italic;
}

.se-filter-two {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 22px;
}

.se-filter-date-row,
.se-filter-price-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.se-filter-date-row label,
.se-filter-price-row label {
  display: grid;
  gap: 6px;
}

.se-filter-date-row span,
.se-filter-price-row span {
  color: #5b8fe8;
  font-size: 12px;
  font-weight: 750;
}

.se-filter-date-row input,
.se-filter-price-row input {
  width: 100%;
  box-sizing: border-box;
  height: 42px;
  border: 1px solid #e4e7f1;
  border-radius: 12px;
  background: #fff;
  color: #1f2430;
  padding: 0 12px;
  font-size: 14px;
  outline: none;
}

.se-filter-free {
  min-height: 42px;
  display: inline-flex;
  align-items: center;
  gap: 9px;
  margin-bottom: 10px;
  color: #1f2430;
  font-size: 14px;
  font-weight: 700;
}

.se-filter-free input {
  width: 18px;
  height: 18px;
  accent-color: #5b8fe8;
}

.se-filter-footer {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  padding: 14px 20px 18px;
  border-top: 1px solid #e4e7f1;
  background: #f6f7fb;
}

.se-filter-reset,
.se-filter-apply {
  min-height: 48px;
  border-radius: 14px;
  font-size: 13px;
  font-weight: 850;
  cursor: pointer;
}

.se-filter-reset {
  border: 1.5px solid #5b8fe8;
  background: transparent;
  color: #5b8fe8;
}

.se-filter-apply {
  border: 1.5px solid #5b8fe8;
  background: #5b8fe8;
  color: #fff;
  box-shadow: 0 8px 18px rgba(91, 143, 232, 0.26);
}

@media (max-width: 900px) {
  .se-filter-overlay {
    align-items: flex-end;
    padding: 0;
  }

  .se-filter-panel {
    width: 100%;
    max-height: 88vh;
    border-radius: 20px 20px 0 0;
  }

  .se-filter-handle {
    display: block;
    align-self: center;
    width: 38px;
    height: 4px;
    border-radius: 999px;
    background: #e4e7f1;
    margin-top: 8px;
  }

  .se-filter-cat-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .se-filter-two {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 520px) {
  .se-filter-body {
    padding-inline: 16px;
  }

  .se-filter-cat-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .se-filter-date-row,
  .se-filter-price-row {
    grid-template-columns: 1fr;
  }
}

/* Final safety pass for the event-search header:
   keep the utility cluster on the right, prevent nav text overlap, and keep the
   filter dialog fully visible on every viewport. */
.se-topbar-links {
  min-width: 0;
}

.se-topbar-links a,
.se-category-trigger {
  flex: 0 0 auto;
  white-space: nowrap;
}

@media (min-width: 1121px) {
  .se-header-main-block {
    min-width: 0;
    gap: clamp(8px, 0.9vw, 14px);
  }

  .se-header-main-block .se-search {
    flex: 0 1 430px;
    width: min(430px, 29vw);
    max-width: 430px;
  }

  .se-topbar-links {
    gap: clamp(8px, 0.75vw, 13px);
  }
}

@media (min-width: 1121px) and (max-width: 1320px) {
  .se-nav-help {
    display: none;
  }
}

@media (min-width: 1121px) and (max-width: 1240px) {
  .se-nav-venues {
    display: none;
  }

  .se-header-main-block .se-search {
    width: min(400px, 32vw);
    max-width: 400px;
  }
}

@media (min-width: 761px) and (max-width: 1120px) {
  .se-topbar-right {
    width: 100%;
  }

  .se-header-main-block {
    margin-left: auto;
  }

  .se-header-actions {
    margin-left: 6px;
  }
}

@media (min-width: 761px) and (max-width: 980px) {
  .se-header-main-block {
    flex: 1 1 auto;
    justify-content: flex-end;
  }

  .se-header-main-block .se-search {
    flex: 0 1 330px;
    width: min(330px, 42vw);
    min-width: 0;
    max-width: 330px;
  }
}

@media (min-width: 761px) and (max-width: 860px) {
  .se-header-main-block .se-search {
    display: none;
  }

  .se-search-toggle {
    display: inline-flex;
  }

  .se-ticket-quick {
    display: inline-flex;
  }
}

.se-filter-overlay {
  align-items: center;
  justify-content: center;
  padding: max(18px, env(safe-area-inset-top)) 18px max(18px, env(safe-area-inset-bottom));
}

.se-filter-panel {
  max-height: calc(100dvh - 36px);
}

@media (max-width: 900px) {
  .se-filter-overlay {
    align-items: center;
    justify-content: center;
    padding: max(14px, env(safe-area-inset-top)) 12px max(14px, env(safe-area-inset-bottom));
  }

  .se-filter-panel {
    width: min(560px, 100%);
    max-height: calc(100dvh - 28px);
    border-radius: 20px;
  }
}

/* Last-pass stability for the combined event search and filter modal. */
.se-search {
  grid-template-columns: minmax(0, 1fr) minmax(0, 0.76fr) 40px;
}

.se-search-field,
.se-search-input {
  min-width: 0;
}

.se-search .se-search-filter-btn {
  align-self: center;
  justify-self: center;
  flex: 0 0 36px;
  max-width: 36px;
}

@media (min-width: 861px) and (max-width: 1120px) {
  .se-header-main-block {
    flex: 1 1 auto;
    justify-content: flex-end;
    gap: 8px;
    min-width: 0;
  }

  .se-header-main-block .se-search {
    display: grid;
    flex: 0 1 340px;
    width: min(340px, 36vw);
    min-width: 0;
    max-width: 340px;
    grid-template-columns: minmax(0, 1fr) minmax(0, 0.68fr) 38px;
    padding-inline: 3px;
  }

  .se-header-main-block .se-ticket-quick {
    display: inline-flex;
    width: 40px;
    height: 40px;
    padding: 0;
  }

  .se-header-main-block .se-ticket-quick svg {
    display: block;
  }

  .se-header-main-block .se-ticket-quick span {
    display: none;
  }

  .se-search-toggle {
    display: none;
  }
}

@media (min-width: 981px) and (max-width: 1040px) {
  .se-nav-organize {
    display: none;
  }
}

@media (min-width: 861px) and (max-width: 980px) {
  .se-header-main-block .se-search {
    flex-basis: 320px;
    width: min(320px, 39vw);
    max-width: 320px;
  }
}

.se-filter-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: max(24px, env(safe-area-inset-top)) 18px max(24px, env(safe-area-inset-bottom));
}

.se-filter-panel {
  width: min(860px, calc(100vw - 36px));
  max-height: calc(100dvh - 48px);
  margin: auto;
}

.se-filter-body {
  min-height: 0;
}

@media (max-width: 900px) {
  .se-filter-overlay {
    align-items: center;
    justify-content: center;
    padding: max(16px, env(safe-area-inset-top)) 12px max(16px, env(safe-area-inset-bottom));
  }

  .se-filter-panel {
    width: min(560px, calc(100vw - 24px));
    max-height: calc(100dvh - 32px);
    border-radius: 20px;
  }
}

/* Final profile action guard: keep login visible and avoid white hover states. */
.se-topbar .se-person,
.se-topbar .se-person:visited {
  display: inline-flex;
  flex: 0 0 auto;
  color: var(--se-muted);
  background: transparent;
  opacity: 1;
  visibility: visible;
}

.se-topbar .se-person:hover,
.se-topbar .se-person:focus-visible,
.se-topbar .se-person-in,
.se-topbar .se-person-in:hover,
.se-topbar .se-person-in:focus-visible {
  color: var(--se-purple);
  background: transparent;
}

.se-person-icon,
.se-person svg {
  display: inline-flex;
  flex: 0 0 auto;
  color: currentColor;
}

.se-person-avatar {
  display: block;
  width: 24px;
  height: 24px;
  border-radius: 999px;
  object-fit: cover;
  box-shadow: 0 0 0 2px rgba(91, 143, 232, 0.18);
}

@media (min-width: 901px) {
  .se-nav-desktop .se-category-menu {
    display: none;
  }
}

@media (max-width: 420px) {
  .se-header-actions {
    flex: 0 0 auto;
  }

  .se-topbar .se-person {
    flex-basis: 35px;
    min-width: 35px;
    width: 35px;
    height: 42px;
  }

  .se-person-icon {
    width: 24px;
    height: 24px;
    align-items: center;
    justify-content: center;
  }

  .se-person svg {
    width: 24px;
    height: 24px;
  }
}

@media (max-width: 370px) {
  .se-topbar .se-brand-logo {
    height: 20px;
  }

  .se-search-toggle,
  .se-ticket-quick,
  .se-topbar .se-person,
  .se-burger {
    width: 33px;
    min-width: 33px;
  }

  .se-header-main-block,
  .se-header-actions,
  .se-topbar-right {
    gap: 1px;
  }
}

/* ---- web event discovery blocks ---- */
.se-home-live-hero {
  position: relative;
  min-height: 0;
  display: grid;
  grid-template-columns: minmax(0, 0.95fr) minmax(280px, 0.86fr);
  align-items: center;
  gap: clamp(20px, 4vw, 58px);
  max-width: 1800px;
  margin: 0 auto;
  padding: clamp(28px, 4.2vw, 58px) clamp(18px, 4vw, 72px) clamp(20px, 3.2vw, 44px);
  overflow: hidden;
}

.se-home-live-copy {
  position: relative;
  z-index: 2;
  max-width: 650px;
}

.se-home-live-copy h1 {
  max-width: 560px;
  margin: 8px 0 13px;
  color: var(--se-ink);
  font-size: clamp(32px, 4vw, 58px);
  line-height: 1.02;
  letter-spacing: 0;
  text-transform: lowercase;
}

.se-home-live-copy p {
  margin: 0 0 14px;
  max-width: 610px;
  color: var(--se-muted);
  font-size: clamp(14px, 1.05vw, 17px);
  line-height: 1.58;
}

.se-home-live-features {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  max-width: 660px;
  margin: 0 0 18px;
}

.se-home-live-features span {
  min-height: 29px;
  display: inline-flex;
  align-items: center;
  padding: 0 10px;
  border: 1px solid #dfe7f8;
  border-radius: 999px;
  background: #fff;
  color: #1f2430;
  font-size: 12px;
  font-weight: 800;
  text-transform: lowercase;
}

.se-home-live-btn {
  min-height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 15px;
  border-radius: 999px;
  background: #5b8fe8;
  color: #fff;
  font-weight: 850;
  text-decoration: none;
  box-shadow: 0 14px 28px rgba(91, 143, 232, 0.25);
}

.se-home-photo-stage {
  position: relative;
  min-height: clamp(260px, 31vw, 430px);
}

.se-home-photo-card {
  position: absolute;
  overflow: hidden;
  border-radius: 8px;
  background: linear-gradient(135deg, #eaf1ff, #f6f2ff);
  box-shadow: 0 26px 60px rgba(31, 36, 48, 0.2);
  animation: se-photo-float 7s ease-in-out infinite;
}

.se-home-photo-card img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.se-home-photo-card span {
  position: absolute;
  left: 10px;
  bottom: 10px;
  width: auto;
  height: auto;
  display: inline-flex;
  align-items: center;
  min-height: 27px;
  padding: 0 9px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.9);
  color: #1f2430;
  font-size: 11px;
  font-weight: 900;
  text-transform: lowercase;
  backdrop-filter: blur(8px);
}

.se-home-photo-1 { left: 6%; top: 3%; width: 43%; aspect-ratio: 4 / 5; transform: rotate(-5deg); }
.se-home-photo-2 { right: 8%; top: 12%; width: 39%; aspect-ratio: 1 / 1; transform: rotate(4deg); animation-delay: -1.2s; }
.se-home-photo-3 { left: 25%; bottom: 4%; width: 39%; aspect-ratio: 16 / 11; transform: rotate(3deg); animation-delay: -2.4s; }
.se-home-photo-4 { right: 17%; bottom: 12%; width: 24%; aspect-ratio: 1; transform: rotate(-7deg); animation-delay: -3.4s; }

@keyframes se-photo-float {
  0%, 100% { translate: 0 0; }
  50% { translate: 0 -14px; }
}

.se-home-categories-wrap {
  position: relative;
  display: grid;
  grid-template-columns: 42px minmax(0, 1fr) 42px;
  align-items: center;
  gap: 8px;
  padding-top: 4px;
  padding-bottom: 28px;
}

.se-home-categories {
  min-width: 0;
  display: flex;
  gap: 10px;
  overflow-x: auto;
  padding: 2px 2px 8px;
  scrollbar-width: none;
  scroll-behavior: smooth;
  scroll-snap-type: x proximity;
}

.se-home-categories::-webkit-scrollbar {
  display: none;
}

.se-home-cat-pill {
  flex: 0 0 116px;
  min-height: 92px;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 9px;
  padding: 10px 9px;
  border: 1px solid color-mix(in srgb, var(--cat-color) 24%, #e4e7f1);
  border-radius: 8px;
  background: #fff;
  color: #1f2430;
  text-decoration: none;
  text-align: center;
  scroll-snap-align: start;
}

.se-home-cat-pill span {
  width: 42px;
  height: 42px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: color-mix(in srgb, var(--cat-color) 12%, #fff);
  color: var(--cat-color);
  font-size: 22px;
  font-weight: 950;
}

.se-home-cat-pill strong {
  max-width: 100%;
  font-size: 12px;
  line-height: 1.18;
  white-space: normal;
}

.se-home-cat-arrow {
  width: 38px;
  height: 38px;
  border: 0;
  border-radius: 999px;
  background: #fff;
  color: #5b8fe8;
  box-shadow: 0 10px 24px rgba(31, 36, 48, 0.12);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
  transition: opacity 0.16s ease, transform 0.16s ease;
}

.se-home-cat-arrow:hover:not(:disabled) {
  transform: translateY(-1px);
}

.se-home-cat-arrow:disabled {
  opacity: 0.24;
  cursor: default;
  box-shadow: none;
}

.se-home-highlight,
.se-results-page {
  padding-top: 24px;
  padding-bottom: 52px;
}

.se-home-section-head,
.se-results-head {
  margin-bottom: 18px;
}

.se-home-section-head {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
}

.se-home-section-head h2,
.se-results-head h1 {
  margin: 7px 0 0;
  color: var(--se-ink);
}

.se-home-section-head h2 {
  font-size: clamp(26px, 3vw, 42px);
}

.se-home-section-head a {
  color: #5b8fe8;
  font-weight: 850;
  text-decoration: none;
  white-space: nowrap;
}

.se-results-head {
  max-width: 760px;
}

.se-results-head h1 {
  font-size: clamp(30px, 4vw, 54px);
}

.se-results-head p {
  color: var(--se-muted);
  line-height: 1.6;
}

.se-event-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 18px;
}

.se-event-card {
  min-width: 0;
  overflow: hidden;
  border: 1px solid #e4e7f1;
  border-radius: 8px;
  background: #fff;
  color: inherit;
  text-decoration: none;
  box-shadow: 0 12px 28px rgba(31, 36, 48, 0.08);
  transition: transform 0.18s ease, box-shadow 0.18s ease;
}

.se-event-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 18px 38px rgba(31, 36, 48, 0.14);
}

.se-event-card-media {
  position: relative;
  aspect-ratio: 1 / 1;
  overflow: hidden;
  background: #eaf1ff;
}

.se-event-card-media img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.se-event-card-empty {
  width: 100%;
  height: 100%;
  display: grid;
  place-items: center;
  color: #5b8fe8;
  font-weight: 900;
}

.se-event-date-badge,
.se-event-kind-badge {
  position: absolute;
  top: 10px;
  border-radius: 999px;
  color: #fff;
  font-size: 11px;
  font-weight: 900;
  line-height: 1;
}

.se-event-date-badge {
  left: 10px;
  padding: 7px 9px;
  background: rgba(31, 36, 48, 0.76);
}

.se-event-kind-badge {
  right: 10px;
  padding: 7px 9px;
  background: #5b8fe8;
}

.se-event-card-body {
  min-height: 118px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 12px;
}

.se-event-card-body h3 {
  margin: 0;
  color: #1f2430;
  font-size: 15px;
  line-height: 1.25;
}

.se-event-card-location {
  margin: 8px 0 0;
  color: var(--se-muted);
  font-size: 13px;
}

.se-event-card-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: 12px;
  color: #5b8fe8;
  font-size: 13px;
  font-weight: 850;
}

.se-event-empty,
.se-event-loading {
  padding: 22px;
  border: 1px dashed #d7def0;
  border-radius: 8px;
  color: var(--se-muted);
  background: #fff;
}

.se-event-grid-loading {
  pointer-events: none;
}

.se-event-skeleton-card {
  box-shadow: 0 10px 24px rgba(31, 36, 48, 0.06);
}

.se-event-skeleton-thumb,
.se-event-skeleton-line {
  position: relative;
  overflow: hidden;
  background: linear-gradient(90deg, #edf1f8 0%, #f7f9fd 48%, #edf1f8 100%);
  background-size: 220% 100%;
  animation: se-skeleton-shimmer 1.15s ease-in-out infinite;
}

.se-event-skeleton-thumb::after {
  content: "";
  position: absolute;
  inset: 18px;
  border-radius: 8px;
  border: 1px solid rgba(91, 143, 232, 0.16);
}

.se-event-skeleton-line {
  display: block;
  height: 12px;
  border-radius: 999px;
}

.se-event-skeleton-title {
  width: 78%;
  height: 15px;
}

.se-event-skeleton-meta {
  width: 58%;
  margin-top: 12px;
}

.se-event-skeleton-price {
  width: 68px;
}

.se-event-skeleton-action {
  width: 54px;
}

@keyframes se-skeleton-shimmer {
  0% { background-position: 100% 0; }
  100% { background-position: -100% 0; }
}

@media (max-width: 860px) {
  .se-home-live-hero {
    grid-template-columns: 1fr;
    min-height: 0;
  }

  .se-home-photo-stage {
    min-height: 300px;
  }

  .se-event-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
  }
}

@media (max-width: 520px) {
  .se-home-live-hero {
    padding-inline: 14px;
  }

  .se-home-photo-stage {
    min-height: 260px;
  }

  .se-home-cat-pill strong {
    font-size: 12px;
  }

  .se-home-categories-wrap {
    grid-template-columns: 34px minmax(0, 1fr) 34px;
    gap: 4px;
    padding-inline: 8px;
  }

  .se-home-cat-arrow {
    width: 32px;
    height: 32px;
    font-size: 22px;
  }

  .se-home-cat-pill {
    flex-basis: 98px;
    min-height: 88px;
  }

  .se-event-card-body {
    min-height: 110px;
    padding: 10px;
  }
}

/* ============================================================ cookie consent */
.se-cc-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 18, 26, 0.55);
  backdrop-filter: blur(3px);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  z-index: 9999;
  padding: 16px;
  animation: se-cc-fade 0.2s ease;
}

@keyframes se-cc-fade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.se-cc-card {
  background: #fff;
  width: 100%;
  max-width: 560px;
  border-radius: 20px;
  box-shadow: var(--se-shadow);
  overflow: hidden;
  max-height: 92vh;
  display: flex;
  flex-direction: column;
  animation: se-cc-rise 0.25s ease;
}

@keyframes se-cc-rise {
  from {
    transform: translateY(24px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.se-cc-head {
  background: var(--se-grad);
  color: #fff;
  padding: 22px 24px 18px;
  display: flex;
  align-items: center;
  gap: 14px;
}

.se-cc-head svg {
  width: 46px;
  height: 46px;
  flex: 0 0 auto;
}

.se-cc-head h2 {
  margin: 0;
  font-size: 19px;
  font-family: var(--se-font);
}

.se-cc-body {
  padding: 20px 24px 4px;
  overflow-y: auto;
  font-family: var(--se-font);
  color: var(--se-ink);
  line-height: 1.6;
}

.se-cc-body p {
  margin: 0 0 12px;
  font-size: 14.5px;
  color: #313846;
}

.se-cc-body a {
  color: var(--se-purple);
  font-weight: 600;
}

/* category rows */
.se-cc-cat {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  padding: 14px 0;
  border-top: 1px solid var(--se-border);
}

.se-cc-cat-title {
  font-weight: 700;
  font-size: 14.5px;
  margin: 0 0 3px;
}

.se-cc-cat-desc {
  margin: 0;
  font-size: 13px;
  color: var(--se-muted);
}

/* toggle */
.se-switch {
  position: relative;
  width: 44px;
  height: 26px;
  flex: 0 0 auto;
  margin-top: 2px;
}

.se-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.se-switch .se-slider {
  position: absolute;
  inset: 0;
  background: #cfd4e0;
  border-radius: 999px;
  transition: background 0.2s ease;
}

.se-switch .se-slider::before {
  content: "";
  position: absolute;
  height: 20px;
  width: 20px;
  left: 3px;
  top: 3px;
  background: #fff;
  border-radius: 50%;
  transition: transform 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
}

.se-switch input:checked + .se-slider {
  background: var(--se-purple);
}

.se-switch input:checked + .se-slider::before {
  transform: translateX(18px);
}

.se-switch input:disabled + .se-slider {
  background: var(--se-blue);
  opacity: 0.6;
  cursor: not-allowed;
}

/* actions */
.se-cc-actions {
  padding: 16px 24px 22px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.se-btn {
  flex: 1 1 auto;
  border: none;
  border-radius: 12px;
  padding: 13px 18px;
  font: inherit;
  font-weight: 700;
  font-size: 14.5px;
  cursor: pointer;
  font-family: var(--se-font);
  transition: transform 0.05s ease, box-shadow 0.2s ease;
}

.se-btn:active {
  transform: translateY(1px);
}

.se-btn-primary {
  background: var(--se-grad);
  color: #fff;
  box-shadow: var(--se-shadow-sm);
}

.se-btn-ghost {
  background: var(--se-surface);
  color: var(--se-ink);
  border: 1px solid var(--se-border);
}

.se-btn-text {
  background: none;
  color: var(--se-purple);
  flex: 1 1 100%;
  order: 3;
}

.se-cc-foot {
  padding: 0 24px 18px;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: nowrap;
  font-size: 12.5px;
}

.se-cc-foot-links {
  display: flex;
  gap: 14px;
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
}

.se-cc-foot a {
  color: var(--se-muted);
  text-decoration: none;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}

.se-cc-foot a:hover {
  color: var(--se-purple);
}

.se-cc-lang {
  position: relative;
  flex: 0 0 auto;
}

.se-cc-lang-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid var(--se-border);
  border-radius: 8px;
  background: var(--se-surface);
  color: var(--se-muted);
  font-family: var(--se-font);
  font-weight: 600;
  font-size: 12.5px;
  padding: 4px 8px;
  cursor: pointer;
  max-width: 160px;
}

.se-cc-lang-btn:hover,
.se-cc-lang-btn:focus {
  color: var(--se-purple);
  border-color: var(--se-purple);
  outline: none;
}

.se-cc-lang-flag {
  font-size: 14px;
  line-height: 1;
}

.se-cc-lang-label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.se-cc-lang-menu {
  min-width: 210px;
  max-height: 260px;
  overflow-y: auto;
  margin: 0;
  padding: 6px;
  list-style: none;
  background: var(--se-white);
  border: 1px solid var(--se-border);
  border-radius: var(--se-radius-sm);
  box-shadow: var(--se-shadow);
  z-index: 10000;
}

.se-cc-lang-opt {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 9px 10px;
  border: none;
  border-radius: 8px;
  background: none;
  font-family: var(--se-font);
  font-size: 14px;
  color: var(--se-ink);
  cursor: pointer;
  text-align: left;
}

.se-cc-lang-opt:hover,
.se-cc-lang-opt.se-active {
  background: var(--se-grad-soft);
  color: var(--se-purple);
}

.se-cc-lang-opt-label {
  font-weight: 600;
}

/* re-open settings floating link used on policy pages */
.se-reopen {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: var(--se-grad);
  color: #fff;
  border: none;
  border-radius: 12px;
  padding: 12px 18px;
  font: inherit;
  font-weight: 700;
  cursor: pointer;
  font-family: var(--se-font);
  box-shadow: var(--se-shadow-sm);
  margin: 8px 0;
}

/* ============================================================== help center */
/* full-bleed hero: huge illustration with the heading overlaid on top */
.se-hc-hero {
  position: relative;
  min-height: 440px;
  display: flex;
  align-items: center;
  overflow: hidden;
  border-bottom: 1px solid var(--se-border);
}

.se-hc-hero-art {
  position: absolute;
  inset: 0;
}

.se-hc-hero-art svg {
  width: 100%;
  height: 100%;
  display: block;
}

/* darkening scrim so white text stays legible over the illustration */
.se-hc-scrim {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    90deg,
    rgba(18, 16, 42, 0.62) 0%,
    rgba(18, 16, 42, 0.34) 46%,
    rgba(18, 16, 42, 0) 78%
  );
}

.se-hc-hero-inner {
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: 1080px;
  margin: 0 auto;
  padding: 60px 24px;
}

.se-hc-hero-text {
  max-width: 600px;
  color: #fff;
}

.se-hc-eyebrow {
  display: inline-block;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: #fff;
  background: rgba(255, 255, 255, 0.18);
  border: 1px solid rgba(255, 255, 255, 0.35);
  border-radius: 999px;
  padding: 5px 14px;
  margin-bottom: 16px;
  backdrop-filter: blur(4px);
}

.se-hc-hero h1 {
  margin: 0 0 14px;
  font-size: 46px;
  line-height: 1.08;
  letter-spacing: -1px;
  color: #fff;
}

.se-hc-hero-sub {
  margin: 0 0 24px;
  font-size: 18px;
  line-height: 1.55;
  color: rgba(255, 255, 255, 0.94);
  max-width: 48ch;
}

.se-hc-cta-row {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.se-hc-cta {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  background: #fff;
  color: var(--se-purple);
  border-radius: 12px;
  padding: 13px 22px;
  font-weight: 800;
  font-size: 15px;
  text-decoration: none;
  box-shadow: 0 8px 22px rgba(18, 16, 42, 0.25);
}

.se-hc-cta:hover {
  transform: translateY(-1px);
}

.se-hc-note {
  color: rgba(255, 255, 255, 0.85);
  font-size: 13.5px;
}

/* lead paragraph under the hero */
.se-hc-lead {
  font-size: 17px;
  color: var(--se-muted);
  max-width: 70ch;
  margin: 0 0 8px;
}

/* App-first red disclaimer banner at the top of the Help Center. */
.se-hc-disclaimer {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin: 0 0 22px;
  padding: 14px 18px;
  border: 1px solid #f1b0b0;
  border-left: 5px solid #d12b2b;
  border-radius: 12px;
  background: #fdecec;
  color: #8f1d1d;
}

.se-hc-disclaimer p {
  margin: 0;
  font-size: 14.5px;
  line-height: 1.5;
}

.se-hc-disclaimer strong {
  color: #7a1414;
}

.se-hc-disclaimer-icon {
  font-size: 20px;
  line-height: 1.4;
  flex: 0 0 auto;
}

/* topic grid */
.se-hc-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(248px, 1fr));
  gap: 16px;
  margin: 20px 0 8px;
}

.se-hc-topic {
  display: flex;
  gap: 14px;
  align-items: flex-start;
  background: var(--se-surface);
  border: 1px solid var(--se-border);
  border-radius: var(--se-radius);
  padding: 18px;
  text-decoration: none;
  color: inherit;
  transition: box-shadow 0.2s ease, transform 0.06s ease;
}

.se-hc-topic:hover {
  box-shadow: var(--se-shadow-sm);
  transform: translateY(-2px);
}

.se-hc-topic-art {
  flex: 0 0 auto;
  width: 46px;
  height: 46px;
}

.se-hc-topic-art svg {
  width: 100%;
  height: 100%;
  display: block;
}

.se-hc-topic h3 {
  margin: 0 0 5px;
  font-size: 16px;
}

.se-hc-topic p {
  margin: 0;
  color: var(--se-muted);
  font-size: 13.5px;
  line-height: 1.55;
}

/* FAQ accordion (native details/summary) */
.se-hc-q {
  border: 1px solid var(--se-border);
  border-radius: var(--se-radius-sm);
  margin: 10px 0;
  background: #fff;
  overflow: hidden;
}

.se-hc-q summary {
  cursor: pointer;
  list-style: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 14px;
  padding: 15px 18px;
  font-weight: 700;
  font-size: 15.5px;
  color: var(--se-ink);
}

.se-hc-q summary::-webkit-details-marker {
  display: none;
}

.se-hc-q summary::after {
  content: "+";
  font-size: 22px;
  font-weight: 400;
  color: var(--se-purple);
  line-height: 1;
  transition: transform 0.2s ease;
}

.se-hc-q[open] summary {
  color: var(--se-purple);
}

.se-hc-q[open] summary::after {
  transform: rotate(45deg);
}

.se-hc-a {
  padding: 0 18px 16px;
  color: #313846;
  font-size: 14.5px;
  line-height: 1.65;
}

.se-hc-a a {
  color: var(--se-purple);
  font-weight: 600;
}

/* contact band */
.se-hc-contact {
  background: var(--se-grad);
  color: #fff;
  border-radius: var(--se-radius);
  padding: 30px 32px;
  margin: 28px 0 8px;
  display: flex;
  align-items: center;
  gap: 26px;
  flex-wrap: wrap;
  box-shadow: var(--se-shadow);
}

.se-hc-contact-art {
  flex: 0 0 auto;
  width: 84px;
  height: 84px;
}

.se-hc-contact-art svg {
  width: 100%;
  height: 100%;
}

.se-hc-contact-body {
  flex: 1 1 280px;
}

.se-hc-contact h2 {
  margin: 0 0 6px;
  color: #fff;
  font-size: 22px;
}

.se-hc-contact p {
  margin: 0 0 16px;
  color: rgba(255, 255, 255, 0.92);
  font-size: 15px;
}

.se-hc-mail {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  background: #fff;
  color: var(--se-purple);
  border-radius: 12px;
  padding: 12px 20px;
  font-weight: 800;
  font-size: 15px;
  text-decoration: none;
  box-shadow: 0 6px 18px rgba(18, 16, 42, 0.22);
}

.se-hc-contact-meta {
  margin: 14px 0 0;
  color: rgba(255, 255, 255, 0.82);
  font-size: 13px;
}

/* ----------------------------------------------------------- responsiveness */
@media (max-width: 760px) {
  .se-hc-hero {
    min-height: 380px;
  }
  .se-hc-hero h1 {
    font-size: 32px;
  }
  .se-hc-hero-sub {
    font-size: 16px;
  }
  .se-hc-scrim {
    background: linear-gradient(
      180deg,
      rgba(18, 16, 42, 0.3) 0%,
      rgba(18, 16, 42, 0.55) 100%
    );
  }
  .se-hc-contact {
    padding: 24px;
  }
}

@media (max-width: 640px) {
  .se-hero-inner {
    flex-direction: column-reverse;
    text-align: center;
    gap: 18px;
    padding: 32px 20px;
  }
  .se-hero p {
    margin: 0 auto;
  }
  .se-hero-art {
    width: 130px;
    height: 130px;
  }
  .se-hero h1 {
    font-size: 27px;
  }
  .se-cc-overlay {
    padding: 0;
  }
  .se-cc-card {
    max-width: 100%;
    border-radius: 18px 18px 0 0;
    max-height: 94vh;
  }
}

/* ═══════════════════════════════════════════════════════════════════════════
   HOME / LANDING PAGE
   ═══════════════════════════════════════════════════════════════════════════ */

/* split hero: copy left, illustration right */
.se-home-hero {
  background: var(--se-grad-soft);
  border-bottom: 1px solid var(--se-border);
  overflow: hidden;
}

.se-home-hero-inner {
  max-width: 1120px;
  margin: 0 auto;
  padding: 56px 24px;
  display: grid;
  grid-template-columns: 1.05fr 1fr;
  align-items: center;
  gap: 40px;
}

.se-home-hero-text h1 {
  font-size: 42px;
  line-height: 1.08;
  letter-spacing: -1px;
  margin: 0 0 18px;
  color: var(--se-ink);
}

.se-home-eyebrow {
  color: #fff;
  background: var(--se-grad);
  border: none;
  margin-bottom: 18px;
}

.se-home-hero-sub {
  font-size: 17.5px;
  line-height: 1.6;
  color: var(--se-muted);
  margin: 0 0 18px;
  max-width: 56ch;
}

.se-home-tagline {
  font-size: 16px;
  font-weight: 800;
  color: var(--se-purple);
  margin: 0;
}

.se-home-hero-art {
  width: 100%;
}

.se-home-hero-art svg {
  width: 100%;
  height: auto;
  display: block;
  filter: drop-shadow(0 18px 40px rgba(76, 60, 180, 0.18));
}

/* content spacing tweak for the home page */
.se-home-content {
  max-width: 1000px;
}

/* App-first notice pinned directly under the header on the home page:
   red disclaimer banner with the store badges right below it. */
.se-home-top-notice {
  padding-top: 20px;
}

.se-home-top-notice .se-hc-disclaimer {
  margin-bottom: 0;
}

.se-home-top-notice .se-home-get {
  margin: 16px 0 4px;
}

@media (max-width: 760px) {
  .se-home-top-notice {
    padding-top: 14px;
  }
}

/* download strip */
.se-home-get {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  text-align: center;
  margin: 28px 0 8px;
}

.se-home-get-label {
  font-size: 15px;
  font-weight: 700;
  color: var(--se-ink);
}

/* store badges (shared: home + footer) */
.se-store-badges {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 12px;
}

.se-store-badge {
  display: inline-flex;
  line-height: 0;
  border-radius: 10px;
  text-decoration: none;
  transition: transform 0.08s ease, box-shadow 0.2s ease;
}

.se-store-badge svg {
  height: 48px;
  width: auto;
  display: block;
}

.se-store-badge:hover {
  transform: translateY(-2px);
  box-shadow: var(--se-shadow-sm);
}

/* features */
.se-home-feat-heading {
  text-align: center;
  font-size: 26px;
  letter-spacing: -0.4px;
  margin: 56px 0 8px;
}

.se-home-feat-lead {
  text-align: center;
  color: var(--se-muted);
  font-size: 16px;
  max-width: 60ch;
  margin: 0 auto 20px;
}

.se-home-features {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 24px;
}

.se-home-feature {
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  gap: 32px;
  background: var(--se-surface);
  border: 1px solid var(--se-border);
  border-radius: var(--se-radius);
  padding: 26px 30px;
}

.se-home-feature-rev .se-home-feature-art {
  order: 2;
}

.se-home-feature-art svg {
  width: 100%;
  height: auto;
  max-height: 240px;
  display: block;
}

.se-home-feature-body h3 {
  font-size: 21px;
  margin: 0 0 10px;
  letter-spacing: -0.3px;
}

.se-home-feature-body p {
  font-size: 15.5px;
  line-height: 1.6;
  color: #313846;
  margin: 0;
}

/* closing CTA band */
.se-home-cta-band {
  margin: 48px 0 8px;
  padding: 40px 28px;
  border-radius: var(--se-radius);
  background: var(--se-grad);
  color: #fff;
  text-align: center;
}

.se-home-cta-band h2 {
  color: #fff;
  font-size: 24px;
  margin: 0 0 8px;
}

.se-home-cta-band p {
  color: rgba(255, 255, 255, 0.92);
  margin: 0 0 20px;
  font-size: 16px;
}

/* footer store block */
.se-foot-stores {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  margin-bottom: 18px;
}

.se-foot-stores-label {
  font-size: 12.5px;
  font-weight: 700;
  color: var(--se-muted);
}

.se-foot-stores .se-store-badge svg {
  height: 42px;
}

@media (max-width: 820px) {
  .se-home-hero-inner {
    grid-template-columns: 1fr;
    text-align: center;
    gap: 24px;
  }
  .se-home-hero-text h1 {
    font-size: 34px;
  }
  .se-home-hero-sub {
    margin-left: auto;
    margin-right: auto;
  }
  .se-home-hero-art {
    max-width: 420px;
    margin: 0 auto;
  }
  .se-home-feature,
  .se-home-feature-rev {
    grid-template-columns: 1fr;
    gap: 18px;
    text-align: center;
  }
  .se-home-feature-rev .se-home-feature-art {
    order: 0;
  }
  .se-home-feature-art svg {
    max-width: 300px;
    margin: 0 auto;
  }
}

/* Final responsive guard: account icon, compact page starts and mobile type. */
.se-topbar .se-person {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  flex: 0 0 auto !important;
  overflow: visible !important;
  opacity: 1 !important;
  visibility: visible !important;
  color: var(--se-muted);
  background: transparent !important;
}

.se-topbar .se-person:hover,
.se-topbar .se-person:focus-visible,
.se-topbar .se-person-in,
.se-topbar .se-person-in:hover,
.se-topbar .se-person-in:focus-visible {
  color: var(--se-purple) !important;
  background: transparent !important;
}

.se-topbar .se-person-icon {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 28px !important;
  height: 28px !important;
  min-width: 28px !important;
  flex: 0 0 28px !important;
  overflow: visible !important;
  color: currentColor !important;
}

.se-topbar .se-person-icon svg {
  display: block !important;
  width: 24px !important;
  height: 24px !important;
}

.se-topbar .se-person-avatar {
  display: block !important;
  width: 24px !important;
  height: 24px !important;
  min-width: 24px !important;
  flex: 0 0 24px !important;
  border-radius: 8px;
  object-fit: cover;
  box-shadow: 0 0 0 1px rgba(91, 143, 232, 0.2);
}

@media (max-width: 760px) {
  .se-page h1 {
    font-size: clamp(24px, 7vw, 42px) !important;
    line-height: 1.12 !important;
    letter-spacing: 0 !important;
  }

  .se-page h2 {
    font-size: clamp(20px, 5.6vw, 32px) !important;
    line-height: 1.16 !important;
    letter-spacing: 0 !important;
  }

  .se-page h3 {
    font-size: clamp(17px, 4.8vw, 22px) !important;
    line-height: 1.2 !important;
    letter-spacing: 0 !important;
  }

  .se-home-live-hero {
    padding-top: 8px !important;
    padding-bottom: 16px !important;
    gap: 8px !important;
  }

  .se-home-live-copy h1 {
    margin-top: 0 !important;
    margin-bottom: 9px !important;
  }

  .se-content.se-home-highlight,
  .se-content.se-results-page {
    padding-top: 12px !important;
  }

  .se-results-head {
    margin-top: 0 !important;
    margin-bottom: 12px !important;
  }

  .se-results-head p {
    margin-top: 8px !important;
  }

  .se-topbar .se-person {
    width: 38px !important;
    min-width: 38px !important;
    height: 42px !important;
    flex: 0 0 38px !important;
    padding: 0 !important;
  }

  .se-topbar .se-person-label {
    display: none !important;
  }
}

@media (max-width: 420px) {
  .se-page h1 {
    font-size: clamp(23px, 7.4vw, 34px) !important;
  }

  .se-page h2 {
    font-size: clamp(19px, 6vw, 26px) !important;
  }

  .se-home-live-hero {
    padding-top: 4px !important;
  }

  .se-content.se-home-highlight,
  .se-content.se-results-page {
    padding-top: 8px !important;
  }

  .se-topbar .se-person {
    width: 35px !important;
    min-width: 35px !important;
    height: 40px !important;
    flex-basis: 35px !important;
  }

  .se-topbar .se-person-icon {
    width: 27px !important;
    height: 27px !important;
    min-width: 27px !important;
    flex-basis: 27px !important;
  }

  .se-topbar .se-person-icon svg {
    width: 25px !important;
    height: 25px !important;
  }

  .se-topbar .se-person-avatar {
    width: 27px !important;
    height: 27px !important;
    min-width: 27px !important;
    flex-basis: 27px !important;
  }
}

/* Final homepage mobile spacing pass. */
@media (max-width: 760px) {
  .se-page > .se-home-live-hero:first-of-type {
    margin-top: 0 !important;
    padding-top: 0 !important;
  }

  .se-page > .se-topbar + .se-home-live-hero {
    margin-top: -4px !important;
    padding-top: 0 !important;
  }

  .se-home-live-copy {
    max-width: none !important;
  }

  .se-home-live-btn {
    margin-top: 2px !important;
  }

  .se-home-photo-stage {
    margin-top: 20px !important;
  }

  .se-home-highlight {
    padding-top: 6px !important;
  }

  .se-home-highlight .se-home-section-head {
    display: grid !important;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: center !important;
    column-gap: 10px !important;
    row-gap: 5px !important;
    margin-bottom: 12px !important;
  }

  .se-home-highlight .se-hc-eyebrow {
    grid-column: 1 / -1;
    width: max-content;
    max-width: 100%;
    font-size: 10px !important;
    padding: 4px 8px !important;
  }

  .se-home-highlight .se-home-section-head h2 {
    min-width: 0;
    margin: 0 !important;
    font-family: var(--se-font) !important;
    font-size: clamp(17px, 4.25vw, 22px) !important;
    line-height: 1.05 !important;
    white-space: nowrap !important;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .se-home-highlight .se-home-section-head a {
    margin: 0 !important;
    font-size: 12px !important;
    line-height: 1 !important;
  }

  .se-content.se-results-page {
    padding-top: 0 !important;
    margin-top: -4px !important;
  }

  .se-results-head h1 {
    font-size: clamp(22px, 6vw, 34px) !important;
  }
}

@media (max-width: 420px) {
  .se-page > .se-home-live-hero:first-of-type {
    padding-top: 0 !important;
  }

  .se-home-photo-stage {
    margin-top: 24px !important;
  }

  .se-home-highlight .se-home-section-head h2 {
    font-size: clamp(15px, 4.05vw, 17px) !important;
  }

  .se-home-highlight .se-home-section-head a {
    font-size: 11px !important;
  }
}

/* Final mobile header alignment: same slot, same gap, same vertical center. */
@media (max-width: 500px) {
  .se-topbar {
    padding-top: 3px !important;
    padding-bottom: 3px !important;
    margin-bottom: -8px !important;
  }

  .se-topbar-inner,
  .se-topbar-bar {
    min-height: 44px !important;
  }

  .se-topbar-bar {
    align-items: center !important;
  }

  .se-topbar-right {
    min-width: 0 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: flex-end !important;
    gap: 0 !important;
  }

  .se-header-main-block,
  .se-header-actions {
    display: flex !important;
    align-items: center !important;
    justify-content: flex-end !important;
    gap: 4px !important;
    margin-left: 0 !important;
  }

  .se-header-actions .se-locale,
  .se-topbar-right > .se-locale,
  .se-locale {
    display: block !important;
  }

  .se-search-toggle,
  .se-ticket-quick,
  .se-locale-btn,
  .se-topbar .se-person,
  .se-burger {
    width: 36px !important;
    min-width: 36px !important;
    height: 40px !important;
    min-height: 40px !important;
    flex: 0 0 36px !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    padding: 0 !important;
    margin: 0 !important;
    border: 0 !important;
    background: transparent !important;
    box-shadow: none !important;
  }

  .se-locale-btn,
  .se-topbar .se-person {
    flex-direction: column !important;
    align-items: center !important;
    justify-content: flex-start !important;
    padding-top: 12px !important;
  }

  .se-locale-btn {
    gap: 1px !important;
  }

  .se-topbar .se-person {
    gap: 2px !important;
  }

  .se-search-toggle svg,
  .se-ticket-quick svg {
    width: 24px !important;
    height: 24px !important;
  }

  .se-topbar .se-person-icon,
  .se-topbar .se-person-avatar {
    width: 23px !important;
    min-width: 23px !important;
    height: 23px !important;
    flex: 0 0 23px !important;
  }

  .se-topbar .se-person-icon {
    height: 23px !important;
    min-height: 23px !important;
    flex-basis: 23px !important;
  }

  .se-topbar .se-person-icon svg {
    width: 22px !important;
    height: 22px !important;
  }

  .se-topbar .se-person-avatar {
    border-radius: 7px !important;
  }

  .se-topbar .se-person-label {
    display: block !important;
    max-width: 36px !important;
    color: currentColor !important;
    font-size: 8.5px !important;
    font-weight: 800 !important;
    line-height: 1 !important;
    text-align: center !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: clip !important;
  }

  .se-locale-flag {
    display: block !important;
    font-size: 17px !important;
    line-height: 1 !important;
    height: 17px !important;
  }

  .se-locale-code {
    display: block !important;
    font-size: 8.5px !important;
    font-weight: 850 !important;
    line-height: 1 !important;
    text-transform: uppercase !important;
  }

  .se-locale-caret {
    display: none !important;
  }

  .se-burger {
    gap: 5px !important;
  }

  .se-burger span {
    width: 21px !important;
  }

  .se-page > .se-topbar + .se-home-live-hero,
  .se-page > .se-topbar + .se-content.se-results-page {
    margin-top: -8px !important;
  }
}

@media (max-width: 370px) {
  .se-header-main-block,
  .se-header-actions {
    gap: 3px !important;
  }

  .se-search-toggle,
  .se-ticket-quick,
  .se-locale-btn,
  .se-topbar .se-person,
  .se-burger {
    width: 35px !important;
    min-width: 35px !important;
    flex-basis: 35px !important;
  }
}

/* Final event card polish: closer to the compact app card typography. */
.se-event-grid {
  grid-template-columns: repeat(auto-fill, minmax(190px, 1fr)) !important;
  gap: 14px !important;
}

.se-event-card {
  border-color: #edf0f7 !important;
  border-radius: 12px !important;
  padding: 6px !important;
  box-shadow: 0 8px 18px rgba(27, 37, 89, 0.05) !important;
}

.se-event-card:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 12px 24px rgba(27, 37, 89, 0.08) !important;
}

.se-event-card-media {
  border-radius: 6px !important;
}

.se-event-card-body {
  min-height: 98px !important;
  padding: 8px 2px 2px !important;
}

.se-event-card-body h3 {
  display: -webkit-box;
  margin: 0 !important;
  color: #1f2430 !important;
  font-size: 13.5px !important;
  font-weight: 650 !important;
  line-height: 1.28 !important;
  letter-spacing: 0 !important;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.se-event-card-location {
  margin-top: 5px !important;
  color: #6b7280 !important;
  font-size: 11.5px !important;
  font-weight: 600 !important;
  line-height: 1.2 !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.se-event-card-foot {
  margin-top: 8px !important;
  color: #5b8fe8 !important;
  font-size: 11.5px !important;
  font-weight: 800 !important;
  line-height: 1.1 !important;
}

.se-event-date-badge,
.se-event-kind-badge {
  top: 8px !important;
  padding: 5px 7px !important;
  font-size: 10px !important;
  font-weight: 850 !important;
}

.se-event-date-badge {
  left: 8px !important;
}

.se-event-kind-badge {
  right: 8px !important;
}

@media (max-width: 760px) {
  .se-event-grid {
    gap: 10px !important;
  }

  .se-event-card {
    border-radius: 10px !important;
    padding: 5px !important;
  }

  .se-event-card-body {
    min-height: 92px !important;
    padding-top: 7px !important;
  }

  .se-event-card-body h3 {
    font-size: 12.5px !important;
    line-height: 1.3 !important;
  }

  .se-event-card-location,
  .se-event-card-foot {
    font-size: 10.8px !important;
  }
}

/* ------------------------------------------------------------------ app gate */
/* "Use the app" interstitial (AppDownloadModal): slides up over event and
   ticket pages on every visit. Bottom sheet on phones, centered slide-up
   dialog on larger screens. */
.se-appgate-backdrop {
  position: fixed;
  inset: 0;
  z-index: 5000;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  background: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(3px);
  animation: se-appgate-fade 0.22s ease both;
}

.se-appgate-sheet {
  position: relative;
  width: 100%;
  max-width: 560px;
  max-height: min(88vh, 88dvh);
  overflow-y: auto;
  box-sizing: border-box;
  background: #fbfcff;
  color: #172033;
  border-radius: 22px 22px 0 0;
  padding: 18px 22px calc(24px + env(safe-area-inset-bottom, 0px));
  box-shadow: 0 -18px 60px rgba(15, 23, 42, 0.35);
  text-align: center;
  animation: se-appgate-rise 0.32s cubic-bezier(0.22, 0.9, 0.3, 1) both;
  outline: none;
}

.se-appgate-sheet h2 {
  margin: 6px 0 0;
  font-size: 22px;
  line-height: 1.25;
  letter-spacing: 0;
  color: #172033;
}

.se-appgate-grabber {
  display: block;
  width: 44px;
  height: 5px;
  margin: 0 auto 14px;
  border-radius: 999px;
  background: #d5dae6;
}

.se-appgate-close {
  position: absolute;
  top: 14px;
  right: 14px;
  width: 34px;
  height: 34px;
  border: 0;
  border-radius: 50%;
  background: #eef1f7;
  color: #4b5568;
  font-size: 15px;
  line-height: 1;
  cursor: pointer;
  transition: background 0.15s ease;
}

.se-appgate-close:hover {
  background: #e2e7f0;
}

.se-appgate-badge {
  width: 68px;
  height: 68px;
  margin: 2px auto 10px;
  border-radius: 18px;
  overflow: hidden;
  background: #172033;
  border: 1px solid rgba(91, 143, 232, 0.18);
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.18);
}

.se-appgate-badge img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.se-appgate-eyebrow {
  display: block;
  width: max-content;
  max-width: 100%;
  margin: 0 auto 12px;
  background: #eaf1ff;
  border-color: #cddcf9;
  color: #345fbf;
}

.se-appgate-text {
  margin: 10px auto 0;
  max-width: 44ch;
  font-size: 14.5px;
  line-height: 1.55;
  color: var(--se-muted, #5b6474);
}

.se-appgate-actions {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  margin-top: 18px;
}

.se-appgate-primary {
  width: 100%;
  max-width: 320px;
  border: 0;
  border-radius: 12px;
  padding: 13px 18px;
  background: #345fbf;
  color: #fff;
  font-size: 15px;
  font-weight: 800;
  cursor: pointer;
  transition: background 0.15s ease, transform 0.06s ease;
}

.se-appgate-primary:hover {
  background: #284fa5;
}

.se-appgate-primary:active {
  transform: scale(0.98);
}

.se-appgate-hint {
  font-size: 12.5px;
  font-weight: 700;
  color: #5b6474;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.se-appgate-badges svg {
  height: 44px;
}

.se-appgate-ghost {
  border: 0;
  background: none;
  padding: 8px 12px;
  color: #5b6474;
  font-size: 13.5px;
  font-weight: 600;
  text-decoration: underline;
  cursor: pointer;
}

.se-appgate-ghost:hover {
  color: #172033;
}

/* Desktop / laptop: centered dialog card that still slides up into place. */
@media (min-width: 641px) {
  .se-appgate-backdrop {
    align-items: center;
    padding: 24px;
  }

  .se-appgate-sheet {
    max-width: 480px;
    border-radius: 22px;
    padding: 26px 30px 30px;
    box-shadow: 0 28px 80px rgba(15, 23, 42, 0.4);
  }

  .se-appgate-grabber {
    display: none;
  }
}

@media (max-width: 380px) {
  .se-appgate-sheet h2 {
    font-size: 19px;
  }

  .se-appgate-badges svg {
    height: 40px;
  }
}

@keyframes se-appgate-fade {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes se-appgate-rise {
  from { transform: translateY(48px); opacity: 0.4; }
  to { transform: translateY(0); opacity: 1; }
}

@media (prefers-reduced-motion: reduce) {
  .se-appgate-backdrop,
  .se-appgate-sheet {
    animation: none;
  }
}

/* ========================================================== TheBowlingClub */
/* Landing page /thebowlingclub. Palette from the TheBowlingClub logo
   (NOT the Main Events brand colors):
     yellow #ffc400   red #e12e2e   sky-blue #2fa8e1   deep navy #0e1f45 */
.se-tbc {
  --tbc-yellow: #ffc400;
  --tbc-red: #e12e2e;
  --tbc-blue: #2fa8e1;
  --tbc-navy: #0e1f45;
  --tbc-navy-2: #16295e;
  --tbc-surface: #f4f7fc;
}

/* hero — dark "bowling alley" band with the big logo below the site header */
.se-tbc-hero {
  position: relative;
  overflow: hidden;
  background:
    radial-gradient(900px 380px at 15% -10%, rgba(47, 168, 225, 0.35), transparent 60%),
    radial-gradient(900px 380px at 85% 110%, rgba(225, 46, 46, 0.28), transparent 60%),
    linear-gradient(160deg, var(--tbc-navy) 0%, var(--tbc-navy-2) 55%, #0a1734 100%);
  border-bottom: 4px solid var(--tbc-yellow);
  text-align: center;
}

/* neon lane stripes, echoing the alley photo in the brochure */
.se-tbc-hero-glow {
  position: absolute;
  inset: 0;
  background:
    linear-gradient(105deg, transparent 12%, rgba(47, 168, 225, 0.14) 12.5%, transparent 13.5%),
    linear-gradient(105deg, transparent 30%, rgba(255, 196, 0, 0.1) 30.5%, transparent 31.5%),
    linear-gradient(105deg, transparent 82%, rgba(225, 46, 46, 0.14) 82.5%, transparent 83.5%);
  pointer-events: none;
}

.se-tbc-hero-inner {
  position: relative;
  z-index: 1;
  max-width: 980px;
  margin: 0 auto;
  padding: 56px 24px 60px;
}

.se-tbc-eyebrow {
  display: inline-block;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: var(--tbc-yellow);
  background: rgba(255, 196, 0, 0.12);
  border: 1px solid rgba(255, 196, 0, 0.45);
  border-radius: 999px;
  padding: 5px 14px;
  margin-bottom: 26px;
}

/* the "big image below the header" — full-width wide logo */
.se-tbc-hero-logo {
  display: block;
  width: min(680px, 92%);
  height: auto;
  margin: 0 auto 26px;
  border-radius: 18px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.45);
}

.se-tbc-hero h1 {
  margin: 0 0 12px;
  font-size: 40px;
  line-height: 1.1;
  letter-spacing: -0.5px;
  color: #fff;
}

.se-tbc-hero-sub {
  margin: 0 auto 26px;
  max-width: 56ch;
  font-size: 18px;
  line-height: 1.55;
  color: rgba(255, 255, 255, 0.92);
}

.se-tbc-cta-row {
  display: flex;
  justify-content: center;
  gap: 14px;
  flex-wrap: wrap;
}

.se-tbc-cta {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: var(--tbc-red);
  color: #fff;
  border-radius: 12px;
  padding: 13px 24px;
  font-weight: 800;
  font-size: 15px;
  text-decoration: none;
  box-shadow: 0 8px 22px rgba(225, 46, 46, 0.35);
  transition: transform 0.12s ease;
}

.se-tbc-cta:hover {
  transform: translateY(-1px);
}

.se-tbc-cta-ghost {
  background: transparent;
  border: 2px solid var(--tbc-blue);
  color: var(--tbc-blue);
  box-shadow: none;
}

/* content sections */
.se-tbc-content.se-content {
  max-width: 980px;
}

.se-tbc-section {
  margin: 40px 0;
}

.se-tbc .se-tbc-content h2 {
  color: var(--tbc-navy);
  border-left: 6px solid var(--tbc-yellow);
  padding-left: 14px;
  font-size: 26px;
  margin: 0 0 16px;
}

.se-tbc-lead {
  font-size: 18px;
  line-height: 1.65;
}

/* brand strip: Seuytel → Main Events → TheBowlingClub */
.se-tbc-brands {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 18px;
  flex-wrap: wrap;
  padding: 26px 18px;
  background: var(--tbc-surface);
  border: 1px solid var(--se-border);
  border-radius: var(--se-radius);
}

.se-tbc-brand {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  min-width: 150px;
}

.se-tbc-brand img {
  height: 54px;
  width: auto;
  max-width: 220px;
  object-fit: contain;
}

.se-tbc-brand-link {
  font-size: 30px;
  font-weight: 800;
  color: var(--tbc-blue);
  line-height: 1;
}

.se-tbc-brand-caption {
  text-align: center;
  color: var(--se-muted);
  margin: 14px 0 0;
}

/* about cards */
.se-tbc-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 18px;
}

.se-tbc-card {
  background: #fff;
  border: 1px solid var(--se-border);
  border-top: 5px solid var(--tbc-blue);
  border-radius: var(--se-radius);
  padding: 22px 24px;
  box-shadow: var(--se-shadow-sm);
}

.se-tbc-card + .se-tbc-card,
.se-tbc-cards .se-tbc-card:nth-child(2) {
  border-top-color: var(--tbc-red);
}

.se-tbc-card h3 {
  margin: 0 0 10px;
  color: var(--tbc-navy);
}

/* tournament text + bowler image */
.se-tbc-split {
  display: flex;
  gap: 26px;
  align-items: flex-start;
}

.se-tbc-split-img {
  flex: 0 0 240px;
  width: 240px;
  border-radius: var(--se-radius);
  box-shadow: var(--se-shadow);
}

/* line-up stat cards (8 / 5 / 3) */
.se-tbc-lineup {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 18px;
  margin: 20px 0 24px;
}

.se-tbc-lineup-card {
  background: var(--tbc-navy);
  color: #fff;
  border-radius: var(--se-radius);
  padding: 22px 24px;
  border-top: 6px solid var(--tbc-blue);
}

.se-tbc-lineup-card.se-tbc-accent-red { border-top-color: var(--tbc-red); }
.se-tbc-lineup-card.se-tbc-accent-yellow { border-top-color: var(--tbc-yellow); }
.se-tbc-lineup-card.se-tbc-accent-blue { border-top-color: var(--tbc-blue); }

.se-tbc-lineup-count {
  display: block;
  font-size: 44px;
  font-weight: 900;
  line-height: 1;
  margin-bottom: 8px;
}

.se-tbc-accent-red .se-tbc-lineup-count { color: var(--tbc-red); }
.se-tbc-accent-yellow .se-tbc-lineup-count { color: var(--tbc-yellow); }
.se-tbc-accent-blue .se-tbc-lineup-count { color: var(--tbc-blue); }

.se-tbc-lineup-card h3 {
  margin: 0 0 8px;
  color: #fff;
  font-size: 17px;
}

.se-tbc-lineup-card p {
  margin: 0;
  font-size: 14.5px;
  line-height: 1.55;
  color: rgba(255, 255, 255, 0.88);
}

/* sponsoring brochure band */
.se-tbc-pdf {
  display: flex;
  align-items: center;
  gap: 24px;
  background: linear-gradient(135deg, var(--tbc-navy) 0%, var(--tbc-navy-2) 100%);
  border-radius: var(--se-radius);
  padding: 28px 30px;
  color: #fff;
}

.se-tbc-pdf-icon {
  flex: 0 0 72px;
  width: 72px;
  height: 72px;
}

.se-tbc-pdf-icon svg {
  width: 100%;
  height: 100%;
}

.se-tbc .se-tbc-pdf h2 {
  color: #fff;
  border-left-color: var(--tbc-red);
}

.se-tbc-pdf-body p {
  color: rgba(255, 255, 255, 0.9);
  margin: 0 0 16px;
}

/* contact band */
.se-tbc-contact {
  background: var(--tbc-surface);
  border: 1px solid var(--se-border);
  border-radius: var(--se-radius);
  padding: 26px 30px;
}

.se-tbc-mail-row {
  display: flex;
  gap: 14px;
  flex-wrap: wrap;
  margin-top: 14px;
}

.se-tbc-mail {
  display: inline-flex;
  flex-direction: column;
  gap: 2px;
  background: #fff;
  border: 1px solid var(--se-border);
  border-left: 5px solid var(--tbc-blue);
  border-radius: var(--se-radius-sm);
  padding: 12px 18px;
  font-weight: 700;
  color: var(--tbc-navy);
  text-decoration: none;
  box-shadow: var(--se-shadow-sm);
}

.se-tbc-mail + .se-tbc-mail {
  border-left-color: var(--tbc-red);
}

.se-tbc-mail small {
  font-weight: 500;
  color: var(--se-muted);
}

.se-tbc-mail:hover {
  transform: translateY(-1px);
}

@media (max-width: 720px) {
  .se-tbc-hero h1 {
    font-size: 30px;
  }

  /* stack the brand logos vertically; the chevron rotates to point down
     (the "reversed ^") and sits below each logo instead of beside it */
  .se-tbc-brands {
    flex-direction: column;
  }

  .se-tbc-brand-link {
    transform: rotate(90deg);
  }

  .se-tbc-split {
    flex-direction: column;
  }

  .se-tbc-split-img {
    width: min(280px, 70%);
    margin: 0 auto;
  }

  .se-tbc-pdf {
    flex-direction: column;
    text-align: center;
  }

  .se-tbc .se-tbc-pdf h2,
  .se-tbc .se-tbc-content h2 {
    border-left: none;
    padding-left: 0;
  }
}

/* ====================================================== Wir die Braunschweiger */
/* Landing page /we-the-people/wir-die-braunschweiger. Civic, local and social:
   Braunschweig red/yellow plus Main Events blue/purple as platform accents. */
.se-wdb {
  --wdb-ink: #121826;
  --wdb-muted: #596275;
  --wdb-red: #d12b2b;
  --wdb-red-dark: #9f1f1f;
  --wdb-yellow: #ffc400;
  --wdb-yellow-soft: #fff5cf;
  --wdb-blue: var(--se-blue, #5b8fe8);
  --wdb-purple: var(--se-purple, #6c3dd3);
  --wdb-paper: #fff9e8;
  --wdb-soft: #f2f6ff;
  --wdb-main-grad: linear-gradient(135deg, var(--wdb-blue) 0%, var(--wdb-purple) 100%);
  background: #fff;
  color: var(--wdb-ink);
}

.se-wdb-hero {
  position: relative;
  min-height: min(76vh, 760px);
  display: flex;
  align-items: center;
  background-size: cover;
  background-position: center;
  border-bottom: 6px solid var(--wdb-yellow);
  box-shadow: inset 0 -1px 0 rgba(91, 143, 232, 0.38);
}

.se-wdb-hero-inner {
  width: min(1040px, calc(100% - 48px));
  margin: 0 auto;
  padding: 74px 0 88px;
  color: var(--wdb-ink);
}

.se-wdb-eyebrow,
.se-wdb-kicker {
  display: inline-flex;
  align-items: center;
  width: fit-content;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 0;
  text-transform: uppercase;
}

.se-wdb-eyebrow {
  margin-bottom: 24px;
  padding: 7px 14px;
  background: #fff;
  border: 1px solid rgba(209, 43, 43, 0.26);
  color: var(--wdb-red);
  box-shadow: 0 8px 20px rgba(18, 24, 38, 0.08);
}

.se-wdb-kicker {
  margin-bottom: 12px;
  color: var(--wdb-blue);
}

.se-wdb-hero h1 {
  max-width: 780px;
  margin: 0;
  color: var(--wdb-ink);
  font-size: clamp(42px, 7vw, 86px);
  line-height: 0.96;
  letter-spacing: 0;
}

.se-wdb-hero p {
  max-width: 690px;
  margin: 24px 0 0;
  padding: 16px 18px;
  color: #252d3d;
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(255, 196, 0, 0.52);
  border-left: 6px solid var(--wdb-yellow);
  border-radius: 8px;
  font-size: clamp(18px, 2vw, 23px);
  line-height: 1.5;
  box-shadow: 0 16px 36px rgba(18, 24, 38, 0.12);
}

.se-wdb-cta-row {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 30px;
}

.se-wdb-cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
  padding: 0 22px;
  border-radius: 8px;
  border: 2px solid var(--wdb-red);
  background: linear-gradient(135deg, var(--wdb-red) 0%, var(--wdb-red-dark) 100%);
  color: #fff;
  font-size: 15px;
  font-weight: 900;
  text-decoration: none;
  box-shadow: 0 10px 24px rgba(198, 40, 40, 0.24);
  transition: transform 0.14s ease, background 0.14s ease;
}

.se-wdb-cta:hover {
  transform: translateY(-1px);
  background: linear-gradient(135deg, #b92323 0%, #851818 100%);
}

.se-wdb-cta-light {
  border-color: var(--wdb-blue);
  background: #fff;
  color: var(--wdb-blue);
  box-shadow: 0 10px 22px rgba(91, 143, 232, 0.12);
}

.se-wdb-cta-light:hover {
  background: #eef4ff;
}

.se-wdb-content.se-content {
  max-width: 1080px;
}

.se-wdb-intro {
  display: grid;
  grid-template-columns: minmax(250px, 0.8fr) minmax(280px, 1.2fr);
  gap: 36px;
  align-items: start;
  padding: 46px 0 24px;
}

.se-wdb h2 {
  margin: 0;
  color: var(--wdb-ink);
  font-size: clamp(26px, 4vw, 42px);
  line-height: 1.08;
  letter-spacing: 0;
}

.se-wdb h3 {
  margin: 0;
  color: var(--wdb-ink);
  font-size: 18px;
  line-height: 1.25;
}

.se-wdb p {
  color: var(--wdb-muted);
  line-height: 1.68;
}

.se-wdb-intro p {
  margin: 0;
  font-size: 17px;
}

.se-wdb-band {
  display: grid;
  grid-template-columns: minmax(280px, 0.92fr) minmax(300px, 1.08fr);
  gap: 28px;
  align-items: stretch;
  margin: 34px 0 52px;
  background: var(--wdb-paper);
  border: 1px solid #f0dfb8;
  border-left: 8px solid var(--wdb-yellow);
  border-top: 1px solid rgba(91, 143, 232, 0.2);
  border-radius: 8px;
  overflow: hidden;
}

.se-wdb-band-text {
  padding: 34px;
}

.se-wdb-band-text p {
  margin-bottom: 0;
}

.se-wdb-band img,
.se-wdb-image-row img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.se-wdb-section {
  margin: 54px 0;
}

.se-wdb-section-head {
  max-width: 760px;
  margin-bottom: 22px;
}

.se-wdb-format-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 14px;
}

.se-wdb-card {
  min-height: 190px;
  background: #fff;
  border: 1px solid var(--se-border);
  border-top: 5px solid var(--wdb-blue);
  border-radius: 8px;
  padding: 22px;
  box-shadow: var(--se-shadow-sm);
}

.se-wdb-card:nth-child(2n) {
  border-top-color: var(--wdb-red);
}

.se-wdb-card:nth-child(3n) {
  border-top-color: var(--wdb-yellow);
}

.se-wdb-card:nth-child(4n) {
  border-top-color: var(--wdb-purple);
}

.se-wdb-card p {
  margin: 10px 0 0;
  font-size: 14.5px;
}

.se-wdb-image-row {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
  margin: 46px 0;
}

.se-wdb-image-row figure {
  margin: 0;
  overflow: hidden;
  background: #fff;
  border-radius: 8px;
  border: 1px solid var(--se-border);
  box-shadow: var(--se-shadow-sm);
}

.se-wdb-image-row img {
  aspect-ratio: 16 / 10;
}

.se-wdb-image-row figcaption {
  padding: 14px 16px 16px;
  color: var(--wdb-muted);
  font-size: 14px;
  line-height: 1.45;
}

.se-wdb-principles {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
  gap: 12px;
}

.se-wdb-principle {
  background: var(--wdb-soft);
  border: 1px solid #dce7fb;
  border-left: 5px solid var(--wdb-blue);
  border-radius: 8px;
  padding: 18px;
  color: #273c66;
  font-weight: 750;
  line-height: 1.45;
}

.se-wdb-program {
  display: grid;
  grid-template-columns: minmax(260px, 0.82fr) minmax(320px, 1.18fr);
  gap: 30px;
  align-items: start;
  margin: 60px 0;
  padding: 34px;
  background:
    linear-gradient(135deg, rgba(91, 143, 232, 0.18), rgba(108, 61, 211, 0.14)),
    #142033;
  border-top: 5px solid var(--wdb-red);
  border-bottom: 5px solid var(--wdb-yellow);
  border-radius: 8px;
}

.se-wdb-program h2,
.se-wdb-program h3 {
  color: #fff;
}

.se-wdb-program .se-wdb-kicker {
  color: #f6c84f;
}

.se-wdb-program p {
  color: rgba(255, 255, 255, 0.78);
}

.se-wdb-steps {
  display: grid;
  gap: 12px;
}

.se-wdb-step {
  display: grid;
  grid-template-columns: 54px 1fr;
  gap: 12px 16px;
  padding: 18px;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 196, 0, 0.18);
  border-radius: 8px;
}

.se-wdb-step span {
  grid-row: span 2;
  color: var(--wdb-yellow);
  font-size: 24px;
  font-weight: 950;
}

.se-wdb-step p {
  margin: 2px 0 0;
  font-size: 14px;
}

.se-wdb-audiences {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.se-wdb-audiences span {
  display: inline-flex;
  align-items: center;
  min-height: 38px;
  padding: 0 14px;
  border-radius: 999px;
  background: var(--wdb-yellow-soft);
  border: 1px solid #f0d18a;
  color: #744800;
  font-weight: 850;
  font-size: 14px;
}

.se-wdb-hosts {
  box-sizing: border-box;
  display: flex;
  gap: 24px;
  align-items: center;
  justify-content: space-between;
  margin: 60px 0 34px;
  padding: 30px;
  background:
    linear-gradient(135deg, rgba(255, 196, 0, 0.16) 0%, rgba(91, 143, 232, 0.14) 55%, rgba(108, 61, 211, 0.1) 100%),
    #fff;
  border: 1px solid #d9e4f8;
  border-left: 8px solid var(--wdb-red);
  border-radius: 8px;
}

.se-wdb-hosts-cta {
  box-sizing: border-box;
  flex: 0 1 240px;
  min-width: 190px;
  max-width: 260px;
  align-self: center;
  border-color: #173f7f;
  background: #173f7f;
  color: #ffffff;
  text-align: center;
  white-space: normal;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.32);
  box-shadow: 0 12px 26px rgba(23, 63, 127, 0.3);
}

.se-wdb-hosts-cta:hover {
  border-color: #123366;
  background: #123366;
  color: #ffffff;
}

.se-wdb-hosts-cta:visited,
.se-wdb-hosts-cta:focus,
.se-wdb-hosts-cta:active {
  color: #ffffff;
}

.se-wdb-hosts > div {
  max-width: 720px;
}

.se-wdb-hosts p {
  margin-bottom: 0;
}

.se-wdb-credit {
  margin: 20px 0 52px;
  border-top: 1px solid var(--se-border);
  padding-top: 14px;
}

.se-wdb-credit p {
  margin: 0;
  font-size: 12px;
  color: #7a8290;
}

@media (max-width: 760px) {
  .se-wdb-hero {
    min-height: 70vh;
    background-position: center;
  }

  .se-wdb-hero-inner {
    width: min(100% - 32px, 1040px);
    padding: 56px 0 66px;
  }

  .se-wdb-cta {
    width: 100%;
  }

  .se-wdb-intro,
  .se-wdb-band,
  .se-wdb-image-row,
  .se-wdb-program {
    grid-template-columns: 1fr;
  }

  .se-wdb-band img {
    min-height: 260px;
  }

  .se-wdb-band-text,
  .se-wdb-program {
    padding: 24px;
  }

  .se-wdb-card {
    min-height: auto;
  }

  .se-wdb-hosts {
    align-items: stretch;
    flex-direction: column;
    padding: 24px;
  }

  .se-wdb-hosts-cta {
    width: 100%;
    max-width: none;
    min-width: 0;
    flex-basis: auto;
    align-self: stretch;
    padding-left: 14px;
    padding-right: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/legal/legal.css"],"names":[],"mappings":"AAAA;;;;;+EAK+E;;AAE/E;EACE,oBAAoB;EACpB,kBAAkB;EAClB,4DAA4D;EAC5D,iEAAiE;EACjE,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,+CAA+C;EAC/C,iDAAiD;EACjD;qBACmB;AACrB;;AAEA,gFAAgF;AAChF;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,MAAM;EACN,oCAAoC;EACpC,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA,+EAA+E;AAC/E;EACE,+BAA+B;EAC/B,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,uBAAuB;EACvB,2BAA2B;EAC3B,kCAAkC;EAClC,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,+EAA+E;AAC/E;EACE,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,+BAA+B;EAC/B,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,+BAA+B;EAC/B,kCAAkC;EAClC,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,gFAAgF;AAChF;EACE,gBAAgB;EAChB,kCAAkC;EAClC,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,+EAA+E;AAC/E;EACE,sCAAsC;EACtC,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA,gFAAgF;AAChF;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,kCAAkC;EAClC,+BAA+B;EAC/B,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,kCAAkC;EAClC,kCAAkC;EAClC,2BAA2B;EAC3B,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kCAAkC;EAClC,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA,kFAAkF;AAClF;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,2EAA2E;AAC3E;6DAC6D;AAC7D;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA,+EAA+E;AAC/E,2EAA2E;AAC3E;EACE,eAAe;EACf,wBAAwB;EACxB,8EAA8E;EAC9E,8CAA8C;AAChD;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,qEAAqE;AACrE;EACE,yBAAyB;AAC3B;;AAEA,6EAA6E;AAC7E;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,YAAY;AACd;;AAEA,0CAA0C;AAC1C;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,6BAA6B;EAC7B,kCAAkC;EAClC,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,2BAA2B;EAC3B,kCAAkC;EAClC,kCAAkC;EAClC,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,4DAA4D;EAC5D,mBAAmB;EACnB,MAAM;EACN,cAAc;EACd,kCAAkC;EAClC,oBAAoB;EACpB,6BAA6B;EAC7B,iFAAiF;AACnF;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,sBAAsB;EACtB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,0BAA0B;EAC1B,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,sBAAsB;EACtB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,2BAA2B;EAC3B,kCAAkC;EAClC,kCAAkC;EAClC,4BAA4B;EAC5B,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA,kCAAkC;AAClC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,sBAAsB;EACtB,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;mDACmD;AACnD;EACE,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,SAAS;EACT,2BAA2B;EAC3B,qCAAqC;EACrC,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,aAAa;EACb,qCAAqC;EACrC,kCAAkC;EAClC,mBAAmB;EACnB,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,cAAc;AAChB;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA,4DAA4D;AAC5D;EACE,wCAAwC;AAC1C;AACA;EACE,UAAU;AACZ;AACA;EACE,0CAA0C;AAC5C;;AAEA;;wEAEwE;AACxE;EACE,eAAe;EACf,QAAQ;EACR,gBAAgB;EAChB,kCAAkC;EAClC,0BAA0B;EAC1B,UAAU;EACV,kBAAkB;EAClB,qDAAqD;EACrD,aAAa;AACf;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,uBAAuB;EACvB,2BAA2B;EAC3B,+CAA+C;EAC/C,2BAA2B;EAC3B,6DAA6D;EAC7D,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,sBAAsB;AACxB;;AAEA,iFAAiF;AACjF;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,aAAa;EACb,kCAAkC;EAClC,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA,8EAA8E;AAC9E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,0BAA0B;EAC1B,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;yCACyC;AACzC;EACE;;IAEE,aAAa;EACf;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;4EAC0E;EAC1E;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA,yEAAyE;EACzE;;;IAGE,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,0BAA0B;IAC1B,kBAAkB;EACpB;AACF;;AAEA;EACE,0EAA0E;EAC1E;IACE,aAAa;EACf;AACF;;AAEA,qFAAqF;AACrF;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,QAAQ;EACR,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,+BAA+B;EAC/B,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,mBAAmB;EACnB,6BAA6B;EAC7B,sBAAsB;EACtB,eAAe;AACjB;;AAEA;;EAEE,uBAAuB;EACvB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6DAA6D;EAC7D,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;;IAEE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;;;IAGE,aAAa;EACf;AACF;;AAEA;EACE;;;IAGE,aAAa;EACf;EACA;IACE,oBAAoB;IACpB,WAAW;IACX,eAAe;IACf,YAAY;IACZ,cAAc;IACd,sBAAsB;IACtB,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,QAAQ;EACV;EACA;IACE,YAAY;EACd;EACA;IACE,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA,yFAAyF;AACzF;;;EAGE,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;;;EAIE,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,QAAQ;EACR,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,uBAAuB;AACzB;;AAEA;;EAEE,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE;IACE,SAAS;EACX;EACA;IACE,SAAS;EACX;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;AACF;;AAEA;EACE;IACE,cAAc;IACd,QAAQ;IACR,iBAAiB;EACnB;EACA;;;IAGE,WAAW;IACX,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,UAAU;EACZ;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,SAAS;EACX;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,cAAc;IACd,eAAe;IACf,cAAc;EAChB;AACF;;AAEA,8FAA8F;AAC9F;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,oBAAoB;EACtB;EACA;;;IAGE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;;;IAGE,cAAc;EAChB;AACF;;AAEA,gFAAgF;AAChF;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,aAAa;IACb,yEAAyE;IACzE,mBAAmB;IACnB,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB,WAAW;EACb;EACA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;;IAEE,iBAAiB;EACnB;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,cAAc;IACd,yBAAyB;IACzB,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;EACA;IACE,cAAc;EAChB;AACF;;AAEA,sFAAsF;AACtF;;EAEE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;IACb,0CAA0C;IAC1C,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,0CAA0C;IAC1C,mBAAmB;IACnB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;IACb,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,oEAAoE;EACtE;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,QAAQ;IACR,iBAAiB;EACnB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,oBAAoB;IACpB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;IACR,gBAAgB;EAClB;;EAEA;;;;IAIE,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,MAAM;IACN,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;IACpB,YAAY;EACd;;EAEA;IACE,cAAc;IACd,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,cAAc;IACd,QAAQ;EACV;;EAEA;;;IAGE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA,kFAAkF;AAClF;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;;EAEE,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;;;EAGE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,uBAAuB;EACvB,qCAAqC;EACrC,sCAAsC;EACtC,yCAAyC;EACzC,8CAA8C;AAChD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,+BAA+B;IAC/B,QAAQ;IACR,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,cAAc;IACd,sCAAsC;EACxC;;EAEA;IACE,cAAc;IACd,WAAW;IACX,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,+BAA+B;IAC/B,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,cAAc;IACd,sCAAsC;EACxC;;EAEA;IACE,cAAc;IACd,WAAW;IACX,kBAAkB;EACpB;AACF;;AAEA,uCAAuC;AACvC;EACE,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mDAAmD;EACnD,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,2DAA2D;EAC3D,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,0EAA0E;AAC5E;;AAEA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,QAAQ;AACV;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;EACf,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,+CAA+C;AACjD;;AAEA;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,4BAA4B;EAC9B;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,gDAAgD;EAClD;;EAEA;;IAEE,0BAA0B;EAC5B;AACF;;AAEA;;mDAEmD;AACnD;EACE,YAAY;AACd;;AAEA;;EAEE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE;IACE,YAAY;IACZ,4BAA4B;EAC9B;;EAEA;IACE,eAAe;IACf,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,cAAc;IACd,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,wFAAwF;AAC1F;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE;IACE,mBAAmB;IACnB,uBAAuB;IACvB,wFAAwF;EAC1F;;EAEA;IACE,uBAAuB;IACvB,+BAA+B;IAC/B,mBAAmB;EACrB;AACF;;AAEA,wEAAwE;AACxE;EACE,4DAA4D;AAC9D;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,cAAc;IACd,yBAAyB;IACzB,QAAQ;IACR,YAAY;EACd;;EAEA;IACE,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,4DAA4D;IAC5D,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;IACpB,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,uBAAuB;IACvB,gBAAgB;EAClB;AACF;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,wFAAwF;AAC1F;;AAEA;EACE,qCAAqC;EACrC,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,mBAAmB;IACnB,uBAAuB;IACvB,wFAAwF;EAC1F;;EAEA;IACE,qCAAqC;IACrC,+BAA+B;IAC/B,mBAAmB;EACrB;AACF;;AAEA,iFAAiF;AACjF;;EAEE,oBAAoB;EACpB,cAAc;EACd,sBAAsB;EACtB,uBAAuB;EACvB,UAAU;EACV,mBAAmB;AACrB;;AAEA;;;;;EAKE,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;;EAEE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;;;;IAIE,WAAW;IACX,eAAe;EACjB;;EAEA;;;IAGE,QAAQ;EACV;AACF;;AAEA,yCAAyC;AACzC;EACE,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,8DAA8D;EAC9D,mBAAmB;EACnB,2BAA2B;EAC3B,iBAAiB;EACjB,cAAc;EACd,iFAAiF;EACjF,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,iCAAiC;EACjC,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,qDAAqD;EACrD,6CAA6C;EAC7C,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,oCAAoC;EACpC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA,mBAAmB,QAAQ,EAAE,OAAO,EAAE,UAAU,EAAE,mBAAmB,EAAE,wBAAwB,EAAE;AACjG,mBAAmB,SAAS,EAAE,QAAQ,EAAE,UAAU,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,sBAAsB,EAAE;AAC1H,mBAAmB,SAAS,EAAE,UAAU,EAAE,UAAU,EAAE,qBAAqB,EAAE,uBAAuB,EAAE,sBAAsB,EAAE;AAC9H,mBAAmB,UAAU,EAAE,WAAW,EAAE,UAAU,EAAE,eAAe,EAAE,wBAAwB,EAAE,sBAAsB,EAAE;;AAE3H;EACE,WAAW,cAAc,EAAE;EAC3B,MAAM,kBAAkB,EAAE;AAC5B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,mEAAmE;EACnE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,0DAA0D;EAC1D,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,8CAA8C;EAC9C,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oDAAoD;AACtD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;EAEE,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,8CAA8C;EAC9C,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,SAAS;EACT,oBAAoB;EACpB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,0BAA0B;EAC1B,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,yEAAyE;EACzE,0BAA0B;EAC1B,yDAAyD;AAC3D;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,KAAK,2BAA2B,EAAE;EAClC,OAAO,4BAA4B,EAAE;AACvC;;AAEA;EACE;IACE,0BAA0B;IAC1B,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gDAAgD;IAChD,SAAS;EACX;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,+CAA+C;IAC/C,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,aAAa;EACf;AACF;;AAEA,gFAAgF;AAChF;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,0BAA0B;EAC1B,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,0BAA0B;EAC1B,WAAW;EACX,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,2BAA2B;EAC3B,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,SAAS;EACT,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,yCAAyC;AAC3C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,2BAA2B;EAC3B,sDAAsD;AACxD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;EACd,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kCAAkC;EAClC,kBAAkB;EAClB,6BAA6B;EAC7B,sBAAsB;EACtB,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,uBAAuB;EACvB,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,2BAA2B;EAC3B,kCAAkC;EAClC,kCAAkC;EAClC,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,wDAAwD;AACxD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,+BAA+B;EAC/B,aAAa;AACf;;AAEA,+EAA+E;AAC/E,wEAAwE;AACxE;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,sEAAsE;AACtE;EACE,kBAAkB;EAClB,QAAQ;EACR;;;;;GAKC;AACH;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,WAAW;EACX,qCAAqC;EACrC,2CAA2C;EAC3C,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA,kCAAkC;AAClC;EACE,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,eAAe;AACjB;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,6BAA6B;EAC7B,kCAAkC;EAClC,+BAA+B;EAC/B,aAAa;EACb,qBAAqB;EACrB,cAAc;EACd,sDAAsD;AACxD;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,2CAA2C;AAC3C;EACE,kCAAkC;EAClC,kCAAkC;EAClC,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,0BAA0B;EAC1B,WAAW;EACX,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;AACjB;;AAEA,+EAA+E;AAC/E;EACE;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE;;;;KAIC;EACH;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,8BAA8B;IAC9B,kBAAkB;IAClB,SAAS;IACT,kBAAkB;EACpB;EACA;IACE,cAAc;EAChB;EACA;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,UAAU;EACZ;EACA;IACE,eAAe;IACf,4BAA4B;IAC5B,gBAAgB;EAClB;AACF;;AAEA;;gFAEgF;;AAEhF,8CAA8C;AAC9C;EACE,+BAA+B;EAC/B,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,iCAAiC;EACjC,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,wDAAwD;AAC1D;;AAEA,4CAA4C;AAC5C;EACE,iBAAiB;AACnB;;AAEA;gEACgE;AAChE;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,sDAAsD;AACxD;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,6BAA6B;EAC7B,kCAAkC;EAClC,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;EAC1B,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,0BAA0B;IAC1B,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,cAAc;EAChB;EACA;;IAEE,0BAA0B;IAC1B,SAAS;IACT,kBAAkB;EACpB;EACA;IACE,QAAQ;EACV;EACA;IACE,gBAAgB;IAChB,cAAc;EAChB;AACF;;AAEA,+EAA+E;AAC/E;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,yBAAyB;EACzB,4BAA4B;EAC5B,qBAAqB;EACrB,8BAA8B;EAC9B,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;;;;;EAKE,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,yBAAyB;EACzB,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;EACE;IACE,4CAA4C;IAC5C,4BAA4B;IAC5B,4BAA4B;EAC9B;;EAEA;IACE,8CAA8C;IAC9C,4BAA4B;IAC5B,4BAA4B;EAC9B;;EAEA;IACE,8CAA8C;IAC9C,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;IACE,2BAA2B;IAC3B,+BAA+B;IAC/B,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;IACxB,6BAA6B;EAC/B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;IACxB,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,0BAA0B;IAC1B,uBAAuB;IACvB,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,8CAA8C;EAChD;;EAEA;IACE,4CAA4C;EAC9C;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,0BAA0B;IAC1B,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,2BAA2B;EAC7B;AACF;;AAEA,wCAAwC;AACxC;EACE;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;;EAEA;IACE,2BAA2B;IAC3B,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;IACxB,0CAA0C;IAC1C,8BAA8B;IAC9B,2BAA2B;IAC3B,uBAAuB;IACvB,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,YAAY;IACZ,oBAAoB;IACpB,sCAAsC;IACtC,+CAA+C;IAC/C,4BAA4B;IAC5B,8BAA8B;IAC9B,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,oBAAoB;IACpB,0BAA0B;IAC1B,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;EAC7B;;EAEA;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,+CAA+C;EACjD;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,8EAA8E;AAC9E;EACE;IACE,2BAA2B;IAC3B,8BAA8B;IAC9B,8BAA8B;EAChC;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,uBAAuB;IACvB,wBAAwB;IACxB,8BAA8B;IAC9B,oCAAoC;IACpC,iBAAiB;EACnB;;EAEA;;IAEE,wBAAwB;IACxB,8BAA8B;IAC9B,oCAAoC;IACpC,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;;;IAGE,yBAAyB;EAC3B;;EAEA;;;;;IAKE,sBAAsB;IACtB,0BAA0B;IAC1B,uBAAuB;IACvB,2BAA2B;IAC3B,yBAAyB;IACzB,+BAA+B;IAC/B,8BAA8B;IAC9B,kCAAkC;IAClC,qBAAqB;IACrB,oBAAoB;IACpB,oBAAoB;IACpB,kCAAkC;IAClC,2BAA2B;EAC7B;;EAEA;;IAEE,iCAAiC;IACjC,8BAA8B;IAC9B,sCAAsC;IACtC,4BAA4B;EAC9B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;;IAEE,sBAAsB;IACtB,0BAA0B;IAC1B,uBAAuB;IACvB,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;IACvB,2BAA2B;IAC3B,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB;IACzB,0BAA0B;IAC1B,8BAA8B;IAC9B,2BAA2B;IAC3B,2BAA2B;IAC3B,yBAAyB;IACzB,6BAA6B;IAC7B,8BAA8B;IAC9B,2BAA2B;IAC3B,8BAA8B;EAChC;;EAEA;IACE,yBAAyB;IACzB,0BAA0B;IAC1B,yBAAyB;IACzB,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;IAC3B,2BAA2B;IAC3B,yBAAyB;IACzB,oCAAoC;EACtC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,2BAA2B;EAC7B;AACF;;AAEA;EACE;;IAEE,mBAAmB;EACrB;;EAEA;;;;;IAKE,sBAAsB;IACtB,0BAA0B;IAC1B,2BAA2B;EAC7B;AACF;;AAEA,wEAAwE;AACxE;EACE,uEAAuE;EACvE,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,uBAAuB;EACvB,wDAAwD;AAC1D;;AAEA;EACE,sCAAsC;EACtC,yDAAyD;AAC3D;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,yBAAyB;EACzB,4BAA4B;EAC5B,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;EAC5B,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,4BAA4B;EAC5B,2BAA2B;EAC3B,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,4BAA4B;EAC5B,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;;EAEE,mBAAmB;EACnB,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,8BAA8B;IAC9B,uBAAuB;EACzB;;EAEA;IACE,2BAA2B;IAC3B,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA;;IAEE,4BAA4B;EAC9B;AACF;;AAEA,gFAAgF;AAChF;;8BAE8B;AAC9B;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,kCAAkC;EAElC,0BAA0B;EAC1B,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,4BAA4B;EAC5B,gEAAgE;EAChE,+CAA+C;EAC/C,kBAAkB;EAClB,qEAAqE;EACrE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,4EAA4E;AAC5E;EACE;IACE,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,6CAA6C;EAC/C;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,OAAO,2BAA2B,EAAE,YAAY,EAAE;EAClD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF;;AAEA,8EAA8E;AAC9E;;0EAE0E;AAC1E;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,6EAA6E;AAC7E;EACE,kBAAkB;EAClB,gBAAgB;EAChB;;;oFAGkF;EAClF,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA,+DAA+D;AAC/D;EACE,kBAAkB;EAClB,QAAQ;EACR;;;8FAG4F;EAC5F,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,wBAAwB;EACxB,mCAAmC;EACnC,yCAAyC;EACzC,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,4DAA4D;AAC5D;EACE,cAAc;EACd,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;EAC1B,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,8CAA8C;EAC9C,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,iCAAiC;EACjC,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,wCAAwC;EACxC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA,wDAAwD;AACxD;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,8BAA8B;EAC9B,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,qCAAqC;EACrC,+BAA+B;EAC/B,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,WAAW;EACX,+BAA+B;EAC/B,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA,wCAAwC,gCAAgC,EAAE;AAC1E,2CAA2C,mCAAmC,EAAE;AAChF,yCAAyC,iCAAiC,EAAE;;AAE5E;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA,0CAA0C,qBAAqB,EAAE;AACjE,6CAA6C,wBAAwB,EAAE;AACvE,2CAA2C,sBAAsB,EAAE;;AAEnE;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,+EAA+E;EAC/E,+BAA+B;EAC/B,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,kCAAkC;EAClC,sCAAsC;EACtC,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;uEACqE;EACrE;IACE,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;;IAEE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA,kFAAkF;AAClF;8EAC8E;AAC9E;EACE,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;EACrB,0BAA0B;EAC1B,mCAAmC;EACnC,uCAAuC;EACvC,oBAAoB;EACpB,mBAAmB;EACnB,oFAAoF;EACpF,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,2BAA2B;EAC3B,0CAA0C;EAC1C,mDAAmD;AACrD;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,yCAAyC;EACzC,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,qBAAqB;EACrB,iCAAiC;EACjC,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,oCAAoC;EACpC,yCAAyC;EACzC,wCAAwC;EACxC,kBAAkB;EAClB,iCAAiC;EACjC,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gCAAgC;EAChC,gFAAgF;EAChF,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,+CAA+C;EAC/C,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,6DAA6D;AAC/D;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,sBAAsB;EACtB,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gEAAgE;EAChE,SAAS;EACT,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,iCAAiC;EACjC,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kEAAkE;EAClE,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,4BAA4B;EAC5B,yBAAyB;EACzB,wCAAwC;EACxC,6CAA6C;EAC7C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;EAClC,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,sCAAsC;EACtC,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,kEAAkE;EAClE,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb;;WAES;EACT,oCAAoC;EACpC,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,cAAc;EACd,aAAa;EACb,qCAAqC;EACrC,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,kCAAkC;EAClC,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb;;QAEM;EACN,yBAAyB;EACzB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;IACE,gBAAgB;IAChB,2BAA2B;EAC7B;;EAEA;IACE,+BAA+B;IAC/B,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;;;;IAIE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;EACrB;AACF","sourcesContent":["/* ============================================================================\n   Seuytel / MainEvents — shared legal + cookie-consent styles\n   Brand palette taken from the logo:\n     purple  #6C3DD3   blue #5B8FE8   gradient 135deg blue -> purple\n   All classes are prefixed `se-` to avoid clashing with the seat-map app.\n   ========================================================================== */\n\n:root {\n  --se-purple: #6c3dd3;\n  --se-blue: #5b8fe8;\n  --se-grad: linear-gradient(135deg, #5b8fe8 0%, #6c3dd3 100%);\n  --se-grad-soft: linear-gradient(135deg, #eef3fd 0%, #f3eefb 100%);\n  --se-ink: #1f2430;\n  --se-muted: #5b6472;\n  --se-surface: #f6f7fb;\n  --se-border: #e6e8f0;\n  --se-white: #ffffff;\n  --se-radius: 16px;\n  --se-radius-sm: 10px;\n  --se-shadow: 0 10px 30px rgba(31, 36, 48, 0.12);\n  --se-shadow-sm: 0 4px 14px rgba(31, 36, 48, 0.08);\n  --se-font: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica,\n    Arial, sans-serif;\n}\n\n/* ---------------------------------------------------------------- page shell */\n.se-page {\n  font-family: var(--se-font);\n  color: var(--se-ink);\n  background: var(--se-white);\n  min-height: 100vh;\n  line-height: 1.7;\n  -webkit-font-smoothing: antialiased;\n}\n\n.se-topbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 16px 24px;\n  border-bottom: 1px solid var(--se-border);\n  position: sticky;\n  top: 0;\n  background: rgba(255, 255, 255, 0.9);\n  backdrop-filter: blur(8px);\n  z-index: 10;\n}\n\n.se-topbar img {\n  height: 30px;\n  width: auto;\n  display: block;\n}\n\n.se-topbar-links {\n  display: flex;\n  gap: 18px;\n  flex-wrap: nowrap;\n}\n\n.se-topbar-links a {\n  color: var(--se-muted);\n  text-decoration: none;\n  font-size: 14px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.se-topbar-links a:hover,\n.se-topbar-links a.se-active {\n  color: var(--se-purple);\n}\n\n/* --------------------------------------------------------------------- hero */\n.se-hero {\n  background: var(--se-grad-soft);\n  border-bottom: 1px solid var(--se-border);\n}\n\n.se-hero-inner {\n  max-width: 880px;\n  margin: 0 auto;\n  padding: 48px 24px;\n  display: flex;\n  align-items: center;\n  gap: 32px;\n}\n\n.se-hero-text {\n  flex: 1 1 auto;\n}\n\n.se-eyebrow {\n  display: inline-block;\n  font-size: 12px;\n  font-weight: 800;\n  letter-spacing: 1.5px;\n  text-transform: uppercase;\n  color: var(--se-purple);\n  background: var(--se-white);\n  border: 1px solid var(--se-border);\n  border-radius: 999px;\n  padding: 5px 12px;\n  margin-bottom: 14px;\n}\n\n.se-hero h1 {\n  margin: 0 0 10px;\n  font-size: 34px;\n  line-height: 1.15;\n  letter-spacing: -0.5px;\n}\n\n.se-hero p {\n  margin: 0;\n  color: var(--se-muted);\n  font-size: 16px;\n  max-width: 46ch;\n}\n\n.se-hero-art {\n  flex: 0 0 auto;\n  width: 180px;\n  height: 180px;\n}\n\n.se-hero-art svg {\n  width: 100%;\n  height: 100%;\n}\n\n/* ------------------------------------------------------------------ content */\n.se-content {\n  max-width: 880px;\n  margin: 0 auto;\n  padding: 40px 24px 72px;\n}\n\n.se-content h2 {\n  font-size: 22px;\n  margin: 36px 0 12px;\n  letter-spacing: -0.3px;\n}\n\n.se-content h2:first-child {\n  margin-top: 0;\n}\n\n.se-content h3 {\n  font-size: 17px;\n  margin: 22px 0 8px;\n}\n\n.se-content p,\n.se-content li {\n  color: #313846;\n  font-size: 15.5px;\n}\n\n.se-content a {\n  color: var(--se-purple);\n  font-weight: 600;\n}\n\n.se-section-head {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin: 40px 0 14px;\n}\n\n.se-section-head .se-mini-art {\n  flex: 0 0 auto;\n  width: 44px;\n  height: 44px;\n}\n\n.se-section-head h2 {\n  margin: 0;\n}\n\n.se-card {\n  background: var(--se-surface);\n  border: 1px solid var(--se-border);\n  border-radius: var(--se-radius);\n  padding: 20px 22px;\n  margin: 16px 0;\n}\n\n.se-callout {\n  border-left: 4px solid var(--se-blue);\n  background: var(--se-grad-soft);\n  border-radius: var(--se-radius-sm);\n  padding: 14px 18px;\n  margin: 18px 0;\n  font-size: 14.5px;\n}\n\n.se-placeholder {\n  color: var(--se-purple);\n  font-weight: 700;\n}\n\n/* ---------------------------------------------------------------- data table */\n.se-table-wrap {\n  overflow-x: auto;\n  border: 1px solid var(--se-border);\n  border-radius: var(--se-radius);\n  margin: 18px 0;\n}\n\n.se-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n  min-width: 560px;\n}\n\n.se-table th,\n.se-table td {\n  text-align: left;\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--se-border);\n  vertical-align: top;\n}\n\n.se-table thead th {\n  background: var(--se-grad);\n  color: #fff;\n  font-weight: 700;\n  border-bottom: none;\n}\n\n.se-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.se-table tbody tr:nth-child(even) td {\n  background: rgba(91, 143, 232, 0.05);\n}\n\n/* --------------------------------------------------------------------- foot */\n.se-foot {\n  border-top: 1px solid var(--se-border);\n  padding: 28px 24px;\n  text-align: center;\n  color: var(--se-muted);\n  font-size: 13.5px;\n}\n\n.se-foot a {\n  color: var(--se-muted);\n  text-decoration: none;\n  font-weight: 600;\n  margin: 0 8px;\n}\n\n.se-foot a:hover {\n  color: var(--se-purple);\n}\n\n.se-link-btn {\n  background: none;\n  border: none;\n  color: var(--se-muted);\n  font: inherit;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 0;\n  margin: 0 8px;\n}\n\n.se-link-btn:hover {\n  color: var(--se-purple);\n}\n\n/* ===================================================== forms (report/delete) */\n.se-form-card {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n  max-width: 560px;\n  padding: 24px;\n  border: 1px solid var(--se-border);\n  border-radius: var(--se-radius);\n  background: var(--se-white);\n  box-shadow: var(--se-shadow-sm);\n}\n\n.se-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.se-label {\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--se-ink);\n}\n\n.se-input {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 11px 13px;\n  border: 1px solid var(--se-border);\n  border-radius: var(--se-radius-sm);\n  background: var(--se-white);\n  font: inherit;\n  font-size: 15px;\n  color: var(--se-ink);\n  outline: none;\n}\n\n.se-input:focus {\n  border-color: var(--se-purple);\n  box-shadow: 0 0 0 3px rgba(108, 61, 211, 0.12);\n}\n\n.se-textarea {\n  resize: vertical;\n  min-height: 110px;\n}\n\n.se-help {\n  font-size: 12px;\n  color: var(--se-muted);\n}\n\n.se-radio-row {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.se-radio {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 9px 14px;\n  border: 1px solid var(--se-border);\n  border-radius: 999px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.se-radio.se-active {\n  border-color: var(--se-purple);\n  color: var(--se-purple);\n  background: var(--se-grad-soft);\n}\n\n.se-check {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  font-size: 14px;\n  color: var(--se-ink);\n  cursor: pointer;\n}\n\n.se-check input {\n  margin-top: 3px;\n}\n\n.se-btn-primary,\n.se-btn-danger {\n  align-self: flex-start;\n  border: none;\n  border-radius: 999px;\n  padding: 12px 22px;\n  font: inherit;\n  font-size: 15px;\n  font-weight: 700;\n  color: #fff;\n  cursor: pointer;\n}\n\n.se-btn-primary {\n  background: var(--se-grad);\n}\n\n.se-btn-danger {\n  background: linear-gradient(135deg, #f0616b 0%, #d23d5b 100%);\n}\n\n.se-btn-primary:disabled,\n.se-btn-danger:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n/* alerts / callouts */\n.se-alert {\n  border-radius: var(--se-radius-sm);\n  padding: 14px 16px;\n  font-size: 14px;\n  border: 1px solid var(--se-border);\n  margin-bottom: 18px;\n}\n\n.se-alert-info {\n  background: var(--se-grad-soft);\n  border-color: #d9def0;\n  color: var(--se-ink);\n}\n\n.se-alert-success {\n  background: #eafaf1;\n  border-color: #b8ecd0;\n  color: #1c6b46;\n}\n\n.se-alert-warn {\n  background: #fff7e6;\n  border-color: #ffe1a8;\n  color: #8a5b00;\n}\n\n.se-alert-error {\n  background: #fdecee;\n  border-color: #f6c2c8;\n  color: #a4283a;\n  margin-bottom: 0;\n}\n\n/* Two-up explanatory cards (Help Center: private/public events, melden/löschen) */\n.se-hc-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 16px;\n  margin: 16px 0 8px;\n}\n\n.se-hc-cards .se-card {\n  margin: 0;\n}\n\n.se-hc-cards .se-card h3 {\n  margin: 0 0 8px;\n}\n\n.se-hc-cards .se-card p:last-child {\n  margin-bottom: 0;\n}\n\n/* ===================================================== layout container */\n/* Centered, width-capped column so the header/footer don't stretch edge-to-edge\n   on large screens and stay aligned with the page content. */\n.se-container {\n  width: 100%;\n  max-width: 1180px;\n  margin: 0 auto;\n  padding: 0 24px;\n  box-sizing: border-box;\n}\n\n/* ===================================================== site header / drawer */\n/* The bar spans full width; its contents live in the centered container. */\n.se-topbar {\n  padding: 12px 0;\n  transform: translateY(0);\n  transition: transform 0.24s ease, box-shadow 0.24s ease, background 0.24s ease;\n  box-shadow: 0 10px 28px rgba(31, 36, 48, 0.06);\n}\n\n.se-topbar-hidden {\n  transform: translateY(-110%);\n}\n\n/* Two tiers: (1) language indicator, (2) brand · search · nav · login. */\n.se-topbar-inner {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.se-topbar-row {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n/* Top tier: language indicator, on its own line, pinned far right. */\n.se-topbar-row-top {\n  justify-content: flex-end;\n}\n\n/* Bottom tier: brand sits far left; everything else clusters on the right. */\n.se-topbar-right {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-left: auto;\n  min-width: 0;\n}\n\n/* ---- language / country selector ---- */\n.se-locale {\n  position: relative;\n}\n\n.se-locale-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  background: var(--se-surface);\n  border: 1px solid var(--se-border);\n  border-radius: 999px;\n  padding: 6px 12px;\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--se-ink);\n  cursor: pointer;\n}\n\n.se-locale-btn:hover {\n  border-color: var(--se-purple);\n}\n\n.se-locale-flag {\n  font-size: 18px;\n  line-height: 1;\n}\n\n.se-locale-country {\n  color: var(--se-muted);\n  font-weight: 600;\n}\n\n.se-locale-caret {\n  color: var(--se-muted);\n  font-size: 11px;\n}\n\n.se-locale-menu {\n  position: absolute;\n  top: calc(100% + 6px);\n  right: 0;\n  min-width: 200px;\n  margin: 0;\n  padding: 6px;\n  list-style: none;\n  background: var(--se-white);\n  border: 1px solid var(--se-border);\n  border-radius: var(--se-radius-sm);\n  box-shadow: var(--se-shadow);\n  z-index: 40;\n}\n\n.se-locale-opt {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 9px 10px;\n  border: none;\n  border-radius: 8px;\n  background: none;\n  font-size: 14px;\n  color: var(--se-ink);\n  cursor: pointer;\n  text-align: left;\n}\n\n.se-locale-opt:hover,\n.se-locale-opt.se-active {\n  background: var(--se-grad-soft);\n  color: var(--se-purple);\n}\n\n.se-locale-opt-lang {\n  font-weight: 800;\n  min-width: 26px;\n}\n\n.se-locale-opt-country {\n  color: var(--se-muted);\n}\n\n.se-locale-opt.se-active .se-locale-opt-country {\n  color: var(--se-purple);\n}\n\n/* ---- website + event-location search ---- */\n.se-search {\n  position: relative;\n  flex: 0 1 280px;\n  min-width: 0;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 0.78fr) 42px;\n  align-items: center;\n  gap: 0;\n  padding: 0 4px;\n  border: 1px solid var(--se-border);\n  border-radius: 999px;\n  background: var(--se-surface);\n  transition: border-color 0.16s ease, background 0.16s ease, box-shadow 0.16s ease;\n}\n\n.se-search:focus-within {\n  border-color: var(--se-purple);\n  background: var(--se-white);\n  box-shadow: 0 0 0 3px rgba(108, 61, 211, 0.12);\n}\n\n.se-search-field {\n  position: relative;\n  min-width: 0;\n}\n\n.se-search-field-location {\n  border-left: 1px solid var(--se-border);\n}\n\n.se-search-glyph {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--se-muted);\n  display: inline-flex;\n  pointer-events: none;\n}\n\n.se-search-input {\n  min-width: 0;\n  width: 100%;\n  box-sizing: border-box;\n  padding: 9px 12px 9px 36px;\n  border: 0;\n  border-radius: 0;\n  background: transparent;\n  font-size: 14px;\n  color: var(--se-ink);\n  outline: none;\n}\n\n.se-location-input {\n  padding-left: 36px;\n}\n\n.se-location-glyph {\n  position: absolute;\n  left: 13px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--se-muted);\n  display: inline-flex;\n  pointer-events: none;\n}\n\n.se-search .se-search-filter-btn {\n  position: relative;\n  justify-self: center;\n  width: 36px;\n  height: 36px;\n  margin-left: 0;\n  border: 0;\n  border-radius: 14px;\n  background: transparent;\n  color: #5b8fe8;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.se-search .se-search-filter-btn:hover,\n.se-search .se-search-filter-btn.se-active {\n  background: #5b8fe8;\n  color: #fff;\n}\n\n.se-search-filter-badge {\n  position: absolute;\n  top: -4px;\n  right: -4px;\n  min-width: 17px;\n  height: 17px;\n  padding: 0 4px;\n  border-radius: 999px;\n  background: #ef4444;\n  color: #fff;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 10px;\n  font-weight: 900;\n  line-height: 1;\n  box-shadow: 0 0 0 2px #fff;\n}\n\n.se-search-input:focus {\n  background: transparent;\n  box-shadow: none;\n}\n\n.se-search-list {\n  position: absolute;\n  top: calc(100% + 8px);\n  left: 0;\n  right: 0;\n  margin: 0;\n  padding: 6px;\n  list-style: none;\n  background: var(--se-white);\n  border: 1px solid var(--se-border);\n  border-radius: var(--se-radius-sm);\n  box-shadow: var(--se-shadow);\n  z-index: 40;\n  max-height: 60vh;\n  overflow: auto;\n}\n\n.se-search-opt {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  width: 100%;\n  padding: 9px 10px;\n  border: none;\n  border-radius: 8px;\n  background: none;\n  cursor: pointer;\n  text-align: left;\n}\n\n.se-search-opt:hover,\n.se-search-opt.se-active {\n  background: var(--se-grad-soft);\n}\n\n.se-search-opt-title {\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--se-ink);\n}\n\n.se-search-opt:hover .se-search-opt-title,\n.se-search-opt.se-active .se-search-opt-title {\n  color: var(--se-purple);\n}\n\n.se-search-opt-hint {\n  font-size: 12px;\n  color: var(--se-muted);\n}\n\n.se-search-empty {\n  padding: 10px 11px;\n  color: var(--se-muted);\n  font-size: 13px;\n}\n\n/* ---- person / login icon ---- */\n.se-person {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n  width: 42px;\n  height: 42px;\n  border-radius: 50%;\n  border: 1px solid var(--se-border);\n  color: var(--se-muted);\n  background: var(--se-surface);\n  text-decoration: none;\n}\n\n.se-person:hover {\n  color: var(--se-purple);\n  border-color: var(--se-purple);\n}\n\n.se-person-in {\n  color: #fff;\n  background: var(--se-grad);\n  border-color: transparent;\n}\n\n.se-person-in:hover {\n  color: #fff;\n}\n\n.se-drawer-search {\n  padding: 10px 12px 4px;\n}\n\n.se-brand {\n  display: inline-flex;\n  align-items: center;\n  flex: 0 0 auto;\n  text-decoration: none;\n}\n\n.se-topbar .se-brand-logo {\n  height: 30px;\n  width: auto;\n  display: block;\n}\n\n/* Inline tabs sit directly to the right of the search field and never shrink\n   or wrap (so \"Hilfe-Center\" stays on one line). */\n.se-nav-desktop {\n  margin-left: 0;\n  flex: 0 0 auto;\n  align-items: center;\n  gap: 12px;\n}\n\n.se-category-menu {\n  position: relative;\n  display: inline-flex;\n}\n\n.se-category-trigger {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  border: 0;\n  background: transparent;\n  color: var(--se-muted);\n  font: inherit;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  padding: 7px 0;\n  white-space: nowrap;\n}\n\n.se-category-trigger:hover,\n.se-category-trigger.se-active {\n  color: var(--se-purple);\n}\n\n.se-category-panel {\n  position: absolute;\n  top: calc(100% + 14px);\n  left: 50%;\n  transform: translateX(-50%);\n  width: min(720px, calc(100vw - 48px));\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 16px;\n  padding: 18px;\n  background: rgba(255, 255, 255, 0.98);\n  border: 1px solid var(--se-border);\n  border-radius: 14px;\n  box-shadow: var(--se-shadow);\n  z-index: 60;\n}\n\n.se-category-group h3 {\n  margin: 0 0 10px;\n  color: var(--se-ink);\n  font-size: 13px;\n  font-weight: 850;\n}\n\n.se-category-grid {\n  display: grid;\n  gap: 6px;\n}\n\n.se-category-grid a {\n  display: block;\n  margin: 0;\n  padding: 8px 10px;\n  border-radius: 8px;\n  color: var(--se-muted);\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.se-category-grid a:hover {\n  color: var(--se-purple);\n  background: var(--se-grad-soft);\n}\n\n.se-header-cta {\n  padding: 9px 14px;\n  box-shadow: 0 6px 18px rgba(91, 143, 232, 0.22);\n}\n\n.se-header-cta .se-me-cta-icon {\n  width: 20px;\n  height: 20px;\n}\n\n/* Language badge shown inline next to the burger — small screens only. */\n.se-locale-mobile {\n  display: none;\n  flex: 0 0 auto;\n}\n\n/* Toggle button — hidden on wide screens, shown on small ones. */\n.se-burger {\n  display: none;\n  flex: 0 0 auto;\n  flex-direction: column;\n  justify-content: center;\n  gap: 5px;\n  width: 44px;\n  height: 44px;\n  padding: 11px;\n  background: none;\n  border: 1px solid var(--se-border);\n  border-radius: 12px;\n  cursor: pointer;\n}\n\n.se-burger span {\n  display: block;\n  height: 2px;\n  width: 100%;\n  background: var(--se-ink);\n  border-radius: 2px;\n  transition: transform 0.25s ease, opacity 0.2s ease;\n}\n\n/* Morph the hamburger into an X while the drawer is open. */\n.se-burger.se-open span:nth-child(1) {\n  transform: translateY(7px) rotate(45deg);\n}\n.se-burger.se-open span:nth-child(2) {\n  opacity: 0;\n}\n.se-burger.se-open span:nth-child(3) {\n  transform: translateY(-7px) rotate(-45deg);\n}\n\n/* Scrim fills the viewport and CLIPS the drawer (overflow:hidden + an\n   absolutely-positioned child), so the off-screen drawer never creates a\n   horizontal scrollbar. High z-index keeps it above all page content. */\n.se-drawer-scrim {\n  position: fixed;\n  inset: 0;\n  overflow: hidden;\n  background: rgba(15, 18, 26, 0.55);\n  backdrop-filter: blur(2px);\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.25s ease, visibility 0.25s ease;\n  z-index: 1000;\n}\n\n.se-drawer-scrim.se-open {\n  opacity: 1;\n  visibility: visible;\n}\n\n.se-drawer {\n  position: absolute;\n  top: 0;\n  right: 0;\n  height: 100%;\n  width: min(82vw, 320px);\n  background: var(--se-white);\n  box-shadow: -10px 0 30px rgba(31, 36, 48, 0.22);\n  transform: translateX(100%);\n  transition: transform 0.28s cubic-bezier(0.22, 0.61, 0.36, 1);\n  display: flex;\n  flex-direction: column;\n}\n\n.se-drawer.se-open {\n  transform: translateX(0);\n}\n\n.se-drawer-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 16px;\n  border-bottom: 1px solid var(--se-border);\n}\n\n.se-drawer-head .se-brand-logo {\n  height: 20px;\n  width: auto;\n}\n\n.se-drawer-close {\n  background: none;\n  border: none;\n  font-size: 20px;\n  line-height: 1;\n  color: var(--se-muted);\n  cursor: pointer;\n  padding: 6px 8px;\n}\n\n.se-drawer-links {\n  display: flex;\n  flex-direction: column;\n  padding: 8px 6px;\n  overflow-y: auto;\n}\n\n.se-drawer-links a {\n  display: block;\n  padding: 14px 16px;\n  border-radius: 12px;\n  color: var(--se-ink);\n  text-decoration: none;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.se-drawer-links a:hover,\n.se-drawer-links a.se-active {\n  background: var(--se-grad-soft);\n  color: var(--se-purple);\n}\n\n.se-drawer-section-title {\n  padding: 16px 16px 6px;\n  color: var(--se-muted);\n  font-size: 12px;\n  font-weight: 850;\n  letter-spacing: 0.6px;\n  text-transform: uppercase;\n}\n\n.se-drawer-cta {\n  align-self: stretch;\n  justify-content: center;\n  margin: 10px 14px 6px;\n}\n\n.se-drawer-cat-group {\n  display: grid;\n  gap: 4px;\n  padding: 8px 8px 10px;\n}\n\n.se-drawer-cat-group strong {\n  padding: 4px 8px;\n  color: var(--se-ink);\n  font-size: 13px;\n}\n\n.se-drawer-cat-group a {\n  padding: 9px 12px;\n  font-size: 14px;\n  color: var(--se-muted);\n}\n\n/* footer: centered container with brand, main tabs row, legal strip, copyright */\n.se-foot-brand {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 16px;\n}\n\n.se-foot-logo {\n  display: inline-flex;\n  text-decoration: none;\n}\n\n.se-foot .se-brand-logo {\n  height: 24px;\n  width: auto;\n  display: block;\n}\n\n.se-foot-main {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.se-foot-main a {\n  font-weight: 700;\n  color: var(--se-ink);\n}\n\n.se-foot-columns {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 20px;\n  margin: 22px auto;\n  text-align: left;\n}\n\n.se-foot-column {\n  display: grid;\n  gap: 8px;\n  padding: 16px;\n  border: 1px solid var(--se-border);\n  border-radius: 12px;\n  background: transparent;\n}\n\n.se-foot-column h3 {\n  margin: 0 0 4px;\n  color: var(--se-ink);\n  font-size: 14px;\n}\n\n.se-foot-column a {\n  margin: 0;\n  color: var(--se-muted);\n  font-size: 13.5px;\n}\n\n/* \"zu MainEvents\" smart entry-point button (footer + anywhere it's reused). */\n.se-me-cta {\n  display: inline-flex;\n  align-items: center;\n  gap: 9px;\n  padding: 10px 18px;\n  border: none;\n  border-radius: 999px;\n  background: var(--se-grad);\n  color: #fff;\n  font-weight: 800;\n  font-size: 14px;\n  cursor: pointer;\n  text-decoration: none;\n  box-shadow: var(--se-shadow);\n}\n\n.se-me-cta:hover {\n  filter: brightness(1.05);\n}\n\n.se-me-cta-icon {\n  height: 22px;\n  width: 22px;\n  display: block;\n}\n\n.se-foot-legal {\n  margin-bottom: 10px;\n  font-size: 13px;\n}\n\n.se-foot-copy {\n  color: var(--se-muted);\n}\n\n/* Wide screens: show inline tabs, fully hide the drawer/toggle so they can't\n   create overflow or intercept clicks. */\n@media (min-width: 761px) {\n  .se-burger,\n  .se-drawer-scrim {\n    display: none;\n  }\n}\n\n@media (max-width: 1080px) {\n  .se-search {\n    flex-basis: 220px;\n  }\n  .se-header-cta span {\n    display: none;\n  }\n}\n\n@media (max-width: 760px) {\n  .se-nav-desktop {\n    display: none;\n  }\n  .se-burger {\n    display: flex;\n  }\n  /* Single-tier mobile bar: drop the separate language row and move the badge\n     inline next to the burger → brand (left) · language + burger (right). */\n  .se-topbar-row-top {\n    display: none;\n  }\n  .se-locale-mobile {\n    display: block;\n  }\n  /* The search and account icon live inside the slide-in drawer instead. */\n  .se-topbar-right .se-search,\n  .se-topbar-right .se-person,\n  .se-header-cta {\n    display: none;\n  }\n  .se-container {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n  .se-foot-columns {\n    grid-template-columns: 1fr;\n    text-align: center;\n  }\n}\n\n@media (max-width: 480px) {\n  /* Save horizontal space in the top row: keep flag + language code only. */\n  .se-locale-country {\n    display: none;\n  }\n}\n\n/* ===================================================== refined app website chrome */\n.se-topbar {\n  padding: 7px 0;\n  background: rgba(255, 255, 255, 0.94);\n}\n\n.se-topbar-inner {\n  gap: 0;\n}\n\n.se-topbar-bar {\n  min-height: 54px;\n}\n\n.se-topbar-row-top,\n.se-locale-mobile {\n  display: none;\n}\n\n.se-topbar .se-brand-logo {\n  height: 28px;\n}\n\n.se-topbar-links a,\n.se-category-trigger {\n  font-size: 13.5px;\n}\n\n.se-locale-btn {\n  gap: 5px;\n  min-width: 74px;\n  justify-content: center;\n  padding: 7px 9px;\n  background: #fff;\n}\n\n.se-locale-code {\n  color: var(--se-ink);\n  font-size: 12px;\n  font-weight: 850;\n  text-transform: uppercase;\n}\n\n.se-person {\n  width: 48px;\n  height: 46px;\n  flex-direction: column;\n  gap: 1px;\n  border-radius: 14px;\n}\n\n.se-person svg {\n  width: 18px;\n  height: 18px;\n}\n\n.se-person span {\n  max-width: 44px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: inherit;\n  font-size: 10px;\n  font-weight: 800;\n  line-height: 1;\n  white-space: nowrap;\n}\n\n.se-ticket-quick,\n.se-search-toggle {\n  display: none;\n}\n\n.se-ticket-quick {\n  align-items: center;\n  justify-content: center;\n  height: 40px;\n  padding: 0 12px;\n  border-radius: 12px;\n  background: var(--se-grad-soft);\n  color: var(--se-purple);\n  font-size: 13px;\n  font-weight: 850;\n  text-decoration: none;\n  white-space: nowrap;\n}\n\n.se-search-toggle {\n  align-items: center;\n  justify-content: center;\n  width: 42px;\n  height: 42px;\n  border: 1px solid var(--se-border);\n  border-radius: 12px;\n  background: var(--se-surface);\n  color: var(--se-muted);\n  cursor: pointer;\n}\n\n.se-search-toggle:hover,\n.se-search-toggle.se-active {\n  color: var(--se-purple);\n  border-color: var(--se-purple);\n  background: #fff;\n}\n\n.se-search-dock {\n  display: none;\n  padding: 0 0 8px;\n}\n\n.se-search-dock.se-open {\n  display: block;\n}\n\n.se-search-dock .se-search {\n  width: min(100%, 560px);\n  margin-left: auto;\n}\n\n.se-search-dock .se-search-list {\n  max-height: min(50vh, 320px);\n}\n\n.se-foot {\n  background: linear-gradient(135deg, #f2f6ff 0%, #f7f3ff 100%);\n  border-top: 1px solid #dfe5f4;\n  color: #465064;\n}\n\n.se-foot-column {\n  background: transparent;\n  border-color: rgba(108, 61, 211, 0.12);\n}\n\n.se-foot-main a,\n.se-foot-column h3 {\n  color: var(--se-ink);\n}\n\n.se-foot a:hover {\n  color: var(--se-purple);\n}\n\n@media (min-width: 1121px) {\n  .se-burger,\n  .se-drawer-scrim {\n    display: none;\n  }\n}\n\n@media (max-width: 1120px) {\n  .se-burger {\n    display: flex;\n  }\n  .se-drawer-scrim {\n    display: block;\n  }\n  .se-category-menu,\n  .se-nav-venues,\n  .se-nav-help {\n    display: none;\n  }\n}\n\n@media (max-width: 980px) {\n  .se-nav-discover,\n  .se-nav-organize,\n  .se-nav-tickets {\n    display: none;\n  }\n  .se-ticket-quick {\n    display: inline-flex;\n    width: auto;\n    min-width: auto;\n    height: 40px;\n    padding: 0 8px;\n    color: var(--se-muted);\n    font-size: 13px;\n    font-weight: 850;\n  }\n  .se-ticket-quick svg {\n    display: none;\n  }\n  .se-ticket-quick span {\n    display: inline;\n  }\n}\n\n@media (max-width: 900px) {\n  .se-topbar-right > .se-search {\n    display: none;\n  }\n  .se-search-toggle {\n    display: inline-flex;\n  }\n}\n\n@media (max-width: 760px) {\n  .se-topbar {\n    padding: 6px 0;\n  }\n  .se-topbar-bar {\n    min-height: 52px;\n  }\n  .se-nav-desktop {\n    display: none;\n  }\n  .se-ticket-quick {\n    display: inline-flex;\n  }\n  .se-topbar-right .se-person {\n    display: inline-flex;\n  }\n  .se-locale {\n    display: block;\n  }\n  .se-locale-btn {\n    min-width: 62px;\n    padding-inline: 7px;\n  }\n  .se-locale-flag {\n    font-size: 16px;\n  }\n  .se-locale-caret {\n    display: none;\n  }\n  .se-search-dock .se-search {\n    width: 100%;\n  }\n  .se-foot {\n    padding-inline: 0;\n  }\n}\n\n@media (max-width: 520px) {\n  .se-topbar-right {\n    gap: 7px;\n  }\n  .se-topbar .se-brand-logo {\n    height: 24px;\n  }\n  .se-ticket-quick {\n    padding-inline: 9px;\n    font-size: 12px;\n  }\n  .se-person {\n    width: 42px;\n    height: 42px;\n  }\n  .se-person span {\n    display: none;\n  }\n}\n\n@media (max-width: 390px) {\n  .se-locale {\n    display: none;\n  }\n}\n\n/* Header action refinement: text-first navigation, icon actions without button chrome. */\n.se-topbar button,\n.se-topbar .se-person,\n.se-topbar .se-ticket-quick {\n  border: 0;\n  background: transparent;\n  box-shadow: none;\n}\n\n.se-topbar button:hover,\n.se-topbar button.se-active,\n.se-topbar .se-person:hover,\n.se-topbar .se-ticket-quick:hover {\n  border: 0;\n  background: transparent;\n  box-shadow: none;\n}\n\n.se-topbar-right {\n  flex: 1 1 auto;\n}\n\n.se-topbar-right > .se-search {\n  flex: 1 1 250px;\n  max-width: 320px;\n}\n\n.se-nav-desktop {\n  justify-content: center;\n}\n\n.se-locale-btn {\n  min-width: 58px;\n  padding: 6px 4px;\n}\n\n.se-locale-menu {\n  right: 0;\n}\n\n.se-person {\n  width: 48px;\n  height: 44px;\n  padding: 0;\n  gap: 2px;\n  color: var(--se-muted);\n  background: transparent;\n}\n\n.se-person-in {\n  color: var(--se-purple);\n  background: transparent;\n}\n\n.se-person-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 20px;\n}\n\n.se-person-label {\n  display: block;\n  max-width: 54px;\n  color: inherit;\n  font-size: 10px;\n  font-weight: 850;\n  line-height: 1;\n  overflow: hidden;\n  text-align: center;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.se-ticket-quick {\n  width: 44px;\n  height: 44px;\n  padding: 0;\n  color: var(--se-muted);\n}\n\n.se-ticket-quick span {\n  display: none;\n}\n\n.se-ticket-quick:hover {\n  color: var(--se-purple);\n}\n\n.se-search-toggle {\n  border: 0;\n  background: transparent;\n}\n\n.se-search-toggle:hover,\n.se-search-toggle.se-active {\n  border: 0;\n  background: transparent;\n}\n\n.se-burger {\n  border: 0;\n  background: transparent;\n}\n\n@media (max-width: 1180px) {\n  .se-topbar-links {\n    gap: 10px;\n  }\n  .se-topbar-right {\n    gap: 10px;\n  }\n  .se-topbar-right > .se-search {\n    max-width: 260px;\n  }\n}\n\n@media (max-width: 900px) {\n  .se-topbar-right > .se-search {\n    order: 1;\n  }\n  .se-ticket-quick {\n    order: 2;\n  }\n  .se-search-toggle {\n    order: 1;\n  }\n  .se-topbar-right > .se-locale {\n    order: 3;\n  }\n  .se-person {\n    order: 4;\n  }\n  .se-burger {\n    order: 5;\n  }\n}\n\n@media (max-width: 760px) {\n  .se-topbar-right {\n    flex: 0 0 auto;\n    gap: 9px;\n    margin-left: auto;\n  }\n  .se-search-toggle,\n  .se-ticket-quick,\n  .se-person {\n    width: 40px;\n    height: 42px;\n  }\n  .se-topbar-right > .se-locale {\n    display: block;\n  }\n  .se-ticket-quick {\n    padding: 0;\n  }\n  .se-ticket-quick svg {\n    display: block;\n  }\n  .se-ticket-quick span {\n    display: none;\n  }\n  .se-burger {\n    display: flex;\n    width: 38px;\n    height: 42px;\n    padding: 10px 8px;\n    order: 99;\n  }\n  .se-person .se-person-label {\n    display: block;\n  }\n}\n\n@media (max-width: 520px) {\n  .se-person .se-person-label {\n    display: block;\n    max-width: 42px;\n    font-size: 9px;\n  }\n}\n\n/* Final responsive header rules: wide header, stable tickets position, fixed right actions. */\n.se-topbar .se-container {\n  max-width: 1800px;\n}\n\n.se-nav-tickets {\n  display: none;\n}\n\n.se-ticket-quick {\n  display: inline-flex;\n  flex: 0 0 auto;\n  order: 2;\n  width: auto;\n  height: 40px;\n  padding: 0 4px;\n  color: var(--se-muted);\n}\n\n.se-ticket-quick svg {\n  display: none;\n}\n\n.se-ticket-quick span {\n  display: inline;\n  font-size: 13.5px;\n  font-weight: 850;\n}\n\n.se-nav-desktop {\n  order: 3;\n}\n\n.se-topbar-right > .se-locale {\n  flex: 0 0 auto;\n  order: 7;\n}\n\n.se-person {\n  flex: 0 0 auto;\n  order: 8;\n}\n\n.se-burger {\n  flex: 0 0 auto;\n  order: 9;\n}\n\n.se-search-toggle {\n  flex: 0 0 auto;\n  order: 1;\n}\n\n.se-topbar-right > .se-search {\n  order: 1;\n}\n\n@media (max-width: 1180px) {\n  .se-ticket-quick {\n    width: 40px;\n    padding: 0;\n  }\n  .se-ticket-quick svg {\n    display: block;\n  }\n  .se-ticket-quick span {\n    display: none;\n  }\n}\n\n@media (min-width: 761px) and (max-width: 980px) {\n  .se-topbar-right > .se-search {\n    display: block;\n    flex: 1 1 230px;\n    max-width: 340px;\n    min-width: 180px;\n  }\n  .se-search-toggle {\n    display: none;\n  }\n  .se-ticket-quick {\n    display: inline-flex;\n  }\n  .se-topbar-right > .se-locale,\n  .se-person,\n  .se-burger {\n    margin-left: 0;\n  }\n}\n\n@media (max-width: 760px) {\n  .se-topbar-right > .se-search {\n    display: none;\n  }\n  .se-search-toggle {\n    display: inline-flex;\n  }\n  .se-ticket-quick {\n    display: inline-flex;\n  }\n  .se-topbar-right > .se-locale,\n  .se-person,\n  .se-burger {\n    flex: 0 0 auto;\n  }\n}\n\n/* Keep the utility cluster pinned to the far right at every responsive width. */\n.se-topbar-bar {\n  width: 100%;\n}\n\n.se-brand {\n  flex: 0 0 auto;\n}\n\n.se-topbar-right {\n  flex: 1 1 auto;\n  justify-content: flex-start;\n  min-width: 0;\n}\n\n.se-topbar-right > .se-locale {\n  margin-left: auto;\n}\n\n@media (min-width: 1121px) {\n  .se-topbar-right {\n    display: grid;\n    grid-template-columns: minmax(220px, 320px) auto minmax(0, 1fr) auto auto;\n    align-items: center;\n    column-gap: 14px;\n  }\n  .se-topbar-right > .se-search {\n    justify-self: end;\n    width: 100%;\n  }\n  .se-ticket-quick {\n    justify-self: start;\n  }\n  .se-nav-desktop {\n    justify-self: center;\n  }\n  .se-topbar-right > .se-locale {\n    margin-left: 0;\n  }\n}\n\n@media (min-width: 761px) and (max-width: 1120px) {\n  .se-topbar-right > .se-search,\n  .se-search-toggle {\n    margin-left: auto;\n  }\n  .se-topbar-right > .se-locale {\n    margin-left: 0;\n  }\n}\n\n@media (max-width: 760px) {\n  .se-topbar-right {\n    flex: 1 1 auto;\n    justify-content: flex-end;\n    min-width: 0;\n  }\n  .se-search-toggle {\n    margin-left: auto;\n  }\n  .se-topbar-right > .se-locale {\n    margin-left: 0;\n  }\n}\n\n/* Grouped header layout: center the main navigation block between logo and actions. */\n.se-header-main-block,\n.se-header-actions {\n  display: flex;\n  align-items: center;\n  min-width: 0;\n}\n\n.se-header-main-block {\n  gap: 14px;\n}\n\n.se-header-actions {\n  gap: 12px;\n  flex: 0 0 auto;\n}\n\n@media (min-width: 1121px) {\n  .se-topbar-bar {\n    display: grid;\n    grid-template-columns: auto minmax(0, 1fr);\n    column-gap: 28px;\n  }\n\n  .se-topbar-right {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) auto;\n    align-items: center;\n    gap: 18px;\n    width: 100%;\n  }\n\n  .se-header-main-block {\n    justify-self: center;\n  }\n\n  .se-header-actions {\n    justify-self: end;\n  }\n\n  .se-header-main-block .se-search {\n    flex: 0 1 500px;\n    width: min(500px, 36vw);\n    max-width: 500px;\n  }\n\n  .se-search-toggle {\n    display: none;\n  }\n\n  .se-ticket-quick {\n    width: auto;\n    padding: 0 4px;\n  }\n\n  .se-ticket-quick svg {\n    display: none;\n  }\n\n  .se-ticket-quick span {\n    display: inline;\n  }\n}\n\n@media (max-width: 1120px) {\n  .se-topbar-right {\n    display: flex;\n    justify-content: flex-end;\n  }\n\n  .se-header-main-block {\n    margin-left: auto;\n  }\n\n  .se-header-actions {\n    margin-left: 4px;\n  }\n}\n\n@media (min-width: 761px) and (max-width: 980px) {\n  .se-header-main-block .se-search {\n    display: grid;\n    flex: 0 1 360px;\n    min-width: 190px;\n    max-width: 360px;\n    grid-template-columns: minmax(125px, 1fr) minmax(105px, 0.72fr) 38px;\n  }\n\n  .se-search-toggle {\n    display: none;\n  }\n\n  .se-ticket-quick {\n    width: 40px;\n    padding: 0;\n  }\n\n  .se-ticket-quick svg {\n    display: block;\n  }\n\n  .se-ticket-quick span {\n    display: none;\n  }\n}\n\n@media (max-width: 760px) {\n  .se-header-main-block {\n    gap: 8px;\n    margin-left: auto;\n  }\n\n  .se-header-actions {\n    gap: 8px;\n  }\n\n  .se-header-main-block .se-search {\n    display: none;\n  }\n\n  .se-search-toggle,\n  .se-ticket-quick {\n    display: inline-flex;\n    width: 38px;\n    height: 42px;\n  }\n\n  .se-ticket-quick svg {\n    display: block;\n  }\n\n  .se-ticket-quick span {\n    display: none;\n  }\n\n  .se-header-actions .se-locale {\n    display: block;\n  }\n}\n\n@media (max-width: 420px) {\n  .se-container {\n    padding-left: 10px;\n    padding-right: 10px;\n  }\n\n  .se-topbar .se-brand-logo {\n    height: 22px;\n  }\n\n  .se-topbar-bar {\n    min-height: 48px;\n  }\n\n  .se-topbar-right {\n    gap: 2px;\n  }\n\n  .se-header-main-block {\n    gap: 2px;\n  }\n\n  .se-header-actions {\n    gap: 2px;\n    margin-left: 1px;\n  }\n\n  .se-search-toggle,\n  .se-ticket-quick,\n  .se-person,\n  .se-burger {\n    width: 35px;\n    height: 42px;\n    padding: 0;\n  }\n\n  .se-search-toggle svg,\n  .se-ticket-quick svg {\n    width: 23px;\n    height: 23px;\n  }\n\n  .se-person {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    gap: 0;\n    color: var(--se-muted);\n  }\n\n  .se-person-icon {\n    display: inline-flex;\n    height: 25px;\n  }\n\n  .se-person svg {\n    display: block;\n    width: 24px;\n    height: 24px;\n  }\n\n  .se-person .se-person-label {\n    display: none;\n  }\n\n  .se-locale-btn {\n    min-width: 43px;\n    padding: 0 2px;\n    gap: 2px;\n  }\n\n  .se-topbar-right > .se-locale,\n  .se-header-actions .se-locale,\n  .se-locale {\n    display: block;\n  }\n\n  .se-locale-flag {\n    font-size: 18px;\n  }\n\n  .se-locale-code {\n    font-size: 11px;\n  }\n\n  .se-burger {\n    width: 34px;\n    padding: 9px 5px;\n  }\n}\n\n/* Mobile search opens as its own docked panel directly below the header border. */\n.se-topbar {\n  overflow: visible;\n  z-index: 120;\n}\n\n.se-topbar button,\n.se-topbar a {\n  touch-action: manipulation;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.se-category-panel,\n.se-locale-menu,\n.se-search-list {\n  z-index: 140;\n}\n\n.se-search-dock {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  display: none;\n  padding: 12px 16px 14px;\n  background: rgba(255, 255, 255, 0.98);\n  border-top: 1px solid var(--se-border);\n  border-bottom: 1px solid var(--se-border);\n  box-shadow: 0 18px 30px rgba(31, 36, 48, 0.12);\n}\n\n.se-search-dock.se-open {\n  display: block;\n}\n\n.se-search-dock .se-search {\n  width: min(100%, 760px);\n  margin: 0 auto;\n}\n\n.se-search-dock .se-search-input {\n  height: 44px;\n  background: transparent;\n}\n\n.se-search-dock .se-search-list {\n  top: calc(100% + 8px);\n  max-height: min(52vh, 340px);\n}\n\n@media (min-width: 901px) {\n  .se-search-dock {\n    display: none !important;\n  }\n}\n\n@media (max-width: 900px) {\n  .se-search-dock .se-search {\n    grid-template-columns: 1fr 42px;\n    gap: 9px;\n    border-radius: 18px;\n    padding: 3px 8px;\n  }\n\n  .se-search-dock .se-search-field-location {\n    grid-column: 1 / -1;\n    grid-row: 2;\n    border-left: 0;\n    border-top: 1px solid var(--se-border);\n  }\n\n  .se-search-dock .se-search-filter-btn {\n    grid-column: 2;\n    grid-row: 1;\n    align-self: center;\n  }\n}\n\n@media (max-width: 520px) {\n  .se-drawer-search .se-search {\n    grid-template-columns: 1fr 42px;\n    border-radius: 18px;\n    padding: 3px 8px;\n  }\n\n  .se-drawer-search .se-search-field-location {\n    grid-column: 1 / -1;\n    grid-row: 2;\n    border-left: 0;\n    border-top: 1px solid var(--se-border);\n  }\n\n  .se-drawer-search .se-search-filter-btn {\n    grid-column: 2;\n    grid-row: 1;\n    align-self: center;\n  }\n}\n\n/* Event search filter sheet / popup. */\n.se-filter-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 220;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n}\n\n.se-filter-backdrop {\n  position: absolute;\n  inset: 0;\n  border: 0;\n  background: rgba(15, 18, 26, 0.42);\n  cursor: pointer;\n}\n\n.se-filter-panel {\n  position: relative;\n  width: min(860px, 100%);\n  max-height: min(84vh, 760px);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  border-radius: 22px;\n  background: #f6f7fb;\n  box-shadow: 0 28px 70px rgba(31, 36, 48, 0.24);\n}\n\n.se-filter-handle {\n  display: none;\n}\n\n.se-filter-head {\n  display: grid;\n  grid-template-columns: 42px 1fr 42px;\n  align-items: center;\n  padding: 16px 20px 14px;\n  border-bottom: 1px solid #e4e7f1;\n}\n\n.se-filter-head h2 {\n  margin: 0;\n  color: #1f2430;\n  font-size: 18px;\n  font-weight: 850;\n  text-align: center;\n}\n\n.se-filter-close {\n  width: 34px;\n  height: 34px;\n  border: 0;\n  border-radius: 12px;\n  background: transparent;\n  color: #1f2430;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.se-filter-body {\n  overflow: auto;\n  padding: 18px 20px 20px;\n}\n\n.se-filter-section {\n  padding: 16px 4px;\n  border-bottom: 1px solid #e4e7f1;\n}\n\n.se-filter-section:first-child {\n  padding-top: 0;\n}\n\n.se-filter-section:last-child {\n  border-bottom: 0;\n}\n\n.se-filter-section h3 {\n  margin: 0 0 12px;\n  color: #1f2430;\n  font-size: 15px;\n  font-weight: 850;\n}\n\n.se-filter-cat-grid {\n  display: grid;\n  grid-template-columns: repeat(6, minmax(92px, 1fr));\n  gap: 10px;\n}\n\n.se-filter-cat {\n  min-height: 98px;\n  padding: 10px;\n  border: 1.5px solid #e8dcfa;\n  border-radius: 14px;\n  background: #fff;\n  color: #1f2430;\n  text-align: left;\n  cursor: pointer;\n}\n\n.se-filter-cat.se-active {\n  border-color: var(--cat-color);\n  border-width: 2px;\n}\n\n.se-filter-cat-top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.se-filter-cat-icon {\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  background: color-mix(in srgb, var(--cat-color) 14%, white);\n  color: var(--cat-color);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  font-weight: 900;\n}\n\n.se-filter-cat-radio {\n  width: 16px;\n  height: 16px;\n  border: 1.5px solid #e4e7f1;\n  border-radius: 999px;\n  margin-top: 2px;\n}\n\n.se-filter-cat.se-active .se-filter-cat-radio {\n  border-color: var(--cat-color);\n  background: radial-gradient(circle, #fff 0 35%, var(--cat-color) 38% 100%);\n}\n\n.se-filter-cat-name {\n  display: block;\n  color: #1f2430;\n  font-size: 11.5px;\n  font-weight: 650;\n  line-height: 1.25;\n  text-align: center;\n}\n\n.se-filter-segment,\n.se-filter-chip-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.se-filter-segment button,\n.se-filter-chip-row button {\n  min-height: 36px;\n  padding: 8px 12px;\n  border: 1px solid #e4e7f1;\n  border-radius: 999px;\n  background: #fff;\n  color: #1f2430;\n  font-size: 13px;\n  font-weight: 750;\n  cursor: pointer;\n}\n\n.se-filter-segment button.se-active,\n.se-filter-chip-row button.se-active {\n  border-color: #5b8fe8;\n  background: #5b8fe8;\n  color: #fff;\n}\n\n.se-filter-note {\n  margin: 10px 0 0;\n  color: #5b8fe8;\n  font-size: 12px;\n  font-style: italic;\n}\n\n.se-filter-two {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 22px;\n}\n\n.se-filter-date-row,\n.se-filter-price-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n}\n\n.se-filter-date-row label,\n.se-filter-price-row label {\n  display: grid;\n  gap: 6px;\n}\n\n.se-filter-date-row span,\n.se-filter-price-row span {\n  color: #5b8fe8;\n  font-size: 12px;\n  font-weight: 750;\n}\n\n.se-filter-date-row input,\n.se-filter-price-row input {\n  width: 100%;\n  box-sizing: border-box;\n  height: 42px;\n  border: 1px solid #e4e7f1;\n  border-radius: 12px;\n  background: #fff;\n  color: #1f2430;\n  padding: 0 12px;\n  font-size: 14px;\n  outline: none;\n}\n\n.se-filter-free {\n  min-height: 42px;\n  display: inline-flex;\n  align-items: center;\n  gap: 9px;\n  margin-bottom: 10px;\n  color: #1f2430;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.se-filter-free input {\n  width: 18px;\n  height: 18px;\n  accent-color: #5b8fe8;\n}\n\n.se-filter-footer {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n  padding: 14px 20px 18px;\n  border-top: 1px solid #e4e7f1;\n  background: #f6f7fb;\n}\n\n.se-filter-reset,\n.se-filter-apply {\n  min-height: 48px;\n  border-radius: 14px;\n  font-size: 13px;\n  font-weight: 850;\n  cursor: pointer;\n}\n\n.se-filter-reset {\n  border: 1.5px solid #5b8fe8;\n  background: transparent;\n  color: #5b8fe8;\n}\n\n.se-filter-apply {\n  border: 1.5px solid #5b8fe8;\n  background: #5b8fe8;\n  color: #fff;\n  box-shadow: 0 8px 18px rgba(91, 143, 232, 0.26);\n}\n\n@media (max-width: 900px) {\n  .se-filter-overlay {\n    align-items: flex-end;\n    padding: 0;\n  }\n\n  .se-filter-panel {\n    width: 100%;\n    max-height: 88vh;\n    border-radius: 20px 20px 0 0;\n  }\n\n  .se-filter-handle {\n    display: block;\n    align-self: center;\n    width: 38px;\n    height: 4px;\n    border-radius: 999px;\n    background: #e4e7f1;\n    margin-top: 8px;\n  }\n\n  .se-filter-cat-grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n\n  .se-filter-two {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 520px) {\n  .se-filter-body {\n    padding-inline: 16px;\n  }\n\n  .se-filter-cat-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .se-filter-date-row,\n  .se-filter-price-row {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Final safety pass for the event-search header:\n   keep the utility cluster on the right, prevent nav text overlap, and keep the\n   filter dialog fully visible on every viewport. */\n.se-topbar-links {\n  min-width: 0;\n}\n\n.se-topbar-links a,\n.se-category-trigger {\n  flex: 0 0 auto;\n  white-space: nowrap;\n}\n\n@media (min-width: 1121px) {\n  .se-header-main-block {\n    min-width: 0;\n    gap: clamp(8px, 0.9vw, 14px);\n  }\n\n  .se-header-main-block .se-search {\n    flex: 0 1 430px;\n    width: min(430px, 29vw);\n    max-width: 430px;\n  }\n\n  .se-topbar-links {\n    gap: clamp(8px, 0.75vw, 13px);\n  }\n}\n\n@media (min-width: 1121px) and (max-width: 1320px) {\n  .se-nav-help {\n    display: none;\n  }\n}\n\n@media (min-width: 1121px) and (max-width: 1240px) {\n  .se-nav-venues {\n    display: none;\n  }\n\n  .se-header-main-block .se-search {\n    width: min(400px, 32vw);\n    max-width: 400px;\n  }\n}\n\n@media (min-width: 761px) and (max-width: 1120px) {\n  .se-topbar-right {\n    width: 100%;\n  }\n\n  .se-header-main-block {\n    margin-left: auto;\n  }\n\n  .se-header-actions {\n    margin-left: 6px;\n  }\n}\n\n@media (min-width: 761px) and (max-width: 980px) {\n  .se-header-main-block {\n    flex: 1 1 auto;\n    justify-content: flex-end;\n  }\n\n  .se-header-main-block .se-search {\n    flex: 0 1 330px;\n    width: min(330px, 42vw);\n    min-width: 0;\n    max-width: 330px;\n  }\n}\n\n@media (min-width: 761px) and (max-width: 860px) {\n  .se-header-main-block .se-search {\n    display: none;\n  }\n\n  .se-search-toggle {\n    display: inline-flex;\n  }\n\n  .se-ticket-quick {\n    display: inline-flex;\n  }\n}\n\n.se-filter-overlay {\n  align-items: center;\n  justify-content: center;\n  padding: max(18px, env(safe-area-inset-top)) 18px max(18px, env(safe-area-inset-bottom));\n}\n\n.se-filter-panel {\n  max-height: calc(100dvh - 36px);\n}\n\n@media (max-width: 900px) {\n  .se-filter-overlay {\n    align-items: center;\n    justify-content: center;\n    padding: max(14px, env(safe-area-inset-top)) 12px max(14px, env(safe-area-inset-bottom));\n  }\n\n  .se-filter-panel {\n    width: min(560px, 100%);\n    max-height: calc(100dvh - 28px);\n    border-radius: 20px;\n  }\n}\n\n/* Last-pass stability for the combined event search and filter modal. */\n.se-search {\n  grid-template-columns: minmax(0, 1fr) minmax(0, 0.76fr) 40px;\n}\n\n.se-search-field,\n.se-search-input {\n  min-width: 0;\n}\n\n.se-search .se-search-filter-btn {\n  align-self: center;\n  justify-self: center;\n  flex: 0 0 36px;\n  max-width: 36px;\n}\n\n@media (min-width: 861px) and (max-width: 1120px) {\n  .se-header-main-block {\n    flex: 1 1 auto;\n    justify-content: flex-end;\n    gap: 8px;\n    min-width: 0;\n  }\n\n  .se-header-main-block .se-search {\n    display: grid;\n    flex: 0 1 340px;\n    width: min(340px, 36vw);\n    min-width: 0;\n    max-width: 340px;\n    grid-template-columns: minmax(0, 1fr) minmax(0, 0.68fr) 38px;\n    padding-inline: 3px;\n  }\n\n  .se-header-main-block .se-ticket-quick {\n    display: inline-flex;\n    width: 40px;\n    height: 40px;\n    padding: 0;\n  }\n\n  .se-header-main-block .se-ticket-quick svg {\n    display: block;\n  }\n\n  .se-header-main-block .se-ticket-quick span {\n    display: none;\n  }\n\n  .se-search-toggle {\n    display: none;\n  }\n}\n\n@media (min-width: 981px) and (max-width: 1040px) {\n  .se-nav-organize {\n    display: none;\n  }\n}\n\n@media (min-width: 861px) and (max-width: 980px) {\n  .se-header-main-block .se-search {\n    flex-basis: 320px;\n    width: min(320px, 39vw);\n    max-width: 320px;\n  }\n}\n\n.se-filter-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n  padding: max(24px, env(safe-area-inset-top)) 18px max(24px, env(safe-area-inset-bottom));\n}\n\n.se-filter-panel {\n  width: min(860px, calc(100vw - 36px));\n  max-height: calc(100dvh - 48px);\n  margin: auto;\n}\n\n.se-filter-body {\n  min-height: 0;\n}\n\n@media (max-width: 900px) {\n  .se-filter-overlay {\n    align-items: center;\n    justify-content: center;\n    padding: max(16px, env(safe-area-inset-top)) 12px max(16px, env(safe-area-inset-bottom));\n  }\n\n  .se-filter-panel {\n    width: min(560px, calc(100vw - 24px));\n    max-height: calc(100dvh - 32px);\n    border-radius: 20px;\n  }\n}\n\n/* Final profile action guard: keep login visible and avoid white hover states. */\n.se-topbar .se-person,\n.se-topbar .se-person:visited {\n  display: inline-flex;\n  flex: 0 0 auto;\n  color: var(--se-muted);\n  background: transparent;\n  opacity: 1;\n  visibility: visible;\n}\n\n.se-topbar .se-person:hover,\n.se-topbar .se-person:focus-visible,\n.se-topbar .se-person-in,\n.se-topbar .se-person-in:hover,\n.se-topbar .se-person-in:focus-visible {\n  color: var(--se-purple);\n  background: transparent;\n}\n\n.se-person-icon,\n.se-person svg {\n  display: inline-flex;\n  flex: 0 0 auto;\n  color: currentColor;\n}\n\n.se-person-avatar {\n  display: block;\n  width: 24px;\n  height: 24px;\n  border-radius: 999px;\n  object-fit: cover;\n  box-shadow: 0 0 0 2px rgba(91, 143, 232, 0.18);\n}\n\n@media (min-width: 901px) {\n  .se-nav-desktop .se-category-menu {\n    display: none;\n  }\n}\n\n@media (max-width: 420px) {\n  .se-header-actions {\n    flex: 0 0 auto;\n  }\n\n  .se-topbar .se-person {\n    flex-basis: 35px;\n    min-width: 35px;\n    width: 35px;\n    height: 42px;\n  }\n\n  .se-person-icon {\n    width: 24px;\n    height: 24px;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .se-person svg {\n    width: 24px;\n    height: 24px;\n  }\n}\n\n@media (max-width: 370px) {\n  .se-topbar .se-brand-logo {\n    height: 20px;\n  }\n\n  .se-search-toggle,\n  .se-ticket-quick,\n  .se-topbar .se-person,\n  .se-burger {\n    width: 33px;\n    min-width: 33px;\n  }\n\n  .se-header-main-block,\n  .se-header-actions,\n  .se-topbar-right {\n    gap: 1px;\n  }\n}\n\n/* ---- web event discovery blocks ---- */\n.se-home-live-hero {\n  position: relative;\n  min-height: 0;\n  display: grid;\n  grid-template-columns: minmax(0, 0.95fr) minmax(280px, 0.86fr);\n  align-items: center;\n  gap: clamp(20px, 4vw, 58px);\n  max-width: 1800px;\n  margin: 0 auto;\n  padding: clamp(28px, 4.2vw, 58px) clamp(18px, 4vw, 72px) clamp(20px, 3.2vw, 44px);\n  overflow: hidden;\n}\n\n.se-home-live-copy {\n  position: relative;\n  z-index: 2;\n  max-width: 650px;\n}\n\n.se-home-live-copy h1 {\n  max-width: 560px;\n  margin: 8px 0 13px;\n  color: var(--se-ink);\n  font-size: clamp(32px, 4vw, 58px);\n  line-height: 1.02;\n  letter-spacing: 0;\n  text-transform: lowercase;\n}\n\n.se-home-live-copy p {\n  margin: 0 0 14px;\n  max-width: 610px;\n  color: var(--se-muted);\n  font-size: clamp(14px, 1.05vw, 17px);\n  line-height: 1.58;\n}\n\n.se-home-live-features {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 7px;\n  max-width: 660px;\n  margin: 0 0 18px;\n}\n\n.se-home-live-features span {\n  min-height: 29px;\n  display: inline-flex;\n  align-items: center;\n  padding: 0 10px;\n  border: 1px solid #dfe7f8;\n  border-radius: 999px;\n  background: #fff;\n  color: #1f2430;\n  font-size: 12px;\n  font-weight: 800;\n  text-transform: lowercase;\n}\n\n.se-home-live-btn {\n  min-height: 40px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 15px;\n  border-radius: 999px;\n  background: #5b8fe8;\n  color: #fff;\n  font-weight: 850;\n  text-decoration: none;\n  box-shadow: 0 14px 28px rgba(91, 143, 232, 0.25);\n}\n\n.se-home-photo-stage {\n  position: relative;\n  min-height: clamp(260px, 31vw, 430px);\n}\n\n.se-home-photo-card {\n  position: absolute;\n  overflow: hidden;\n  border-radius: 8px;\n  background: linear-gradient(135deg, #eaf1ff, #f6f2ff);\n  box-shadow: 0 26px 60px rgba(31, 36, 48, 0.2);\n  animation: se-photo-float 7s ease-in-out infinite;\n}\n\n.se-home-photo-card img {\n  width: 100%;\n  height: 100%;\n  display: block;\n  object-fit: cover;\n}\n\n.se-home-photo-card span {\n  position: absolute;\n  left: 10px;\n  bottom: 10px;\n  width: auto;\n  height: auto;\n  display: inline-flex;\n  align-items: center;\n  min-height: 27px;\n  padding: 0 9px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.9);\n  color: #1f2430;\n  font-size: 11px;\n  font-weight: 900;\n  text-transform: lowercase;\n  backdrop-filter: blur(8px);\n}\n\n.se-home-photo-1 { left: 6%; top: 3%; width: 43%; aspect-ratio: 4 / 5; transform: rotate(-5deg); }\n.se-home-photo-2 { right: 8%; top: 12%; width: 39%; aspect-ratio: 1 / 1; transform: rotate(4deg); animation-delay: -1.2s; }\n.se-home-photo-3 { left: 25%; bottom: 4%; width: 39%; aspect-ratio: 16 / 11; transform: rotate(3deg); animation-delay: -2.4s; }\n.se-home-photo-4 { right: 17%; bottom: 12%; width: 24%; aspect-ratio: 1; transform: rotate(-7deg); animation-delay: -3.4s; }\n\n@keyframes se-photo-float {\n  0%, 100% { translate: 0 0; }\n  50% { translate: 0 -14px; }\n}\n\n.se-home-categories-wrap {\n  position: relative;\n  display: grid;\n  grid-template-columns: 42px minmax(0, 1fr) 42px;\n  align-items: center;\n  gap: 8px;\n  padding-top: 4px;\n  padding-bottom: 28px;\n}\n\n.se-home-categories {\n  min-width: 0;\n  display: flex;\n  gap: 10px;\n  overflow-x: auto;\n  padding: 2px 2px 8px;\n  scrollbar-width: none;\n  scroll-behavior: smooth;\n  scroll-snap-type: x proximity;\n}\n\n.se-home-categories::-webkit-scrollbar {\n  display: none;\n}\n\n.se-home-cat-pill {\n  flex: 0 0 116px;\n  min-height: 92px;\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 9px;\n  padding: 10px 9px;\n  border: 1px solid color-mix(in srgb, var(--cat-color) 24%, #e4e7f1);\n  border-radius: 8px;\n  background: #fff;\n  color: #1f2430;\n  text-decoration: none;\n  text-align: center;\n  scroll-snap-align: start;\n}\n\n.se-home-cat-pill span {\n  width: 42px;\n  height: 42px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 12px;\n  background: color-mix(in srgb, var(--cat-color) 12%, #fff);\n  color: var(--cat-color);\n  font-size: 22px;\n  font-weight: 950;\n}\n\n.se-home-cat-pill strong {\n  max-width: 100%;\n  font-size: 12px;\n  line-height: 1.18;\n  white-space: normal;\n}\n\n.se-home-cat-arrow {\n  width: 38px;\n  height: 38px;\n  border: 0;\n  border-radius: 999px;\n  background: #fff;\n  color: #5b8fe8;\n  box-shadow: 0 10px 24px rgba(31, 36, 48, 0.12);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 26px;\n  font-weight: 700;\n  line-height: 1;\n  cursor: pointer;\n  transition: opacity 0.16s ease, transform 0.16s ease;\n}\n\n.se-home-cat-arrow:hover:not(:disabled) {\n  transform: translateY(-1px);\n}\n\n.se-home-cat-arrow:disabled {\n  opacity: 0.24;\n  cursor: default;\n  box-shadow: none;\n}\n\n.se-home-highlight,\n.se-results-page {\n  padding-top: 24px;\n  padding-bottom: 52px;\n}\n\n.se-home-section-head,\n.se-results-head {\n  margin-bottom: 18px;\n}\n\n.se-home-section-head {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.se-home-section-head h2,\n.se-results-head h1 {\n  margin: 7px 0 0;\n  color: var(--se-ink);\n}\n\n.se-home-section-head h2 {\n  font-size: clamp(26px, 3vw, 42px);\n}\n\n.se-home-section-head a {\n  color: #5b8fe8;\n  font-weight: 850;\n  text-decoration: none;\n  white-space: nowrap;\n}\n\n.se-results-head {\n  max-width: 760px;\n}\n\n.se-results-head h1 {\n  font-size: clamp(30px, 4vw, 54px);\n}\n\n.se-results-head p {\n  color: var(--se-muted);\n  line-height: 1.6;\n}\n\n.se-event-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 18px;\n}\n\n.se-event-card {\n  min-width: 0;\n  overflow: hidden;\n  border: 1px solid #e4e7f1;\n  border-radius: 8px;\n  background: #fff;\n  color: inherit;\n  text-decoration: none;\n  box-shadow: 0 12px 28px rgba(31, 36, 48, 0.08);\n  transition: transform 0.18s ease, box-shadow 0.18s ease;\n}\n\n.se-event-card:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 18px 38px rgba(31, 36, 48, 0.14);\n}\n\n.se-event-card-media {\n  position: relative;\n  aspect-ratio: 1 / 1;\n  overflow: hidden;\n  background: #eaf1ff;\n}\n\n.se-event-card-media img {\n  width: 100%;\n  height: 100%;\n  display: block;\n  object-fit: cover;\n}\n\n.se-event-card-empty {\n  width: 100%;\n  height: 100%;\n  display: grid;\n  place-items: center;\n  color: #5b8fe8;\n  font-weight: 900;\n}\n\n.se-event-date-badge,\n.se-event-kind-badge {\n  position: absolute;\n  top: 10px;\n  border-radius: 999px;\n  color: #fff;\n  font-size: 11px;\n  font-weight: 900;\n  line-height: 1;\n}\n\n.se-event-date-badge {\n  left: 10px;\n  padding: 7px 9px;\n  background: rgba(31, 36, 48, 0.76);\n}\n\n.se-event-kind-badge {\n  right: 10px;\n  padding: 7px 9px;\n  background: #5b8fe8;\n}\n\n.se-event-card-body {\n  min-height: 118px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 12px;\n}\n\n.se-event-card-body h3 {\n  margin: 0;\n  color: #1f2430;\n  font-size: 15px;\n  line-height: 1.25;\n}\n\n.se-event-card-location {\n  margin: 8px 0 0;\n  color: var(--se-muted);\n  font-size: 13px;\n}\n\n.se-event-card-foot {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-top: 12px;\n  color: #5b8fe8;\n  font-size: 13px;\n  font-weight: 850;\n}\n\n.se-event-empty,\n.se-event-loading {\n  padding: 22px;\n  border: 1px dashed #d7def0;\n  border-radius: 8px;\n  color: var(--se-muted);\n  background: #fff;\n}\n\n.se-event-grid-loading {\n  pointer-events: none;\n}\n\n.se-event-skeleton-card {\n  box-shadow: 0 10px 24px rgba(31, 36, 48, 0.06);\n}\n\n.se-event-skeleton-thumb,\n.se-event-skeleton-line {\n  position: relative;\n  overflow: hidden;\n  background: linear-gradient(90deg, #edf1f8 0%, #f7f9fd 48%, #edf1f8 100%);\n  background-size: 220% 100%;\n  animation: se-skeleton-shimmer 1.15s ease-in-out infinite;\n}\n\n.se-event-skeleton-thumb::after {\n  content: \"\";\n  position: absolute;\n  inset: 18px;\n  border-radius: 8px;\n  border: 1px solid rgba(91, 143, 232, 0.16);\n}\n\n.se-event-skeleton-line {\n  display: block;\n  height: 12px;\n  border-radius: 999px;\n}\n\n.se-event-skeleton-title {\n  width: 78%;\n  height: 15px;\n}\n\n.se-event-skeleton-meta {\n  width: 58%;\n  margin-top: 12px;\n}\n\n.se-event-skeleton-price {\n  width: 68px;\n}\n\n.se-event-skeleton-action {\n  width: 54px;\n}\n\n@keyframes se-skeleton-shimmer {\n  0% { background-position: 100% 0; }\n  100% { background-position: -100% 0; }\n}\n\n@media (max-width: 860px) {\n  .se-home-live-hero {\n    grid-template-columns: 1fr;\n    min-height: 0;\n  }\n\n  .se-home-photo-stage {\n    min-height: 300px;\n  }\n\n  .se-event-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 12px;\n  }\n}\n\n@media (max-width: 520px) {\n  .se-home-live-hero {\n    padding-inline: 14px;\n  }\n\n  .se-home-photo-stage {\n    min-height: 260px;\n  }\n\n  .se-home-cat-pill strong {\n    font-size: 12px;\n  }\n\n  .se-home-categories-wrap {\n    grid-template-columns: 34px minmax(0, 1fr) 34px;\n    gap: 4px;\n    padding-inline: 8px;\n  }\n\n  .se-home-cat-arrow {\n    width: 32px;\n    height: 32px;\n    font-size: 22px;\n  }\n\n  .se-home-cat-pill {\n    flex-basis: 98px;\n    min-height: 88px;\n  }\n\n  .se-event-card-body {\n    min-height: 110px;\n    padding: 10px;\n  }\n}\n\n/* ============================================================ cookie consent */\n.se-cc-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 18, 26, 0.55);\n  backdrop-filter: blur(3px);\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  z-index: 9999;\n  padding: 16px;\n  animation: se-cc-fade 0.2s ease;\n}\n\n@keyframes se-cc-fade {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.se-cc-card {\n  background: #fff;\n  width: 100%;\n  max-width: 560px;\n  border-radius: 20px;\n  box-shadow: var(--se-shadow);\n  overflow: hidden;\n  max-height: 92vh;\n  display: flex;\n  flex-direction: column;\n  animation: se-cc-rise 0.25s ease;\n}\n\n@keyframes se-cc-rise {\n  from {\n    transform: translateY(24px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n.se-cc-head {\n  background: var(--se-grad);\n  color: #fff;\n  padding: 22px 24px 18px;\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n\n.se-cc-head svg {\n  width: 46px;\n  height: 46px;\n  flex: 0 0 auto;\n}\n\n.se-cc-head h2 {\n  margin: 0;\n  font-size: 19px;\n  font-family: var(--se-font);\n}\n\n.se-cc-body {\n  padding: 20px 24px 4px;\n  overflow-y: auto;\n  font-family: var(--se-font);\n  color: var(--se-ink);\n  line-height: 1.6;\n}\n\n.se-cc-body p {\n  margin: 0 0 12px;\n  font-size: 14.5px;\n  color: #313846;\n}\n\n.se-cc-body a {\n  color: var(--se-purple);\n  font-weight: 600;\n}\n\n/* category rows */\n.se-cc-cat {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 14px;\n  padding: 14px 0;\n  border-top: 1px solid var(--se-border);\n}\n\n.se-cc-cat-title {\n  font-weight: 700;\n  font-size: 14.5px;\n  margin: 0 0 3px;\n}\n\n.se-cc-cat-desc {\n  margin: 0;\n  font-size: 13px;\n  color: var(--se-muted);\n}\n\n/* toggle */\n.se-switch {\n  position: relative;\n  width: 44px;\n  height: 26px;\n  flex: 0 0 auto;\n  margin-top: 2px;\n}\n\n.se-switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.se-switch .se-slider {\n  position: absolute;\n  inset: 0;\n  background: #cfd4e0;\n  border-radius: 999px;\n  transition: background 0.2s ease;\n}\n\n.se-switch .se-slider::before {\n  content: \"\";\n  position: absolute;\n  height: 20px;\n  width: 20px;\n  left: 3px;\n  top: 3px;\n  background: #fff;\n  border-radius: 50%;\n  transition: transform 0.2s ease;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);\n}\n\n.se-switch input:checked + .se-slider {\n  background: var(--se-purple);\n}\n\n.se-switch input:checked + .se-slider::before {\n  transform: translateX(18px);\n}\n\n.se-switch input:disabled + .se-slider {\n  background: var(--se-blue);\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* actions */\n.se-cc-actions {\n  padding: 16px 24px 22px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.se-btn {\n  flex: 1 1 auto;\n  border: none;\n  border-radius: 12px;\n  padding: 13px 18px;\n  font: inherit;\n  font-weight: 700;\n  font-size: 14.5px;\n  cursor: pointer;\n  font-family: var(--se-font);\n  transition: transform 0.05s ease, box-shadow 0.2s ease;\n}\n\n.se-btn:active {\n  transform: translateY(1px);\n}\n\n.se-btn-primary {\n  background: var(--se-grad);\n  color: #fff;\n  box-shadow: var(--se-shadow-sm);\n}\n\n.se-btn-ghost {\n  background: var(--se-surface);\n  color: var(--se-ink);\n  border: 1px solid var(--se-border);\n}\n\n.se-btn-text {\n  background: none;\n  color: var(--se-purple);\n  flex: 1 1 100%;\n  order: 3;\n}\n\n.se-cc-foot {\n  padding: 0 24px 18px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: nowrap;\n  font-size: 12.5px;\n}\n\n.se-cc-foot-links {\n  display: flex;\n  gap: 14px;\n  flex: 1 1 auto;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.se-cc-foot a {\n  color: var(--se-muted);\n  text-decoration: none;\n  font-weight: 600;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-width: 0;\n}\n\n.se-cc-foot a:hover {\n  color: var(--se-purple);\n}\n\n.se-cc-lang {\n  position: relative;\n  flex: 0 0 auto;\n}\n\n.se-cc-lang-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  border: 1px solid var(--se-border);\n  border-radius: 8px;\n  background: var(--se-surface);\n  color: var(--se-muted);\n  font-family: var(--se-font);\n  font-weight: 600;\n  font-size: 12.5px;\n  padding: 4px 8px;\n  cursor: pointer;\n  max-width: 160px;\n}\n\n.se-cc-lang-btn:hover,\n.se-cc-lang-btn:focus {\n  color: var(--se-purple);\n  border-color: var(--se-purple);\n  outline: none;\n}\n\n.se-cc-lang-flag {\n  font-size: 14px;\n  line-height: 1;\n}\n\n.se-cc-lang-label {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.se-cc-lang-menu {\n  min-width: 210px;\n  max-height: 260px;\n  overflow-y: auto;\n  margin: 0;\n  padding: 6px;\n  list-style: none;\n  background: var(--se-white);\n  border: 1px solid var(--se-border);\n  border-radius: var(--se-radius-sm);\n  box-shadow: var(--se-shadow);\n  z-index: 10000;\n}\n\n.se-cc-lang-opt {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 9px 10px;\n  border: none;\n  border-radius: 8px;\n  background: none;\n  font-family: var(--se-font);\n  font-size: 14px;\n  color: var(--se-ink);\n  cursor: pointer;\n  text-align: left;\n}\n\n.se-cc-lang-opt:hover,\n.se-cc-lang-opt.se-active {\n  background: var(--se-grad-soft);\n  color: var(--se-purple);\n}\n\n.se-cc-lang-opt-label {\n  font-weight: 600;\n}\n\n/* re-open settings floating link used on policy pages */\n.se-reopen {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: var(--se-grad);\n  color: #fff;\n  border: none;\n  border-radius: 12px;\n  padding: 12px 18px;\n  font: inherit;\n  font-weight: 700;\n  cursor: pointer;\n  font-family: var(--se-font);\n  box-shadow: var(--se-shadow-sm);\n  margin: 8px 0;\n}\n\n/* ============================================================== help center */\n/* full-bleed hero: huge illustration with the heading overlaid on top */\n.se-hc-hero {\n  position: relative;\n  min-height: 440px;\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n  border-bottom: 1px solid var(--se-border);\n}\n\n.se-hc-hero-art {\n  position: absolute;\n  inset: 0;\n}\n\n.se-hc-hero-art svg {\n  width: 100%;\n  height: 100%;\n  display: block;\n}\n\n/* darkening scrim so white text stays legible over the illustration */\n.se-hc-scrim {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(\n    90deg,\n    rgba(18, 16, 42, 0.62) 0%,\n    rgba(18, 16, 42, 0.34) 46%,\n    rgba(18, 16, 42, 0) 78%\n  );\n}\n\n.se-hc-hero-inner {\n  position: relative;\n  z-index: 2;\n  width: 100%;\n  max-width: 1080px;\n  margin: 0 auto;\n  padding: 60px 24px;\n}\n\n.se-hc-hero-text {\n  max-width: 600px;\n  color: #fff;\n}\n\n.se-hc-eyebrow {\n  display: inline-block;\n  font-size: 12px;\n  font-weight: 800;\n  letter-spacing: 1.5px;\n  text-transform: uppercase;\n  color: #fff;\n  background: rgba(255, 255, 255, 0.18);\n  border: 1px solid rgba(255, 255, 255, 0.35);\n  border-radius: 999px;\n  padding: 5px 14px;\n  margin-bottom: 16px;\n  backdrop-filter: blur(4px);\n}\n\n.se-hc-hero h1 {\n  margin: 0 0 14px;\n  font-size: 46px;\n  line-height: 1.08;\n  letter-spacing: -1px;\n  color: #fff;\n}\n\n.se-hc-hero-sub {\n  margin: 0 0 24px;\n  font-size: 18px;\n  line-height: 1.55;\n  color: rgba(255, 255, 255, 0.94);\n  max-width: 48ch;\n}\n\n.se-hc-cta-row {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.se-hc-cta {\n  display: inline-flex;\n  align-items: center;\n  gap: 9px;\n  background: #fff;\n  color: var(--se-purple);\n  border-radius: 12px;\n  padding: 13px 22px;\n  font-weight: 800;\n  font-size: 15px;\n  text-decoration: none;\n  box-shadow: 0 8px 22px rgba(18, 16, 42, 0.25);\n}\n\n.se-hc-cta:hover {\n  transform: translateY(-1px);\n}\n\n.se-hc-note {\n  color: rgba(255, 255, 255, 0.85);\n  font-size: 13.5px;\n}\n\n/* lead paragraph under the hero */\n.se-hc-lead {\n  font-size: 17px;\n  color: var(--se-muted);\n  max-width: 70ch;\n  margin: 0 0 8px;\n}\n\n/* App-first red disclaimer banner at the top of the Help Center. */\n.se-hc-disclaimer {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  margin: 0 0 22px;\n  padding: 14px 18px;\n  border: 1px solid #f1b0b0;\n  border-left: 5px solid #d12b2b;\n  border-radius: 12px;\n  background: #fdecec;\n  color: #8f1d1d;\n}\n\n.se-hc-disclaimer p {\n  margin: 0;\n  font-size: 14.5px;\n  line-height: 1.5;\n}\n\n.se-hc-disclaimer strong {\n  color: #7a1414;\n}\n\n.se-hc-disclaimer-icon {\n  font-size: 20px;\n  line-height: 1.4;\n  flex: 0 0 auto;\n}\n\n/* topic grid */\n.se-hc-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(248px, 1fr));\n  gap: 16px;\n  margin: 20px 0 8px;\n}\n\n.se-hc-topic {\n  display: flex;\n  gap: 14px;\n  align-items: flex-start;\n  background: var(--se-surface);\n  border: 1px solid var(--se-border);\n  border-radius: var(--se-radius);\n  padding: 18px;\n  text-decoration: none;\n  color: inherit;\n  transition: box-shadow 0.2s ease, transform 0.06s ease;\n}\n\n.se-hc-topic:hover {\n  box-shadow: var(--se-shadow-sm);\n  transform: translateY(-2px);\n}\n\n.se-hc-topic-art {\n  flex: 0 0 auto;\n  width: 46px;\n  height: 46px;\n}\n\n.se-hc-topic-art svg {\n  width: 100%;\n  height: 100%;\n  display: block;\n}\n\n.se-hc-topic h3 {\n  margin: 0 0 5px;\n  font-size: 16px;\n}\n\n.se-hc-topic p {\n  margin: 0;\n  color: var(--se-muted);\n  font-size: 13.5px;\n  line-height: 1.55;\n}\n\n/* FAQ accordion (native details/summary) */\n.se-hc-q {\n  border: 1px solid var(--se-border);\n  border-radius: var(--se-radius-sm);\n  margin: 10px 0;\n  background: #fff;\n  overflow: hidden;\n}\n\n.se-hc-q summary {\n  cursor: pointer;\n  list-style: none;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 14px;\n  padding: 15px 18px;\n  font-weight: 700;\n  font-size: 15.5px;\n  color: var(--se-ink);\n}\n\n.se-hc-q summary::-webkit-details-marker {\n  display: none;\n}\n\n.se-hc-q summary::after {\n  content: \"+\";\n  font-size: 22px;\n  font-weight: 400;\n  color: var(--se-purple);\n  line-height: 1;\n  transition: transform 0.2s ease;\n}\n\n.se-hc-q[open] summary {\n  color: var(--se-purple);\n}\n\n.se-hc-q[open] summary::after {\n  transform: rotate(45deg);\n}\n\n.se-hc-a {\n  padding: 0 18px 16px;\n  color: #313846;\n  font-size: 14.5px;\n  line-height: 1.65;\n}\n\n.se-hc-a a {\n  color: var(--se-purple);\n  font-weight: 600;\n}\n\n/* contact band */\n.se-hc-contact {\n  background: var(--se-grad);\n  color: #fff;\n  border-radius: var(--se-radius);\n  padding: 30px 32px;\n  margin: 28px 0 8px;\n  display: flex;\n  align-items: center;\n  gap: 26px;\n  flex-wrap: wrap;\n  box-shadow: var(--se-shadow);\n}\n\n.se-hc-contact-art {\n  flex: 0 0 auto;\n  width: 84px;\n  height: 84px;\n}\n\n.se-hc-contact-art svg {\n  width: 100%;\n  height: 100%;\n}\n\n.se-hc-contact-body {\n  flex: 1 1 280px;\n}\n\n.se-hc-contact h2 {\n  margin: 0 0 6px;\n  color: #fff;\n  font-size: 22px;\n}\n\n.se-hc-contact p {\n  margin: 0 0 16px;\n  color: rgba(255, 255, 255, 0.92);\n  font-size: 15px;\n}\n\n.se-hc-mail {\n  display: inline-flex;\n  align-items: center;\n  gap: 9px;\n  background: #fff;\n  color: var(--se-purple);\n  border-radius: 12px;\n  padding: 12px 20px;\n  font-weight: 800;\n  font-size: 15px;\n  text-decoration: none;\n  box-shadow: 0 6px 18px rgba(18, 16, 42, 0.22);\n}\n\n.se-hc-contact-meta {\n  margin: 14px 0 0;\n  color: rgba(255, 255, 255, 0.82);\n  font-size: 13px;\n}\n\n/* ----------------------------------------------------------- responsiveness */\n@media (max-width: 760px) {\n  .se-hc-hero {\n    min-height: 380px;\n  }\n  .se-hc-hero h1 {\n    font-size: 32px;\n  }\n  .se-hc-hero-sub {\n    font-size: 16px;\n  }\n  .se-hc-scrim {\n    background: linear-gradient(\n      180deg,\n      rgba(18, 16, 42, 0.3) 0%,\n      rgba(18, 16, 42, 0.55) 100%\n    );\n  }\n  .se-hc-contact {\n    padding: 24px;\n  }\n}\n\n@media (max-width: 640px) {\n  .se-hero-inner {\n    flex-direction: column-reverse;\n    text-align: center;\n    gap: 18px;\n    padding: 32px 20px;\n  }\n  .se-hero p {\n    margin: 0 auto;\n  }\n  .se-hero-art {\n    width: 130px;\n    height: 130px;\n  }\n  .se-hero h1 {\n    font-size: 27px;\n  }\n  .se-cc-overlay {\n    padding: 0;\n  }\n  .se-cc-card {\n    max-width: 100%;\n    border-radius: 18px 18px 0 0;\n    max-height: 94vh;\n  }\n}\n\n/* ═══════════════════════════════════════════════════════════════════════════\n   HOME / LANDING PAGE\n   ═══════════════════════════════════════════════════════════════════════════ */\n\n/* split hero: copy left, illustration right */\n.se-home-hero {\n  background: var(--se-grad-soft);\n  border-bottom: 1px solid var(--se-border);\n  overflow: hidden;\n}\n\n.se-home-hero-inner {\n  max-width: 1120px;\n  margin: 0 auto;\n  padding: 56px 24px;\n  display: grid;\n  grid-template-columns: 1.05fr 1fr;\n  align-items: center;\n  gap: 40px;\n}\n\n.se-home-hero-text h1 {\n  font-size: 42px;\n  line-height: 1.08;\n  letter-spacing: -1px;\n  margin: 0 0 18px;\n  color: var(--se-ink);\n}\n\n.se-home-eyebrow {\n  color: #fff;\n  background: var(--se-grad);\n  border: none;\n  margin-bottom: 18px;\n}\n\n.se-home-hero-sub {\n  font-size: 17.5px;\n  line-height: 1.6;\n  color: var(--se-muted);\n  margin: 0 0 18px;\n  max-width: 56ch;\n}\n\n.se-home-tagline {\n  font-size: 16px;\n  font-weight: 800;\n  color: var(--se-purple);\n  margin: 0;\n}\n\n.se-home-hero-art {\n  width: 100%;\n}\n\n.se-home-hero-art svg {\n  width: 100%;\n  height: auto;\n  display: block;\n  filter: drop-shadow(0 18px 40px rgba(76, 60, 180, 0.18));\n}\n\n/* content spacing tweak for the home page */\n.se-home-content {\n  max-width: 1000px;\n}\n\n/* App-first notice pinned directly under the header on the home page:\n   red disclaimer banner with the store badges right below it. */\n.se-home-top-notice {\n  padding-top: 20px;\n}\n\n.se-home-top-notice .se-hc-disclaimer {\n  margin-bottom: 0;\n}\n\n.se-home-top-notice .se-home-get {\n  margin: 16px 0 4px;\n}\n\n@media (max-width: 760px) {\n  .se-home-top-notice {\n    padding-top: 14px;\n  }\n}\n\n/* download strip */\n.se-home-get {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 14px;\n  text-align: center;\n  margin: 28px 0 8px;\n}\n\n.se-home-get-label {\n  font-size: 15px;\n  font-weight: 700;\n  color: var(--se-ink);\n}\n\n/* store badges (shared: home + footer) */\n.se-store-badges {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.se-store-badge {\n  display: inline-flex;\n  line-height: 0;\n  border-radius: 10px;\n  text-decoration: none;\n  transition: transform 0.08s ease, box-shadow 0.2s ease;\n}\n\n.se-store-badge svg {\n  height: 48px;\n  width: auto;\n  display: block;\n}\n\n.se-store-badge:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--se-shadow-sm);\n}\n\n/* features */\n.se-home-feat-heading {\n  text-align: center;\n  font-size: 26px;\n  letter-spacing: -0.4px;\n  margin: 56px 0 8px;\n}\n\n.se-home-feat-lead {\n  text-align: center;\n  color: var(--se-muted);\n  font-size: 16px;\n  max-width: 60ch;\n  margin: 0 auto 20px;\n}\n\n.se-home-features {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  margin-top: 24px;\n}\n\n.se-home-feature {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  align-items: center;\n  gap: 32px;\n  background: var(--se-surface);\n  border: 1px solid var(--se-border);\n  border-radius: var(--se-radius);\n  padding: 26px 30px;\n}\n\n.se-home-feature-rev .se-home-feature-art {\n  order: 2;\n}\n\n.se-home-feature-art svg {\n  width: 100%;\n  height: auto;\n  max-height: 240px;\n  display: block;\n}\n\n.se-home-feature-body h3 {\n  font-size: 21px;\n  margin: 0 0 10px;\n  letter-spacing: -0.3px;\n}\n\n.se-home-feature-body p {\n  font-size: 15.5px;\n  line-height: 1.6;\n  color: #313846;\n  margin: 0;\n}\n\n/* closing CTA band */\n.se-home-cta-band {\n  margin: 48px 0 8px;\n  padding: 40px 28px;\n  border-radius: var(--se-radius);\n  background: var(--se-grad);\n  color: #fff;\n  text-align: center;\n}\n\n.se-home-cta-band h2 {\n  color: #fff;\n  font-size: 24px;\n  margin: 0 0 8px;\n}\n\n.se-home-cta-band p {\n  color: rgba(255, 255, 255, 0.92);\n  margin: 0 0 20px;\n  font-size: 16px;\n}\n\n/* footer store block */\n.se-foot-stores {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 18px;\n}\n\n.se-foot-stores-label {\n  font-size: 12.5px;\n  font-weight: 700;\n  color: var(--se-muted);\n}\n\n.se-foot-stores .se-store-badge svg {\n  height: 42px;\n}\n\n@media (max-width: 820px) {\n  .se-home-hero-inner {\n    grid-template-columns: 1fr;\n    text-align: center;\n    gap: 24px;\n  }\n  .se-home-hero-text h1 {\n    font-size: 34px;\n  }\n  .se-home-hero-sub {\n    margin-left: auto;\n    margin-right: auto;\n  }\n  .se-home-hero-art {\n    max-width: 420px;\n    margin: 0 auto;\n  }\n  .se-home-feature,\n  .se-home-feature-rev {\n    grid-template-columns: 1fr;\n    gap: 18px;\n    text-align: center;\n  }\n  .se-home-feature-rev .se-home-feature-art {\n    order: 0;\n  }\n  .se-home-feature-art svg {\n    max-width: 300px;\n    margin: 0 auto;\n  }\n}\n\n/* Final responsive guard: account icon, compact page starts and mobile type. */\n.se-topbar .se-person {\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  flex: 0 0 auto !important;\n  overflow: visible !important;\n  opacity: 1 !important;\n  visibility: visible !important;\n  color: var(--se-muted);\n  background: transparent !important;\n}\n\n.se-topbar .se-person:hover,\n.se-topbar .se-person:focus-visible,\n.se-topbar .se-person-in,\n.se-topbar .se-person-in:hover,\n.se-topbar .se-person-in:focus-visible {\n  color: var(--se-purple) !important;\n  background: transparent !important;\n}\n\n.se-topbar .se-person-icon {\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  width: 28px !important;\n  height: 28px !important;\n  min-width: 28px !important;\n  flex: 0 0 28px !important;\n  overflow: visible !important;\n  color: currentColor !important;\n}\n\n.se-topbar .se-person-icon svg {\n  display: block !important;\n  width: 24px !important;\n  height: 24px !important;\n}\n\n.se-topbar .se-person-avatar {\n  display: block !important;\n  width: 24px !important;\n  height: 24px !important;\n  min-width: 24px !important;\n  flex: 0 0 24px !important;\n  border-radius: 8px;\n  object-fit: cover;\n  box-shadow: 0 0 0 1px rgba(91, 143, 232, 0.2);\n}\n\n@media (max-width: 760px) {\n  .se-page h1 {\n    font-size: clamp(24px, 7vw, 42px) !important;\n    line-height: 1.12 !important;\n    letter-spacing: 0 !important;\n  }\n\n  .se-page h2 {\n    font-size: clamp(20px, 5.6vw, 32px) !important;\n    line-height: 1.16 !important;\n    letter-spacing: 0 !important;\n  }\n\n  .se-page h3 {\n    font-size: clamp(17px, 4.8vw, 22px) !important;\n    line-height: 1.2 !important;\n    letter-spacing: 0 !important;\n  }\n\n  .se-home-live-hero {\n    padding-top: 8px !important;\n    padding-bottom: 16px !important;\n    gap: 8px !important;\n  }\n\n  .se-home-live-copy h1 {\n    margin-top: 0 !important;\n    margin-bottom: 9px !important;\n  }\n\n  .se-content.se-home-highlight,\n  .se-content.se-results-page {\n    padding-top: 12px !important;\n  }\n\n  .se-results-head {\n    margin-top: 0 !important;\n    margin-bottom: 12px !important;\n  }\n\n  .se-results-head p {\n    margin-top: 8px !important;\n  }\n\n  .se-topbar .se-person {\n    width: 38px !important;\n    min-width: 38px !important;\n    height: 42px !important;\n    flex: 0 0 38px !important;\n    padding: 0 !important;\n  }\n\n  .se-topbar .se-person-label {\n    display: none !important;\n  }\n}\n\n@media (max-width: 420px) {\n  .se-page h1 {\n    font-size: clamp(23px, 7.4vw, 34px) !important;\n  }\n\n  .se-page h2 {\n    font-size: clamp(19px, 6vw, 26px) !important;\n  }\n\n  .se-home-live-hero {\n    padding-top: 4px !important;\n  }\n\n  .se-content.se-home-highlight,\n  .se-content.se-results-page {\n    padding-top: 8px !important;\n  }\n\n  .se-topbar .se-person {\n    width: 35px !important;\n    min-width: 35px !important;\n    height: 40px !important;\n    flex-basis: 35px !important;\n  }\n\n  .se-topbar .se-person-icon {\n    width: 27px !important;\n    height: 27px !important;\n    min-width: 27px !important;\n    flex-basis: 27px !important;\n  }\n\n  .se-topbar .se-person-icon svg {\n    width: 25px !important;\n    height: 25px !important;\n  }\n\n  .se-topbar .se-person-avatar {\n    width: 27px !important;\n    height: 27px !important;\n    min-width: 27px !important;\n    flex-basis: 27px !important;\n  }\n}\n\n/* Final homepage mobile spacing pass. */\n@media (max-width: 760px) {\n  .se-page > .se-home-live-hero:first-of-type {\n    margin-top: 0 !important;\n    padding-top: 0 !important;\n  }\n\n  .se-page > .se-topbar + .se-home-live-hero {\n    margin-top: -4px !important;\n    padding-top: 0 !important;\n  }\n\n  .se-home-live-copy {\n    max-width: none !important;\n  }\n\n  .se-home-live-btn {\n    margin-top: 2px !important;\n  }\n\n  .se-home-photo-stage {\n    margin-top: 20px !important;\n  }\n\n  .se-home-highlight {\n    padding-top: 6px !important;\n  }\n\n  .se-home-highlight .se-home-section-head {\n    display: grid !important;\n    grid-template-columns: minmax(0, 1fr) auto;\n    align-items: center !important;\n    column-gap: 10px !important;\n    row-gap: 5px !important;\n    margin-bottom: 12px !important;\n  }\n\n  .se-home-highlight .se-hc-eyebrow {\n    grid-column: 1 / -1;\n    width: max-content;\n    max-width: 100%;\n    font-size: 10px !important;\n    padding: 4px 8px !important;\n  }\n\n  .se-home-highlight .se-home-section-head h2 {\n    min-width: 0;\n    margin: 0 !important;\n    font-family: var(--se-font) !important;\n    font-size: clamp(17px, 4.25vw, 22px) !important;\n    line-height: 1.05 !important;\n    white-space: nowrap !important;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .se-home-highlight .se-home-section-head a {\n    margin: 0 !important;\n    font-size: 12px !important;\n    line-height: 1 !important;\n  }\n\n  .se-content.se-results-page {\n    padding-top: 0 !important;\n    margin-top: -4px !important;\n  }\n\n  .se-results-head h1 {\n    font-size: clamp(22px, 6vw, 34px) !important;\n  }\n}\n\n@media (max-width: 420px) {\n  .se-page > .se-home-live-hero:first-of-type {\n    padding-top: 0 !important;\n  }\n\n  .se-home-photo-stage {\n    margin-top: 24px !important;\n  }\n\n  .se-home-highlight .se-home-section-head h2 {\n    font-size: clamp(15px, 4.05vw, 17px) !important;\n  }\n\n  .se-home-highlight .se-home-section-head a {\n    font-size: 11px !important;\n  }\n}\n\n/* Final mobile header alignment: same slot, same gap, same vertical center. */\n@media (max-width: 500px) {\n  .se-topbar {\n    padding-top: 3px !important;\n    padding-bottom: 3px !important;\n    margin-bottom: -8px !important;\n  }\n\n  .se-topbar-inner,\n  .se-topbar-bar {\n    min-height: 44px !important;\n  }\n\n  .se-topbar-bar {\n    align-items: center !important;\n  }\n\n  .se-topbar-right {\n    min-width: 0 !important;\n    display: flex !important;\n    align-items: center !important;\n    justify-content: flex-end !important;\n    gap: 0 !important;\n  }\n\n  .se-header-main-block,\n  .se-header-actions {\n    display: flex !important;\n    align-items: center !important;\n    justify-content: flex-end !important;\n    gap: 4px !important;\n    margin-left: 0 !important;\n  }\n\n  .se-header-actions .se-locale,\n  .se-topbar-right > .se-locale,\n  .se-locale {\n    display: block !important;\n  }\n\n  .se-search-toggle,\n  .se-ticket-quick,\n  .se-locale-btn,\n  .se-topbar .se-person,\n  .se-burger {\n    width: 36px !important;\n    min-width: 36px !important;\n    height: 40px !important;\n    min-height: 40px !important;\n    flex: 0 0 36px !important;\n    display: inline-flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    padding: 0 !important;\n    margin: 0 !important;\n    border: 0 !important;\n    background: transparent !important;\n    box-shadow: none !important;\n  }\n\n  .se-locale-btn,\n  .se-topbar .se-person {\n    flex-direction: column !important;\n    align-items: center !important;\n    justify-content: flex-start !important;\n    padding-top: 12px !important;\n  }\n\n  .se-locale-btn {\n    gap: 1px !important;\n  }\n\n  .se-topbar .se-person {\n    gap: 2px !important;\n  }\n\n  .se-search-toggle svg,\n  .se-ticket-quick svg {\n    width: 24px !important;\n    height: 24px !important;\n  }\n\n  .se-topbar .se-person-icon,\n  .se-topbar .se-person-avatar {\n    width: 23px !important;\n    min-width: 23px !important;\n    height: 23px !important;\n    flex: 0 0 23px !important;\n  }\n\n  .se-topbar .se-person-icon {\n    height: 23px !important;\n    min-height: 23px !important;\n    flex-basis: 23px !important;\n  }\n\n  .se-topbar .se-person-icon svg {\n    width: 22px !important;\n    height: 22px !important;\n  }\n\n  .se-topbar .se-person-avatar {\n    border-radius: 7px !important;\n  }\n\n  .se-topbar .se-person-label {\n    display: block !important;\n    max-width: 36px !important;\n    color: currentColor !important;\n    font-size: 8.5px !important;\n    font-weight: 800 !important;\n    line-height: 1 !important;\n    text-align: center !important;\n    white-space: nowrap !important;\n    overflow: hidden !important;\n    text-overflow: clip !important;\n  }\n\n  .se-locale-flag {\n    display: block !important;\n    font-size: 17px !important;\n    line-height: 1 !important;\n    height: 17px !important;\n  }\n\n  .se-locale-code {\n    display: block !important;\n    font-size: 8.5px !important;\n    font-weight: 850 !important;\n    line-height: 1 !important;\n    text-transform: uppercase !important;\n  }\n\n  .se-locale-caret {\n    display: none !important;\n  }\n\n  .se-burger {\n    gap: 5px !important;\n  }\n\n  .se-burger span {\n    width: 21px !important;\n  }\n\n  .se-page > .se-topbar + .se-home-live-hero,\n  .se-page > .se-topbar + .se-content.se-results-page {\n    margin-top: -8px !important;\n  }\n}\n\n@media (max-width: 370px) {\n  .se-header-main-block,\n  .se-header-actions {\n    gap: 3px !important;\n  }\n\n  .se-search-toggle,\n  .se-ticket-quick,\n  .se-locale-btn,\n  .se-topbar .se-person,\n  .se-burger {\n    width: 35px !important;\n    min-width: 35px !important;\n    flex-basis: 35px !important;\n  }\n}\n\n/* Final event card polish: closer to the compact app card typography. */\n.se-event-grid {\n  grid-template-columns: repeat(auto-fill, minmax(190px, 1fr)) !important;\n  gap: 14px !important;\n}\n\n.se-event-card {\n  border-color: #edf0f7 !important;\n  border-radius: 12px !important;\n  padding: 6px !important;\n  box-shadow: 0 8px 18px rgba(27, 37, 89, 0.05) !important;\n}\n\n.se-event-card:hover {\n  transform: translateY(-2px) !important;\n  box-shadow: 0 12px 24px rgba(27, 37, 89, 0.08) !important;\n}\n\n.se-event-card-media {\n  border-radius: 6px !important;\n}\n\n.se-event-card-body {\n  min-height: 98px !important;\n  padding: 8px 2px 2px !important;\n}\n\n.se-event-card-body h3 {\n  display: -webkit-box;\n  margin: 0 !important;\n  color: #1f2430 !important;\n  font-size: 13.5px !important;\n  font-weight: 650 !important;\n  line-height: 1.28 !important;\n  letter-spacing: 0 !important;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.se-event-card-location {\n  margin-top: 5px !important;\n  color: #6b7280 !important;\n  font-size: 11.5px !important;\n  font-weight: 600 !important;\n  line-height: 1.2 !important;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.se-event-card-foot {\n  margin-top: 8px !important;\n  color: #5b8fe8 !important;\n  font-size: 11.5px !important;\n  font-weight: 800 !important;\n  line-height: 1.1 !important;\n}\n\n.se-event-date-badge,\n.se-event-kind-badge {\n  top: 8px !important;\n  padding: 5px 7px !important;\n  font-size: 10px !important;\n  font-weight: 850 !important;\n}\n\n.se-event-date-badge {\n  left: 8px !important;\n}\n\n.se-event-kind-badge {\n  right: 8px !important;\n}\n\n@media (max-width: 760px) {\n  .se-event-grid {\n    gap: 10px !important;\n  }\n\n  .se-event-card {\n    border-radius: 10px !important;\n    padding: 5px !important;\n  }\n\n  .se-event-card-body {\n    min-height: 92px !important;\n    padding-top: 7px !important;\n  }\n\n  .se-event-card-body h3 {\n    font-size: 12.5px !important;\n    line-height: 1.3 !important;\n  }\n\n  .se-event-card-location,\n  .se-event-card-foot {\n    font-size: 10.8px !important;\n  }\n}\n\n/* ------------------------------------------------------------------ app gate */\n/* \"Use the app\" interstitial (AppDownloadModal): slides up over event and\n   ticket pages on every visit. Bottom sheet on phones, centered slide-up\n   dialog on larger screens. */\n.se-appgate-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 5000;\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  background: rgba(15, 23, 42, 0.55);\n  -webkit-backdrop-filter: blur(3px);\n  backdrop-filter: blur(3px);\n  animation: se-appgate-fade 0.22s ease both;\n}\n\n.se-appgate-sheet {\n  position: relative;\n  width: 100%;\n  max-width: 560px;\n  max-height: min(88vh, 88dvh);\n  overflow-y: auto;\n  box-sizing: border-box;\n  background: #fbfcff;\n  color: #172033;\n  border-radius: 22px 22px 0 0;\n  padding: 18px 22px calc(24px + env(safe-area-inset-bottom, 0px));\n  box-shadow: 0 -18px 60px rgba(15, 23, 42, 0.35);\n  text-align: center;\n  animation: se-appgate-rise 0.32s cubic-bezier(0.22, 0.9, 0.3, 1) both;\n  outline: none;\n}\n\n.se-appgate-sheet h2 {\n  margin: 6px 0 0;\n  font-size: 22px;\n  line-height: 1.25;\n  letter-spacing: 0;\n  color: #172033;\n}\n\n.se-appgate-grabber {\n  display: block;\n  width: 44px;\n  height: 5px;\n  margin: 0 auto 14px;\n  border-radius: 999px;\n  background: #d5dae6;\n}\n\n.se-appgate-close {\n  position: absolute;\n  top: 14px;\n  right: 14px;\n  width: 34px;\n  height: 34px;\n  border: 0;\n  border-radius: 50%;\n  background: #eef1f7;\n  color: #4b5568;\n  font-size: 15px;\n  line-height: 1;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.se-appgate-close:hover {\n  background: #e2e7f0;\n}\n\n.se-appgate-badge {\n  width: 68px;\n  height: 68px;\n  margin: 2px auto 10px;\n  border-radius: 18px;\n  overflow: hidden;\n  background: #172033;\n  border: 1px solid rgba(91, 143, 232, 0.18);\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.18);\n}\n\n.se-appgate-badge img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.se-appgate-eyebrow {\n  display: block;\n  width: max-content;\n  max-width: 100%;\n  margin: 0 auto 12px;\n  background: #eaf1ff;\n  border-color: #cddcf9;\n  color: #345fbf;\n}\n\n.se-appgate-text {\n  margin: 10px auto 0;\n  max-width: 44ch;\n  font-size: 14.5px;\n  line-height: 1.55;\n  color: var(--se-muted, #5b6474);\n}\n\n.se-appgate-actions {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  margin-top: 18px;\n}\n\n.se-appgate-primary {\n  width: 100%;\n  max-width: 320px;\n  border: 0;\n  border-radius: 12px;\n  padding: 13px 18px;\n  background: #345fbf;\n  color: #fff;\n  font-size: 15px;\n  font-weight: 800;\n  cursor: pointer;\n  transition: background 0.15s ease, transform 0.06s ease;\n}\n\n.se-appgate-primary:hover {\n  background: #284fa5;\n}\n\n.se-appgate-primary:active {\n  transform: scale(0.98);\n}\n\n.se-appgate-hint {\n  font-size: 12.5px;\n  font-weight: 700;\n  color: #5b6474;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n}\n\n.se-appgate-badges svg {\n  height: 44px;\n}\n\n.se-appgate-ghost {\n  border: 0;\n  background: none;\n  padding: 8px 12px;\n  color: #5b6474;\n  font-size: 13.5px;\n  font-weight: 600;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.se-appgate-ghost:hover {\n  color: #172033;\n}\n\n/* Desktop / laptop: centered dialog card that still slides up into place. */\n@media (min-width: 641px) {\n  .se-appgate-backdrop {\n    align-items: center;\n    padding: 24px;\n  }\n\n  .se-appgate-sheet {\n    max-width: 480px;\n    border-radius: 22px;\n    padding: 26px 30px 30px;\n    box-shadow: 0 28px 80px rgba(15, 23, 42, 0.4);\n  }\n\n  .se-appgate-grabber {\n    display: none;\n  }\n}\n\n@media (max-width: 380px) {\n  .se-appgate-sheet h2 {\n    font-size: 19px;\n  }\n\n  .se-appgate-badges svg {\n    height: 40px;\n  }\n}\n\n@keyframes se-appgate-fade {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes se-appgate-rise {\n  from { transform: translateY(48px); opacity: 0.4; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .se-appgate-backdrop,\n  .se-appgate-sheet {\n    animation: none;\n  }\n}\n\n/* ========================================================== TheBowlingClub */\n/* Landing page /thebowlingclub. Palette from the TheBowlingClub logo\n   (NOT the Main Events brand colors):\n     yellow #ffc400   red #e12e2e   sky-blue #2fa8e1   deep navy #0e1f45 */\n.se-tbc {\n  --tbc-yellow: #ffc400;\n  --tbc-red: #e12e2e;\n  --tbc-blue: #2fa8e1;\n  --tbc-navy: #0e1f45;\n  --tbc-navy-2: #16295e;\n  --tbc-surface: #f4f7fc;\n}\n\n/* hero — dark \"bowling alley\" band with the big logo below the site header */\n.se-tbc-hero {\n  position: relative;\n  overflow: hidden;\n  background:\n    radial-gradient(900px 380px at 15% -10%, rgba(47, 168, 225, 0.35), transparent 60%),\n    radial-gradient(900px 380px at 85% 110%, rgba(225, 46, 46, 0.28), transparent 60%),\n    linear-gradient(160deg, var(--tbc-navy) 0%, var(--tbc-navy-2) 55%, #0a1734 100%);\n  border-bottom: 4px solid var(--tbc-yellow);\n  text-align: center;\n}\n\n/* neon lane stripes, echoing the alley photo in the brochure */\n.se-tbc-hero-glow {\n  position: absolute;\n  inset: 0;\n  background:\n    linear-gradient(105deg, transparent 12%, rgba(47, 168, 225, 0.14) 12.5%, transparent 13.5%),\n    linear-gradient(105deg, transparent 30%, rgba(255, 196, 0, 0.1) 30.5%, transparent 31.5%),\n    linear-gradient(105deg, transparent 82%, rgba(225, 46, 46, 0.14) 82.5%, transparent 83.5%);\n  pointer-events: none;\n}\n\n.se-tbc-hero-inner {\n  position: relative;\n  z-index: 1;\n  max-width: 980px;\n  margin: 0 auto;\n  padding: 56px 24px 60px;\n}\n\n.se-tbc-eyebrow {\n  display: inline-block;\n  font-size: 12px;\n  font-weight: 800;\n  letter-spacing: 1.5px;\n  text-transform: uppercase;\n  color: var(--tbc-yellow);\n  background: rgba(255, 196, 0, 0.12);\n  border: 1px solid rgba(255, 196, 0, 0.45);\n  border-radius: 999px;\n  padding: 5px 14px;\n  margin-bottom: 26px;\n}\n\n/* the \"big image below the header\" — full-width wide logo */\n.se-tbc-hero-logo {\n  display: block;\n  width: min(680px, 92%);\n  height: auto;\n  margin: 0 auto 26px;\n  border-radius: 18px;\n  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.45);\n}\n\n.se-tbc-hero h1 {\n  margin: 0 0 12px;\n  font-size: 40px;\n  line-height: 1.1;\n  letter-spacing: -0.5px;\n  color: #fff;\n}\n\n.se-tbc-hero-sub {\n  margin: 0 auto 26px;\n  max-width: 56ch;\n  font-size: 18px;\n  line-height: 1.55;\n  color: rgba(255, 255, 255, 0.92);\n}\n\n.se-tbc-cta-row {\n  display: flex;\n  justify-content: center;\n  gap: 14px;\n  flex-wrap: wrap;\n}\n\n.se-tbc-cta {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: var(--tbc-red);\n  color: #fff;\n  border-radius: 12px;\n  padding: 13px 24px;\n  font-weight: 800;\n  font-size: 15px;\n  text-decoration: none;\n  box-shadow: 0 8px 22px rgba(225, 46, 46, 0.35);\n  transition: transform 0.12s ease;\n}\n\n.se-tbc-cta:hover {\n  transform: translateY(-1px);\n}\n\n.se-tbc-cta-ghost {\n  background: transparent;\n  border: 2px solid var(--tbc-blue);\n  color: var(--tbc-blue);\n  box-shadow: none;\n}\n\n/* content sections */\n.se-tbc-content.se-content {\n  max-width: 980px;\n}\n\n.se-tbc-section {\n  margin: 40px 0;\n}\n\n.se-tbc .se-tbc-content h2 {\n  color: var(--tbc-navy);\n  border-left: 6px solid var(--tbc-yellow);\n  padding-left: 14px;\n  font-size: 26px;\n  margin: 0 0 16px;\n}\n\n.se-tbc-lead {\n  font-size: 18px;\n  line-height: 1.65;\n}\n\n/* brand strip: Seuytel → Main Events → TheBowlingClub */\n.se-tbc-brands {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 18px;\n  flex-wrap: wrap;\n  padding: 26px 18px;\n  background: var(--tbc-surface);\n  border: 1px solid var(--se-border);\n  border-radius: var(--se-radius);\n}\n\n.se-tbc-brand {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  min-width: 150px;\n}\n\n.se-tbc-brand img {\n  height: 54px;\n  width: auto;\n  max-width: 220px;\n  object-fit: contain;\n}\n\n.se-tbc-brand-link {\n  font-size: 30px;\n  font-weight: 800;\n  color: var(--tbc-blue);\n  line-height: 1;\n}\n\n.se-tbc-brand-caption {\n  text-align: center;\n  color: var(--se-muted);\n  margin: 14px 0 0;\n}\n\n/* about cards */\n.se-tbc-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 18px;\n}\n\n.se-tbc-card {\n  background: #fff;\n  border: 1px solid var(--se-border);\n  border-top: 5px solid var(--tbc-blue);\n  border-radius: var(--se-radius);\n  padding: 22px 24px;\n  box-shadow: var(--se-shadow-sm);\n}\n\n.se-tbc-card + .se-tbc-card,\n.se-tbc-cards .se-tbc-card:nth-child(2) {\n  border-top-color: var(--tbc-red);\n}\n\n.se-tbc-card h3 {\n  margin: 0 0 10px;\n  color: var(--tbc-navy);\n}\n\n/* tournament text + bowler image */\n.se-tbc-split {\n  display: flex;\n  gap: 26px;\n  align-items: flex-start;\n}\n\n.se-tbc-split-img {\n  flex: 0 0 240px;\n  width: 240px;\n  border-radius: var(--se-radius);\n  box-shadow: var(--se-shadow);\n}\n\n/* line-up stat cards (8 / 5 / 3) */\n.se-tbc-lineup {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 18px;\n  margin: 20px 0 24px;\n}\n\n.se-tbc-lineup-card {\n  background: var(--tbc-navy);\n  color: #fff;\n  border-radius: var(--se-radius);\n  padding: 22px 24px;\n  border-top: 6px solid var(--tbc-blue);\n}\n\n.se-tbc-lineup-card.se-tbc-accent-red { border-top-color: var(--tbc-red); }\n.se-tbc-lineup-card.se-tbc-accent-yellow { border-top-color: var(--tbc-yellow); }\n.se-tbc-lineup-card.se-tbc-accent-blue { border-top-color: var(--tbc-blue); }\n\n.se-tbc-lineup-count {\n  display: block;\n  font-size: 44px;\n  font-weight: 900;\n  line-height: 1;\n  margin-bottom: 8px;\n}\n\n.se-tbc-accent-red .se-tbc-lineup-count { color: var(--tbc-red); }\n.se-tbc-accent-yellow .se-tbc-lineup-count { color: var(--tbc-yellow); }\n.se-tbc-accent-blue .se-tbc-lineup-count { color: var(--tbc-blue); }\n\n.se-tbc-lineup-card h3 {\n  margin: 0 0 8px;\n  color: #fff;\n  font-size: 17px;\n}\n\n.se-tbc-lineup-card p {\n  margin: 0;\n  font-size: 14.5px;\n  line-height: 1.55;\n  color: rgba(255, 255, 255, 0.88);\n}\n\n/* sponsoring brochure band */\n.se-tbc-pdf {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n  background: linear-gradient(135deg, var(--tbc-navy) 0%, var(--tbc-navy-2) 100%);\n  border-radius: var(--se-radius);\n  padding: 28px 30px;\n  color: #fff;\n}\n\n.se-tbc-pdf-icon {\n  flex: 0 0 72px;\n  width: 72px;\n  height: 72px;\n}\n\n.se-tbc-pdf-icon svg {\n  width: 100%;\n  height: 100%;\n}\n\n.se-tbc .se-tbc-pdf h2 {\n  color: #fff;\n  border-left-color: var(--tbc-red);\n}\n\n.se-tbc-pdf-body p {\n  color: rgba(255, 255, 255, 0.9);\n  margin: 0 0 16px;\n}\n\n/* contact band */\n.se-tbc-contact {\n  background: var(--tbc-surface);\n  border: 1px solid var(--se-border);\n  border-radius: var(--se-radius);\n  padding: 26px 30px;\n}\n\n.se-tbc-mail-row {\n  display: flex;\n  gap: 14px;\n  flex-wrap: wrap;\n  margin-top: 14px;\n}\n\n.se-tbc-mail {\n  display: inline-flex;\n  flex-direction: column;\n  gap: 2px;\n  background: #fff;\n  border: 1px solid var(--se-border);\n  border-left: 5px solid var(--tbc-blue);\n  border-radius: var(--se-radius-sm);\n  padding: 12px 18px;\n  font-weight: 700;\n  color: var(--tbc-navy);\n  text-decoration: none;\n  box-shadow: var(--se-shadow-sm);\n}\n\n.se-tbc-mail + .se-tbc-mail {\n  border-left-color: var(--tbc-red);\n}\n\n.se-tbc-mail small {\n  font-weight: 500;\n  color: var(--se-muted);\n}\n\n.se-tbc-mail:hover {\n  transform: translateY(-1px);\n}\n\n@media (max-width: 720px) {\n  .se-tbc-hero h1 {\n    font-size: 30px;\n  }\n\n  /* stack the brand logos vertically; the chevron rotates to point down\n     (the \"reversed ^\") and sits below each logo instead of beside it */\n  .se-tbc-brands {\n    flex-direction: column;\n  }\n\n  .se-tbc-brand-link {\n    transform: rotate(90deg);\n  }\n\n  .se-tbc-split {\n    flex-direction: column;\n  }\n\n  .se-tbc-split-img {\n    width: min(280px, 70%);\n    margin: 0 auto;\n  }\n\n  .se-tbc-pdf {\n    flex-direction: column;\n    text-align: center;\n  }\n\n  .se-tbc .se-tbc-pdf h2,\n  .se-tbc .se-tbc-content h2 {\n    border-left: none;\n    padding-left: 0;\n  }\n}\n\n/* ====================================================== Wir die Braunschweiger */\n/* Landing page /we-the-people/wir-die-braunschweiger. Civic, local and social:\n   Braunschweig red/yellow plus Main Events blue/purple as platform accents. */\n.se-wdb {\n  --wdb-ink: #121826;\n  --wdb-muted: #596275;\n  --wdb-red: #d12b2b;\n  --wdb-red-dark: #9f1f1f;\n  --wdb-yellow: #ffc400;\n  --wdb-yellow-soft: #fff5cf;\n  --wdb-blue: var(--se-blue, #5b8fe8);\n  --wdb-purple: var(--se-purple, #6c3dd3);\n  --wdb-paper: #fff9e8;\n  --wdb-soft: #f2f6ff;\n  --wdb-main-grad: linear-gradient(135deg, var(--wdb-blue) 0%, var(--wdb-purple) 100%);\n  background: #fff;\n  color: var(--wdb-ink);\n}\n\n.se-wdb-hero {\n  position: relative;\n  min-height: min(76vh, 760px);\n  display: flex;\n  align-items: center;\n  background-size: cover;\n  background-position: center;\n  border-bottom: 6px solid var(--wdb-yellow);\n  box-shadow: inset 0 -1px 0 rgba(91, 143, 232, 0.38);\n}\n\n.se-wdb-hero-inner {\n  width: min(1040px, calc(100% - 48px));\n  margin: 0 auto;\n  padding: 74px 0 88px;\n  color: var(--wdb-ink);\n}\n\n.se-wdb-eyebrow,\n.se-wdb-kicker {\n  display: inline-flex;\n  align-items: center;\n  width: fit-content;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 900;\n  letter-spacing: 0;\n  text-transform: uppercase;\n}\n\n.se-wdb-eyebrow {\n  margin-bottom: 24px;\n  padding: 7px 14px;\n  background: #fff;\n  border: 1px solid rgba(209, 43, 43, 0.26);\n  color: var(--wdb-red);\n  box-shadow: 0 8px 20px rgba(18, 24, 38, 0.08);\n}\n\n.se-wdb-kicker {\n  margin-bottom: 12px;\n  color: var(--wdb-blue);\n}\n\n.se-wdb-hero h1 {\n  max-width: 780px;\n  margin: 0;\n  color: var(--wdb-ink);\n  font-size: clamp(42px, 7vw, 86px);\n  line-height: 0.96;\n  letter-spacing: 0;\n}\n\n.se-wdb-hero p {\n  max-width: 690px;\n  margin: 24px 0 0;\n  padding: 16px 18px;\n  color: #252d3d;\n  background: rgba(255, 255, 255, 0.9);\n  border: 1px solid rgba(255, 196, 0, 0.52);\n  border-left: 6px solid var(--wdb-yellow);\n  border-radius: 8px;\n  font-size: clamp(18px, 2vw, 23px);\n  line-height: 1.5;\n  box-shadow: 0 16px 36px rgba(18, 24, 38, 0.12);\n}\n\n.se-wdb-cta-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-top: 30px;\n}\n\n.se-wdb-cta {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 48px;\n  padding: 0 22px;\n  border-radius: 8px;\n  border: 2px solid var(--wdb-red);\n  background: linear-gradient(135deg, var(--wdb-red) 0%, var(--wdb-red-dark) 100%);\n  color: #fff;\n  font-size: 15px;\n  font-weight: 900;\n  text-decoration: none;\n  box-shadow: 0 10px 24px rgba(198, 40, 40, 0.24);\n  transition: transform 0.14s ease, background 0.14s ease;\n}\n\n.se-wdb-cta:hover {\n  transform: translateY(-1px);\n  background: linear-gradient(135deg, #b92323 0%, #851818 100%);\n}\n\n.se-wdb-cta-light {\n  border-color: var(--wdb-blue);\n  background: #fff;\n  color: var(--wdb-blue);\n  box-shadow: 0 10px 22px rgba(91, 143, 232, 0.12);\n}\n\n.se-wdb-cta-light:hover {\n  background: #eef4ff;\n}\n\n.se-wdb-content.se-content {\n  max-width: 1080px;\n}\n\n.se-wdb-intro {\n  display: grid;\n  grid-template-columns: minmax(250px, 0.8fr) minmax(280px, 1.2fr);\n  gap: 36px;\n  align-items: start;\n  padding: 46px 0 24px;\n}\n\n.se-wdb h2 {\n  margin: 0;\n  color: var(--wdb-ink);\n  font-size: clamp(26px, 4vw, 42px);\n  line-height: 1.08;\n  letter-spacing: 0;\n}\n\n.se-wdb h3 {\n  margin: 0;\n  color: var(--wdb-ink);\n  font-size: 18px;\n  line-height: 1.25;\n}\n\n.se-wdb p {\n  color: var(--wdb-muted);\n  line-height: 1.68;\n}\n\n.se-wdb-intro p {\n  margin: 0;\n  font-size: 17px;\n}\n\n.se-wdb-band {\n  display: grid;\n  grid-template-columns: minmax(280px, 0.92fr) minmax(300px, 1.08fr);\n  gap: 28px;\n  align-items: stretch;\n  margin: 34px 0 52px;\n  background: var(--wdb-paper);\n  border: 1px solid #f0dfb8;\n  border-left: 8px solid var(--wdb-yellow);\n  border-top: 1px solid rgba(91, 143, 232, 0.2);\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.se-wdb-band-text {\n  padding: 34px;\n}\n\n.se-wdb-band-text p {\n  margin-bottom: 0;\n}\n\n.se-wdb-band img,\n.se-wdb-image-row img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.se-wdb-section {\n  margin: 54px 0;\n}\n\n.se-wdb-section-head {\n  max-width: 760px;\n  margin-bottom: 22px;\n}\n\n.se-wdb-format-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 14px;\n}\n\n.se-wdb-card {\n  min-height: 190px;\n  background: #fff;\n  border: 1px solid var(--se-border);\n  border-top: 5px solid var(--wdb-blue);\n  border-radius: 8px;\n  padding: 22px;\n  box-shadow: var(--se-shadow-sm);\n}\n\n.se-wdb-card:nth-child(2n) {\n  border-top-color: var(--wdb-red);\n}\n\n.se-wdb-card:nth-child(3n) {\n  border-top-color: var(--wdb-yellow);\n}\n\n.se-wdb-card:nth-child(4n) {\n  border-top-color: var(--wdb-purple);\n}\n\n.se-wdb-card p {\n  margin: 10px 0 0;\n  font-size: 14.5px;\n}\n\n.se-wdb-image-row {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 18px;\n  margin: 46px 0;\n}\n\n.se-wdb-image-row figure {\n  margin: 0;\n  overflow: hidden;\n  background: #fff;\n  border-radius: 8px;\n  border: 1px solid var(--se-border);\n  box-shadow: var(--se-shadow-sm);\n}\n\n.se-wdb-image-row img {\n  aspect-ratio: 16 / 10;\n}\n\n.se-wdb-image-row figcaption {\n  padding: 14px 16px 16px;\n  color: var(--wdb-muted);\n  font-size: 14px;\n  line-height: 1.45;\n}\n\n.se-wdb-principles {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));\n  gap: 12px;\n}\n\n.se-wdb-principle {\n  background: var(--wdb-soft);\n  border: 1px solid #dce7fb;\n  border-left: 5px solid var(--wdb-blue);\n  border-radius: 8px;\n  padding: 18px;\n  color: #273c66;\n  font-weight: 750;\n  line-height: 1.45;\n}\n\n.se-wdb-program {\n  display: grid;\n  grid-template-columns: minmax(260px, 0.82fr) minmax(320px, 1.18fr);\n  gap: 30px;\n  align-items: start;\n  margin: 60px 0;\n  padding: 34px;\n  background:\n    linear-gradient(135deg, rgba(91, 143, 232, 0.18), rgba(108, 61, 211, 0.14)),\n    #142033;\n  border-top: 5px solid var(--wdb-red);\n  border-bottom: 5px solid var(--wdb-yellow);\n  border-radius: 8px;\n}\n\n.se-wdb-program h2,\n.se-wdb-program h3 {\n  color: #fff;\n}\n\n.se-wdb-program .se-wdb-kicker {\n  color: #f6c84f;\n}\n\n.se-wdb-program p {\n  color: rgba(255, 255, 255, 0.78);\n}\n\n.se-wdb-steps {\n  display: grid;\n  gap: 12px;\n}\n\n.se-wdb-step {\n  display: grid;\n  grid-template-columns: 54px 1fr;\n  gap: 12px 16px;\n  padding: 18px;\n  background: rgba(255, 255, 255, 0.07);\n  border: 1px solid rgba(255, 196, 0, 0.18);\n  border-radius: 8px;\n}\n\n.se-wdb-step span {\n  grid-row: span 2;\n  color: var(--wdb-yellow);\n  font-size: 24px;\n  font-weight: 950;\n}\n\n.se-wdb-step p {\n  margin: 2px 0 0;\n  font-size: 14px;\n}\n\n.se-wdb-audiences {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.se-wdb-audiences span {\n  display: inline-flex;\n  align-items: center;\n  min-height: 38px;\n  padding: 0 14px;\n  border-radius: 999px;\n  background: var(--wdb-yellow-soft);\n  border: 1px solid #f0d18a;\n  color: #744800;\n  font-weight: 850;\n  font-size: 14px;\n}\n\n.se-wdb-hosts {\n  box-sizing: border-box;\n  display: flex;\n  gap: 24px;\n  align-items: center;\n  justify-content: space-between;\n  margin: 60px 0 34px;\n  padding: 30px;\n  background:\n    linear-gradient(135deg, rgba(255, 196, 0, 0.16) 0%, rgba(91, 143, 232, 0.14) 55%, rgba(108, 61, 211, 0.1) 100%),\n    #fff;\n  border: 1px solid #d9e4f8;\n  border-left: 8px solid var(--wdb-red);\n  border-radius: 8px;\n}\n\n.se-wdb-hosts-cta {\n  box-sizing: border-box;\n  flex: 0 1 240px;\n  min-width: 190px;\n  max-width: 260px;\n  align-self: center;\n  border-color: #173f7f;\n  background: #173f7f;\n  color: #ffffff;\n  text-align: center;\n  white-space: normal;\n  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.32);\n  box-shadow: 0 12px 26px rgba(23, 63, 127, 0.3);\n}\n\n.se-wdb-hosts-cta:hover {\n  border-color: #123366;\n  background: #123366;\n  color: #ffffff;\n}\n\n.se-wdb-hosts-cta:visited,\n.se-wdb-hosts-cta:focus,\n.se-wdb-hosts-cta:active {\n  color: #ffffff;\n}\n\n.se-wdb-hosts > div {\n  max-width: 720px;\n}\n\n.se-wdb-hosts p {\n  margin-bottom: 0;\n}\n\n.se-wdb-credit {\n  margin: 20px 0 52px;\n  border-top: 1px solid var(--se-border);\n  padding-top: 14px;\n}\n\n.se-wdb-credit p {\n  margin: 0;\n  font-size: 12px;\n  color: #7a8290;\n}\n\n@media (max-width: 760px) {\n  .se-wdb-hero {\n    min-height: 70vh;\n    background-position: center;\n  }\n\n  .se-wdb-hero-inner {\n    width: min(100% - 32px, 1040px);\n    padding: 56px 0 66px;\n  }\n\n  .se-wdb-cta {\n    width: 100%;\n  }\n\n  .se-wdb-intro,\n  .se-wdb-band,\n  .se-wdb-image-row,\n  .se-wdb-program {\n    grid-template-columns: 1fr;\n  }\n\n  .se-wdb-band img {\n    min-height: 260px;\n  }\n\n  .se-wdb-band-text,\n  .se-wdb-program {\n    padding: 24px;\n  }\n\n  .se-wdb-card {\n    min-height: auto;\n  }\n\n  .se-wdb-hosts {\n    align-items: stretch;\n    flex-direction: column;\n    padding: 24px;\n  }\n\n  .se-wdb-hosts-cta {\n    width: 100%;\n    max-width: none;\n    min-width: 0;\n    flex-basis: auto;\n    align-self: stretch;\n    padding-left: 14px;\n    padding-right: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
